  <template>
  <div class="order">
    <template>
    <div class="order-header">
      <div class="order-no notMobile">
        <div v-if="order.exception_list && order.exception_list.length" style="display:inline-block;">
          <template v-for="(ex,index) in order.exception_list">
            <template v-if="['地址变更','商品变更','尺码变更'].indexOf(ex.type_name)==-1">
              <label :title="getTitle(ex,true)" class="exception-label" :class="{'close':ex.status==2,'tips':ex.category==2 || ex.category==3,'noti':ex.category==4}" @click="showException(index)">
                {{ getTitle(ex) }}
                <div v-if="isLastFromUser(ex)" style="position:absolute;right:-4px;top:1px;background:#ff4650;width:10px;height:10px;border-radius: 50%;"></div>
              </label>
              <label v-if="index<order.exception_list.length-1">
                |
              </label>
            </template>
          </template>
        </div>
        <el-popover
            placement="bottom"
            width="280"
            trigger="hover">
            <p v-if="isSingle" class="clearfix" style="margin-top: 5px;">
              <span style="display:inline-block;margin-right:5px;">
                任务来源:
              </span>
              <span style="display:inline-block;width:160px;word-break:break-all;">
                {{ displaySource(order.source) }}{{ order.app_version?' '+order.app_version:'' }}
              </span>
            </p>
            <p v-if="isSingle" class="clearfix" style="margin-top: 5px;">
              <span style="display:inline-block;margin-right:5px;">
                手机型号:
              </span>
              <span style="display:inline-block;width:160px;word-break:break-all;">
                {{order.device_marketing_name}}
              </span>
            </p>
            <p v-if="isSingle" class="clearfix" style="margin-top: 5px;">
              <span style="display:inline-block;margin-right:5px;">
                支付方式:
              </span>
              <span style="display:inline-block;width:160px;word-break:break-all;">
                {{getPayMethod(order.payment_type)}}
              </span>
            </p>
            <p v-if="isSingle" class="clearfix" style="margin-top: 5px;">
              <span style="display:inline-block;margin-right:5px;">
                模式:
              </span>
              <span style="display:inline-block;width:160px;word-break:break-all;">
                {{order.service_type == 1? '下单':'下单+转运'}}{{order.type == 2 ? '/ 帮我找货':''}}
              </span>
            </p>
            <p v-if="isSingle && order.business_order_no" class="clearfix" style="margin-top: 5px;display:flex">
              <span style="display:inline-block;margin-right:5px;">
                商家订单:
              </span>
              <span style="display:inline-block">
                <span v-for="n in order.business_order_no.split('|')" style="display:block">
                  {{  n  }}
                </span>
              </span>
            </p>
            <p v-if="isSingle && order.merchant_account" class="clearfix" style="margin-top: 5px;display:flex">
              <span style="display:inline-block;margin-right:5px;">
                下单账号:
              </span>
              <span style="display:inline-block">
                <span v-for="n in order.merchant_account.split('|')" style="display:block">
                  {{  n  }}
                </span>
              </span>
            </p>
            <p v-if="isSingle && order.buyer_delegate_username" class="clearfix" style="margin-top: 5px;">
              <span style="display:inline-block;margin-right:5px;">
                下单委托:
              </span>
              <span style="display:inline-block;width:160px;word-break:break-all;">
                {{order.buyer_delegate_username}}
              </span>
            </p>
            <p v-if="isSingle && order.business_shipping_username" class="clearfix" style="margin-top: 5px;">
              <span style="display:inline-block;margin-right:5px;">
                商家物流委托:
              </span>
              <span>
                {{order.business_shipping_username}}
              </span>
            </p>
            <p v-if="isSingle && order.transport_shipping_username" class="clearfix" style="margin-top: 5px;">
              <span style="display:inline-block;margin-right:5px;">
                转运物流委托:
              </span>
              <span>
                {{order.transport_shipping_username}}
              </span>
            </p>
            <p v-if="isSingle && order.buyer.email" class="clearfix" style="margin-top: 5px;">
              <span style="display:inline-block;margin-right:5px;">
                联系邮箱:
              </span>
              <span style="display:inline-block;width:160px;word-break:break-all;">
                {{order.buyer.email}}
              </span>
            </p>
            <p style="margin-top: 5px;">
              <span style="display:inline-block;margin-right:5px;">
                缺货处理:
              </span>
              <span style="display:inline-block;word-break:break-all;">
                {{order.stockout_deal_info?order.stockout_deal_info.name:''}}
              </span>
            </p>
            <div v-if="order.realRemark" style="margin-top: 5px;word-break: break-word;">
              <p>
                备注<span v-if="order.realRemark" style="position:relative;margin-left:3px;">
                  <i class="el-icon-chat-square" style="color:#000;"></i>
                  <div style="position:absolute;right:-4px;top:1px;background:#ff4650;width:10px;height:10px;border-radius: 50%;"></div>
                </span>
              </p>
              <p style="margin-top: 5px;">
                {{order.realRemark}}
              </p>
            </div>
            <!--<p  >
              <span style="display:inline-block;">备注：</span>
              <span style="display:inline-block;width:140px;">{{order.realRemark}}</span>
            </p>-->
            <!--<p  class="clearfix" style="margin-top: 5px;">
              <span style="display:inline-block;" v-if="order.support_transport_service == '1'">无需下单人提供转运服务</span>
              <span style="display:inline-block;" v-if="order.support_transport_service == '2'">需下单人提供转运服务</span>
            </p>-->
            <a class="order_no" slot="reference">
              <span v-if="order.realRemark" style="position:relative;">
                <i class="el-icon-chat-square" style="color:#000;"></i>
                <div style="position:absolute;right:0px;top:1px;background:#ff4650;width:10px;height:10px;border-radius: 50%;"></div>
              </span>
              {{order.order_no}}
            </a>
        </el-popover>
        <span v-if="!trackTask">
          <el-popover
            placement="bottom"
            trigger="hover" class="copyPopover">
            <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="begin()" v-if="order.status == 13 && isSingle && maishouenable && order.noNeedPaid">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">开始下单</span>
            </p>
            <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="take_by_single()" v-if="order.status == 11 && isSingle && maishouenable">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">确认接单</span>
            </p>
            <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showUploadOrder()" v-if="order.type == 2 && order.status == 14 && order.noNeedPaid && isSingle && (maishouenable || order.buyer_delegate_account_id==account_id)">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">上传下单信息</span>
            </p>
            <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="editOrder()" v-if="order.status == 12&&isSingle && maishouenable">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">修改任务</span>
            </p>
            <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showChangeAddress()" v-if="['11'].indexOf(order.status) > -1&&!isSingle && (role!=3 || maishouenable)">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">修改地址</span>
            </p>
            <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showOrderCancel()" v-if="['11', '13'].indexOf(order.status) > -1&&!isSingle && (role!=3 || maishouenable)">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">取消任务</span>
            </p>
            <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showOrderCancel()" v-if="['11', '12','13','14'].indexOf(order.status) > -1&&isSingle && (maishouenable || order.business_shipping_account_id==account_id)">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">取消任务</span>
            </p>
            <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showExpress()" v-if="order.type == 2 && order.status == 15 && (role==2 || maishouenable || order.business_shipping_account_id==account_id || order.buyer_delegate_account_id==account_id)">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">上传商家物流</span>
            </p>
            <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showProductCancel()" v-if="order.type == 2 && order.status != 20 && order.status != 12 && order.status != 11&&order.status!=30&& (maishouenable || order.business_shipping_account_id==account_id) &&order.type==0&&order.status!=16">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">取消商品</span>
            </p>
            <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showProductCancel()" v-if="order.type == 2 && order.status != 20 && order.status != 12 && order.status != 11&&order.status!=30&&isSingle && (maishouenable || order.business_shipping_account_id==account_id) &&order.type==2&&order.status!=16">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">取消商品</span>
            </p>
            <!--<p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showProductCancel()">
              <img src="../../../assets/images/copy.png" class="copy" alt="">
              <span style="font-size:14px;">取消商品</span>
            </p>-->
            <!--<p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showOrderVoucher()" v-if="order.status==15||order.status==16||order.status==20 || order.type == 2">
              <img src="../../../assets/images/copy.png" class="copy" alt="">
              <span style="font-size:14px;">下单凭证</span>
            </p>-->
            <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showOrderVoucher()">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">下单凭证</span>
            </p>
            <!--<p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="assignBuyerVisible=true">
              <img src="../../../assets/images/copy.png" class="copy" alt="">
              <span style="font-size:14px;">分配买手</span>
            </p>-->
            <!--<p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="copyOrder()" v-if="order.type!=2 && ((isSingle && order.single_account_id==account_id) || (!isSingle))">
              <img src="../../../assets/images/copy.png" class="copy" alt="">
              <span style="font-size:14px;">复制任务</span>
            </p>-->
            <!--<p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="openTrack()" v-if="order.status == 16&& (role==1 || order.single_account_id==account_id || order.business_shipping_account_id==account_id)">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">小程序跟踪任务</span>
            </p> 20230530 sally要求隐藏此菜单-->
            <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showModifyOrder(true)" v-if="(isShowModifyOrdeInfo()) && isSingle && (maishouenable || order.business_shipping_account_id==account_id || order.buyer_delegate_account_id==account_id)">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">修改下单信息</span>
            </p>
            <p  class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showModifyDelegate" v-if="order.status != 30 && isSingle && maishouenable">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">修改委托</span>
            </p>
            <p  class="clearfix" style="cursor:pointer;margin-top:5px;" @click="callbackOrderEx" v-if="order.type == 2 && (order.status == 14 || order.status == 15) && isSingle && (role!=3 || maishouenable || order.buyer_delegate_account_id==account_id)">
                <i class="el-icon-news"></i>
                <span style="font-size:14px;">撤回到待下单</span>
              </p>
              <p  class="clearfix" style="cursor:pointer;margin-top:5px;" @click="callbackPackage" v-if="order.type == 2 && isShowCallbackPackage() && isSingle && (role!=3 || maishouenable)">
                <i class="el-icon-news"></i>
                <span style="font-size:14px;">撤回发货</span>
              </p>
              <p  class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showPackageCancel" v-if="isShowCallbackPackage1() && (role!=3 || maishouenable)">
                <i class="el-icon-news"></i>
                <span style="font-size:14px;">发起退货</span>
              </p>
              <p  class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showFeePromotion" v-if="order.status != 30 && isSingle && maishouenable">
                <i class="el-icon-news"></i>
                <span style="font-size:14px;">减免服务费</span>
              </p>
              <p  class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showAfterSale" v-if="order.status != 30 && isSingle && maishouenable">
                <i class="el-icon-news"></i>
                <span style="font-size:14px;">售后退款</span>
              </p>
              <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showAddException()" v-if="isSingle && ( role==2 || maishouenable || order.buyer_delegate_account_id==account_id || order.business_shipping_account_id==account_id || order.transport_shipping_account_id==account_id)">
                <i class="el-icon-news"></i>
                <span style="font-size:14px;">新增异常/提示</span>
              </p>
              <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showAddTicket()" v-if="isSingle && ( role==2 || maishouenable || order.buyer_delegate_account_id==account_id || order.business_shipping_account_id==account_id || order.transport_shipping_account_id==account_id)">
                <i class="el-icon-news"></i>
                <span style="font-size:14px;">新增工单</span>
              </p>
             <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showAddAmountBill()" v-if="isSingle && ( role==2 || maishouenable || order.buyer_delegate_account_id==account_id || order.business_shipping_account_id==account_id || order.transport_shipping_account_id==account_id)">
                <i class="el-icon-news"></i>
                <span style="font-size:14px;">新增账单</span>
              </p>
            <p class="clearfix" style="cursor:pointer;margin-top:5px;" @click="showOrderLog()" v-if="isSingle">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">任务日志</span>
            </p>
            <span v-show="showHead" slot="reference" class="moreIcon"><i class="el-icon-more"></i></span>
          </el-popover>
        </span>
        <!--<span v-if="!trackTask && role==3">
          <el-popover
            placement="bottom"
            trigger="hover" class="copyPopover">
            <p class="clearfix" style="cursor:pointer;" @click="showOrderVoucher()">
              <i class="el-icon-news"></i>
              <span style="font-size:14px;">下单凭证</span>
            </p>
            <span slot="reference" class="moreIcon"><i class="el-icon-more"></i></span>
          </el-popover>
        </span>-->
        <p>
          <el-popover v-if="order.remark"
            placement="bottom"
            trigger="hover">
            <p>{{order.iconTitle}}</p>
            <a slot="reference"><i class="iconfont joyorderIcon" :class="{'el-icon-joyorder26 taobao':order.remark.indexOf('淘宝下单')==0,'el-icon-joyorderweixin':order.remark.indexOf('微信下单')==0}"/></a>
          </el-popover>
          <span @click="showOrderDelegate()" v-if="showDelegateText">
            <label style="cursor:pointer;">{{ order.buyer_delegate_account_id && order.buyer_delegate_account_id!='0' && order.transport_shipping_account_id == order.buyer_delegate_account_id?`${order.buyer_delegate_username}下单&转运`:(order.buyer_delegate_username?order.buyer_delegate_username+'下单':'下单委托') }}</label> |
          </span>
          <span v-if="order.buyer_delegate_username|| order.single_username" @click="searchBuyer('2')">
            <label class="search_tag">{{ order.buyer_delegate_username|| order.single_username }}</label> |
          </span>
          <span v-if="order.conditions.single_id > 0 && !isSingle">
            {{order.conditions.single_name}}
            <!-- <i class="ico ico-chat-enable pointer" v-if="!trackTask" v-bind:class="{gray: nim.accountOnlineStates.indexOf(`${env}-user-${order.conditions.single_id}`) === -1}" @click="selectChat(order.conditions.single_id)"></i> -->
            <!-- <ChatContainer :fromNick="order.conditions.single_name" class="chat-component" v-if="currentOrder.id == order.id && !trackTask" :toAccountId="order.conditions.single_id" pageType="detail"></ChatContainer> -->
          </span>
          <span class="search_tag" v-if="order.buyer_account_id > 0 && isSingle" @click="searchBuyer('5')">
            {{order.buyer.username}}
            <!-- <i class="ico ico-chat-enable pointer" v-if="!trackTask" v-bind:class="{gray: nim.accountOnlineStates.indexOf(`${env}-user-${order.buyer_account_id}`) === -1}" @click="selectChat(order.buyer_account_id)"></i> -->
            <!-- <ChatContainer :fromNick="order.conditions.buyer_name" class="chat-component" v-if="currentOrder.id == order.id && !trackTask" :toAccountId="order.buyer_account_id" pageType="detail"></ChatContainer> -->
          </span>
          <span style="color: #333;" v-if="order.conditions.single_id <= 0 && !isSingle">未指定下单人</span>
          <span style="color: #333;" v-if="order.buyer_account_id <= 0 && isSingle">未指定买单人</span>
        </p>
      </div>
      <ul class="clearfix notMobile">
        <li class="business-name">
          <span>商家</span>
          <p><a :href="order.website" target="_blank">{{order.business_name}}</a></p>
        </li>
        <li>
          <span style="font-size:13px;">{{ createtimedisplay }}</span>
          <p>{{order.create_time?order.create_time.split(' ')[1]:''}}</p>
        </li>
        <li style="position: relative;">
          <span>金额</span>
          <p>
            <el-popover
              placement="bottom"
              width="230"
              trigger="hover">
              <ul class="popover-price" v-if="real_price_info">
                <li><span>商品</span><del v-if="real_price_info.original_goods_price && real_price_info.original_goods_price.value != real_price_info.goods_price.value">{{real_price_info.original_goods_price.currency_symbol}}{{real_price_info.original_goods_price.value}}</del> {{real_price_info.goods_price.currency_symbol}}{{real_price_info.goods_price.value}}</li>
                <!--<li>
                    <span></span>
                    <label style="color:#07c160"><i class="el-icon-check"></i>
                      满100减20,-{{ order.currency_symbol }}1.00
                    </label>
                  </li>-->
                <li><span>消费税</span><del v-if="real_price_info.original_tax_price && real_price_info.original_tax_price.value != real_price_info.tax_price.value">{{real_price_info.original_tax_price.currency_symbol}}{{real_price_info.original_tax_price.value}}</del> {{real_price_info.tax_price.currency_symbol}}{{real_price_info.tax_price.value}}</li>
                <li><span>商家运费</span><del v-if="real_price_info.original_transport_price && real_price_info.original_transport_price.value != real_price_info.transport_price.value">{{real_price_info.original_transport_price.currency_symbol}}{{real_price_info.original_transport_price.value}}</del> {{real_price_info.transport_price.currency_symbol}}{{real_price_info.transport_price.value}}</li>
                <li><span>其他费用</span><del v-if="real_price_info.original_other_price && real_price_info.original_other_price.value != real_price_info.other_price.value">{{real_price_info.original_other_price.currency_symbol}}{{real_price_info.original_other_price.value}}</del> {{real_price_info.other_price.currency_symbol}}{{real_price_info.other_price.value}}</li>
                <li><span>商家小计({{ real_price_info.original_subtotal_price.currency }})</span><del v-if="real_price_info.original_subtotal_price && real_price_info.original_subtotal_price.value != real_price_info.subtotal_price.value">{{real_price_info.original_subtotal_price.currency_symbol}}{{real_price_info.original_subtotal_price.value}}</del> {{real_price_info.subtotal_price.currency_symbol}}{{real_price_info.subtotal_price.value}}</li>
                <!--<li><span>优惠码</span> {{order.joyorders_promo_code}}</li>-->
                <template v-if="normal_address_show || !isSingle">
                  <hr class="line">
                  <li><span>服务费({{ real_price_info.original_service_price.currency }})</span><del v-if="real_price_info.original_service_price && real_price_info.original_service_price.value != real_price_info.service_price.value">{{real_price_info.original_service_price.currency_symbol}}{{real_price_info.original_service_price.value}}</del> {{real_price_info.service_price.currency_symbol}}{{real_price_info.service_price.value}}</li>
                  <li v-if="real_price_info.discount_price && real_price_info.original_discount_price && (real_price_info.discount_price.value!='0.00' || real_price_info.original_discount_price.value!='0.00')">
                    <span>下单优惠</span>
                    <del v-if="real_price_info.original_discount_price.value != real_price_info.discount_price.value">-{{real_price_info.original_discount_price.currency_symbol}}{{real_price_info.original_discount_price.value}}</del> -{{real_price_info.discount_price.currency_symbol}}{{real_price_info.discount_price.value}}
                  </li>
                  <li v-if="discount_rule.discount_price">
                    <div class="promo_code" v-if="order.joyorders_promo_code">{{order.joyorders_promo_code}}</div>
                    <div>{{discount_rule.discount_price}}</div>
                  </li>
                  <li v-if="discount_rule.buyer_service_fee">
                    <div class="promo_code" v-if="order.joyorders_promo_code">{{order.joyorders_promo_code}}</div>
                    <div>{{discount_rule.buyer_service_fee}}</div>
                  </li>
                  <hr class="line">
                  <li v-show="order.service_type==2"><span>国际运费</span><del v-if="real_price_info.original_international_transport_price && real_price_info.international_transport_price.value != real_price_info.original_international_transport_price.value">{{original_international_transport_price_text}}</del> {{international_transport_price_text}}</li>
                  <li v-if="real_price_info.signed_after_sales_refund && real_price_info.signed_after_sales_refund.value!='0.00'"><span>售后退款</span>
                    {{ (+real_price_info.signed_after_sales_refund.value)<0?'-':'' }}{{real_price_info.signed_after_sales_refund.currency_symbol}}{{real_price_info.signed_after_sales_refund.value.replace('-','')}}
                  </li>
                  <li v-if="real_price_info.after_sales_service_fee && real_price_info.after_sales_service_fee.value!='0.00'"><span>售后服务费</span>
                    {{real_price_info.after_sales_service_fee.currency_symbol}}{{real_price_info.after_sales_service_fee.value}}
                  </li>
                  <li><span>实时汇率</span>{{$decimalFormat(real_price_info.rate,4)}}</li>
                  <li><span>总计</span><del v-if="real_price_info.original_total_price && real_price_info.original_total_price.value != real_price_info.total_price.value">{{real_price_info.original_total_price.currency_symbol}}{{real_price_info.original_total_price.value}}</del> {{real_price_info.total_price.currency_symbol}}{{real_price_info.total_price.value}}</li>
                  <li v-if="real_price_info.payment_price"><span>{{real_price_info.payment_status=='待支付'?'少':'多'}}</span> {{real_price_info.payment_price.currency_symbol}}{{real_price_info.payment_price.value}}</li>
                  <li v-if="real_price_info.paying_amount && real_price_info.paying_amount.value!='0.00'"><span>支付中</span>
                    {{real_price_info.paying_amount.currency_symbol}}{{real_price_info.paying_amount.value}}
                  </li>
                  <li v-if="real_price_info.refunding_amount && real_price_info.refunding_amount.value!='0.00'"><span>退款中</span>
                    {{real_price_info.refunding_amount.currency_symbol}}{{real_price_info.refunding_amount.value}}
                  </li>
                  <li v-if="(maishouenable || order.transport_shipping_account_id==account_id || role==2) && isSingle && order.status != '30' && order.status != '20'" style="margin-top:10px;">
                    <el-button type="primary" class="block btn-14" @click="openModify('修改费用')">修改费用</el-button>
                  </li>
                  <li v-if="isSingle && order.status == '30' && (role!=3 || maishouenable) && showRefundTip" style="margin-top:10px;">
                    <el-button type="primary" class="block btn-14" @click="openModify('退款')">退款</el-button>
                  </li>
                </template>
                <template v-else>
                  <li><span>实时汇率</span>{{$decimalFormat(real_price_info.rate,4)}}</li>
                  <li><span>商家小计（CNY）</span><del v-if="real_price_info.original_subtotal_price_rmb && real_price_info.original_subtotal_price_rmb.value != real_price_info.subtotal_price_rmb.value">{{real_price_info.original_subtotal_price_rmb.currency_symbol}}{{real_price_info.original_subtotal_price_rmb.value}}</del> {{real_price_info.subtotal_price_rmb.currency_symbol}}{{real_price_info.subtotal_price_rmb.value}}</li>
                </template>
              </ul>
              <a slot="reference">
                <template v-if="normal_address_show">
                  {{real_price_info?real_price_info.subtotal_price.currency_symbol:order.price_info.subtotal_price.currency_symbol}}{{real_price_info?real_price_info.subtotal_price.value:order.price_info.subtotal_price.value}}
                  |
                  {{real_price_info?real_price_info.total_price.currency_symbol:order.price_info.total_price.currency_symbol}}{{real_price_info?real_price_info.total_price.value:order.price_info.total_price.value}}<span v-loading="isrefetching"></span><i v-if="!isrefetching" class="el-icon-caret-bottom"></i>
                </template>
                <template v-else>
                  {{real_price_info?real_price_info.subtotal_price.currency_symbol:order.price_info.subtotal_price.currency_symbol}}{{real_price_info?real_price_info.subtotal_price.value:order.price_info.subtotal_price.value}}
                  {{real_price_info?'|'+real_price_info.subtotal_price_rmb.currency_symbol+''+real_price_info.subtotal_price_rmb.value:''}}<span v-loading="isrefetching"></span><i v-if="!isrefetching" class="el-icon-caret-bottom"></i>
                </template>
              </a>
            </el-popover>
          </p>
          <div class="offlineLabel" v-if="order.offline_payment == '1'">私下支付</div>
          <!--<div v-if="order.status != 12 && order.status != 30 && order.status != 20 && order.fee_adjustment_list.length > 0 && order.offline_payment != '1'">
            <div class="unpaidlineLabel" v-if="order.fee_adjustment_list[0].status=='0'">
              <div >待支付</div>
            </div>
          </div>-->
          <div v-if="real_price_info" class="unpaidline">
            <div class="unpaidlineLabel" v-if="real_price_info && real_price_info.payment_price && real_price_info.payment_price.value!='0.00'">
              <div>{{real_price_info.payment_status=='待支付'?'少':'多'}} {{real_price_info.payment_price.currency_symbol}}{{real_price_info.payment_price.value}}</div>
            </div>
            <div class="unpaidlineLabel" v-if="real_price_info.paying_amount && real_price_info.paying_amount.value!='0.00'">
              <div>支付中 {{real_price_info.paying_amount.currency_symbol}}{{real_price_info.paying_amount.value}}</div>
            </div>
            <div class="unpaidlineLabel" v-if="real_price_info.refunding_amount && real_price_info.refunding_amount.value!='0.00'">
              <div>退款中 {{real_price_info.refunding_amount.currency_symbol}}{{real_price_info.refunding_amount.value}}</div>
            </div>
            <div class="unpaidlineLabel miniprogram" v-if="(order.fee_adjustment_list[0] && order.fee_adjustment_list[0].status == 0) || order.status == 12">
              <div>{{ real_price_info.international_transport_price.charge_type==1?'实收':'' }}待支付 ¥{{order.fee_adjustment_list[0]?order.fee_adjustment_list[0].unpaid_fee_rmb:order.rmb_total_amount}}</div>
            </div>
            <div class="unpaidlineLabel alreadypaid" v-if="order.status!=30 && (real_price_info.international_transport_price.charge_type==1 && order.fee_adjustment_list[0] && order.fee_adjustment_list[0].status == 1)">
              <div>实收 ¥{{ real_price_info.international_transport_price.value }}</div>
            </div>
            <div class="unpaidlineLabel waitingcacu" v-if="order.service_type==2 && order.status!=30 && (real_price_info.international_transport_price.charge_type==1 && order.fee_adjustment_list.length==0)">
              <div>实收待计算</div>
            </div>
            <div class="unpaidlineLabel exception" v-if="validate_price_message_title">
              <div>{{ validate_price_message_title }}有异常</div>
            </div>
          </div>
        </li>
        <li>
          <span>寄至<label style="margin-left:3px;font-size:10px;color:black;" v-if="single_type==1 && totalAccountList.length==1">{{ totalAccountList[0].account_name }}</label></span>
          <div style="display:flex;align-items: center;">
            <p class="popover_p" :class="addressStatusClass">
              <template>
                <el-popover
                  placement="bottom"
                  trigger="hover">
                  <template v-if="normal_address_show || order.service_type!=2 || !isSingle">
                    <div class="copyTxt" :class="{copyTxtSuccess:copyTxtSuccess}"
                    v-if="order.address.country != '中国大陆(CN)'"
                    v-clipboard:copy="order.address.county?order.address.first_name+' '+order.address.last_name+' '+order.address.address1+' '+order.address.address2+' '+order.address.county+','+order.address.city+','+order.address.province+' '+order.address.zip_code+' '+order.address.mobile:order.address.first_name+' '+order.address.last_name+' '+order.address.address1+' '+order.address.address2+' '+order.address.city+','+order.address.province+' '+order.address.zip_code+' '+order.address.mobile"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError">
                    <i v-if="!copyTxtSuccess" class="el-icon-news"></i> {{copyTxtSuccess?'已复制':'复制'}}
                    </div>
                    <div class="copyTxt" :class="{copyTxtSuccess:copyTxtSuccess}"
                    v-if="order.address.country == '中国大陆(CN)'"
                    v-clipboard:copy="order.address.county?(order.id_card_id!=0?order.id_card_info.name:order.address.last_name+order.address.first_name)+' '+order.address.mobile+' '+order.address.province+order.address.city+order.address.county+' '+order.address.address1+' '+order.address.address2+' '+(order.address.zip_code?'邮编:'+order.address.zip_code:''):order.address.last_name+order.address.first_name+' '+order.address.mobile+' '+order.address.province+order.address.city+order.address.county+' '+order.address.address1+' '+(order.address.zip_code?'邮编:'+order.address.zip_code:'')"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError">
                    <i v-if="!copyTxtSuccess" class="el-icon-news"></i> {{copyTxtSuccess?'已复制':'复制'}}
                    </div>
                  </template>
                  <template v-if="!normal_address_show && isSingle && order.service_type==2 && order.order_address.first_name!='联系客服'">
                    <div class="copyTxt" :class="{copyTxtSuccess:copyTxtSuccess}"
                    v-if="order.order_address.country != '中国大陆(CN)'"
                    v-clipboard:copy="order.order_address.county?order.order_address.first_name+' '+order.order_address.last_name+' '+order.order_address.address1+' '+order.order_address.address2+' '+order.order_address.county+','+order.order_address.city+','+order.order_address.province+' '+order.order_address.zip_code+' '+order.order_address.mobile:order.order_address.first_name+' '+order.order_address.last_name+' '+order.order_address.address1+' '+order.order_address.address2+' '+order.order_address.city+','+order.order_address.province+' '+order.order_address.zip_code+' '+order.order_address.mobile"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError">
                    <i v-if="!copyTxtSuccess" class="el-icon-news"></i> {{copyTxtSuccess?'已复制':'复制'}}
                    </div>
                    <div class="copyTxt" :class="{copyTxtSuccess:copyTxtSuccess}"
                    v-if="order.order_address.country == '中国大陆(CN)'"
                    v-clipboard:copy="order.order_address.county?(order.id_card_id!=0?order.id_card_info.name:order.order_address.last_name+order.order_address.first_name)+' '+order.order_address.mobile+' '+order.order_address.province+order.order_address.city+order.order_address.county+' '+order.order_address.address1+' '+order.order_address.address2+' '+(order.order_address.zip_code?'邮编:'+order.order_address.zip_code:''):order.order_address.last_name+order.order_address.first_name+' '+order.order_address.mobile+' '+order.order_address.province+order.order_address.city+order.order_address.county+' '+order.order_address.address1+' '+(order.order_address.zip_code?'邮编:'+order.order_address.zip_code:'')"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError">
                    <i v-if="!copyTxtSuccess" class="el-icon-news"></i> {{copyTxtSuccess?'已复制':'复制'}}
                    </div>
                  </template>
                  <SingleAddress v-if="normal_address_show || !isSingle || order.service_type!=2" :singleType="true" :showAddButton="true" :totalAccountList="totalAccountList" :address="order.address" :order="order" :transportList="transportList" :isSingle="isSingle"></SingleAddress>
                  <div v-if="normal_address_show && order.service_type==2" style="text-decoration: underline;cursor: pointer;color:#409eff;" @click="showXiadan=!showXiadan">{{ showXiadan?'隐藏下单地址':'显示下单地址' }}</div>
                  <div v-if="showXiadan || (!normal_address_show && isSingle)" style="margin-bottom:5px;">
                    <div class="bold">下单地址：</div>
                    <SingleAddress :singleType="false" v-if="order.order_address.first_name!='联系客服'" :showAddButton="false" :totalAccountList="totalAccountList" :address="order.order_address" :order="order" :transportList="transportList" :isSingle="isSingle"></SingleAddress>
                    <div v-else>
                      联系客服
                    </div>
                  </div>
                  <template v-if="normal_address_show || order.service_type!=2 || !isSingle">
                    <template v-if="order.service_type==2">
                      <a slot="reference" style="display: flex;align-items: center;" v-if="order.id_card_info.name && (['中国大陆(CN)'].indexOf(order.address.country)>-1)">
                        <img class="flag" :src="`https://pic.joyorders.com/country/${generateCountryCode(order.address.country).toLowerCase()}.png`" alt="country"/>
                        <label v-if="order.id_card_id!=0 && order.id_card_info.name">{{order.id_card_info.name}}</label>
                        <template v-else>
                          <label style="font-weight:bold;">{{order.address.last_name}}</label><label>{{order.address.first_name}}</label>
                        </template>
                        <span style="color:#333;" v-if="order.support_transport_service=='2'&&isSingle&&order.shipping_info&&order.shipping_info.length&&transportList.length" v-for="item in transportList"> | {{item}}</span>
                        <i class="el-icon-caret-bottom"></i>
                      </a>
                      <a slot="reference" style="display: flex;align-items: center;" v-else>
                        <img class="flag" :src="`https://pic.joyorders.com/country/${generateCountryCode(order.address.country).toLowerCase()}.png`" alt="country"/>
                        <template v-if="['中国大陆(CN)'].indexOf(order.address.country)>-1">
                          {{order.address.last_name}} {{order.address.first_name}}
                        </template>
                        <template v-else>
                          {{order.address.first_name}} {{order.address.last_name}}
                        </template>
                        <span style="color:#333;" v-if="order.support_transport_service=='2'&&isSingle&&order.shipping_info&&order.shipping_info.length&&transportList.length" v-for="item in transportList"> | {{item}}</span>
                        <i class="el-icon-caret-bottom"></i>
                      </a>
                    </template>
                    <template v-else>
                      <a slot="reference" style="display: flex;align-items: center;" v-if="order.address.transport_company">
                        <img class="flag" :src="`https://pic.joyorders.com/country/${generateCountryCode(order.address.country).toLowerCase()}.png`" alt="country"/>
                        {{order.address.transport_company}}
                        <span style="color:#333;" v-if="order.support_transport_service=='2'&&isSingle&&order.shipping_info&&order.shipping_info.length&&transportList.length" v-for="item in transportList"> | {{item}}</span> <i class="el-icon-caret-bottom"></i>
                      </a>
                      <a slot="reference" style="display: flex;align-items: center;" v-else>
                        <img class="flag" :src="`https://pic.joyorders.com/country/${generateCountryCode(order.address.country).toLowerCase()}.png`" alt="country"/>
                        <template v-if="['中国大陆(CN)'].indexOf(order.address.country)>-1">
                          {{order.address.last_name}} {{order.address.first_name}}
                        </template>
                        <template v-else>
                          {{order.address.first_name}} {{order.address.last_name}}
                        </template>
                        <span style="color:#333;" v-if="order.support_transport_service=='2'&&isSingle&&order.shipping_info&&order.shipping_info.length&&transportList.length" v-for="item in transportList"> | {{item}}</span>
                        <i class="el-icon-caret-bottom"></i>
                      </a>
                    </template>
                  </template>
                  <template v-if="!normal_address_show && isSingle && order.service_type==2 && order.order_address.first_name!='联系客服'">
                    <a slot="reference" style="display: flex;align-items: center;" v-if="order.order_address.transport_or_not == 2 && (['中国大陆(CN)'].indexOf(order.order_address.country)>-1)">
                      <img class="flag" :src="`https://pic.joyorders.com/country/${generateCountryCode(order.order_address.country).toLowerCase()}.png`" alt="country"/>
                      <label v-if="order.id_card_id!=0 && order.id_card_info.name">{{order.id_card_info.name}}</label>
                      <template v-else>
                        <label style="font-weight:bold;">{{order.order_address.last_name}}</label><label>{{order.order_address.first_name}}</label>
                      </template>
                      <span v-for="item in transportList" style="color:#333;" v-if="order.support_transport_service=='2'&&isSingle&&order.shipping_info&&order.shipping_info.length&&transportList.length">||  | {{item}}</span>
                      <i class="el-icon-caret-bottom"></i>
                    </a>
                    <a slot="reference" style="display: flex;align-items: center;" v-if="order.order_address.transport_or_not == 2 && (['中国大陆(CN)'].indexOf(order.order_address.country)==-1)">
                      <img class="flag" :src="`https://pic.joyorders.com/country/${generateCountryCode(order.order_address.country).toLowerCase()}.png`" alt="country"/>
                      {{order.order_address.first_name}} {{order.order_address.last_name}}
                      <span style="color:#333;" v-if="order.support_transport_service=='2'&&isSingle&&order.shipping_info&&order.shipping_info.length&&transportList.length" v-for="item in transportList"> | {{item}}</span>
                      <i class="el-icon-caret-bottom"></i>
                    </a>
                    <a slot="reference" style="display: flex;align-items: center;" v-if="order.order_address.transport_or_not == 1">
                      <img class="flag" :src="`https://pic.joyorders.com/country/${generateCountryCode(order.order_address.country).toLowerCase()}.png`" alt="country"/>
                      {{order.order_address.transport_company}}
                      <template v-for="item in transportList">
                        <span style="color:#333;" v-if="item!=order.order_address.transport_company.split(' ')[0] && order.support_transport_service=='2'&&isSingle&&order.shipping_info&&order.shipping_info.length&&transportList.length"> | {{item}}</span>
                      </template>
                      <i class="el-icon-caret-bottom"></i>
                    </a>
                  </template>
                  <template v-if="!normal_address_show && isSingle && order.service_type==2 && order.order_address.first_name=='联系客服'">
                    <a slot="reference" style="display: flex;align-items: center;">
                      联系客服
                      <i class="el-icon-caret-bottom"></i>
                    </a>
                  </template>
                  <div class="copyTxt" :class="{copyIdCardSuccess:copyIdCardSuccess}"
                  v-if="(normal_address_show || !isSingle) && order.id_card_id!=0 && order.id_card_info"
                  v-clipboard:copy="order.id_card_info.name+' '+order.id_card_info.id_card+' '+order.id_card_info.valid_date"
                  v-clipboard:success="onCopyIdCard"
                  v-clipboard:error="onError">
                  <i v-if="!copyIdCardSuccess" class="el-icon-news"></i> {{copyIdCardSuccess?'已复制':'复制'}}
                  </div>
                  <div class="id_card_div" v-if="(normal_address_show || !isSingle) && order.id_card_id!=0 && order.id_card_info">
                    <div class="bold"><i class="iconfont el-icon-joyordershenfenzhengrenzheng" style="margin-right:5px;"/>清关证件</div>
                    <p>姓名：{{order.id_card_info.name}}</p>
                    <p>身份证号：{{(role==3 || this.order.transport_shipping_account_id==this.account_id || maishouenable)?order.id_card_info.id_card:order.id_card_info.id_card.substr(0,6)+'XXXXXXXX'+order.id_card_info.id_card.substr(13)}}</p>
                    <p>有效日期：{{order.id_card_info.valid_date}}</p>
                    <div v-if="(role==3 || this.order.transport_shipping_account_id==this.account_id ||  maishouenable)" style="width:100%;display: flex;align-content: space-between;margin-top:7px;">
                      <div class="id_card_img" style="margin-right:5px;" @click="saveIdCard('front_image_url',order.id_card_info.name)">
                        <img :src="order.id_card_info.front_image_url" style="width:100%;"/>
                        <i class="iconfont el-icon-joyorderxiazai"></i>
                      </div>
                      <div class="id_card_img" @click="saveIdCard('back_image_url',order.id_card_info.name)">
                        <img :src="order.id_card_info.back_image_url" style="width:100%;"/>
                        <i class="iconfont el-icon-joyorderxiazai"></i>
                      </div>
                    </div>
                  </div>
                </el-popover>
              </template>
            </p>
            <template v-if="dizhiex_index>-1">
              <p :title="getTitle(order.exception_list[dizhiex_index],true)" class="exception-label" :class="{'close':order.exception_list[dizhiex_index].status==2,'tips':order.exception_list[dizhiex_index].category==2 || order.exception_list[dizhiex_index].category==3,'noti':order.exception_list[dizhiex_index].category==4}" @click="showException(dizhiex_index)">
                {{ getTitle(order.exception_list[dizhiex_index]) }}
                <div v-if="isLastFromUser(order.exception_list[dizhiex_index])" style="position:absolute;right:-4px;top:1px;background:#ff4650;width:10px;height:10px;border-radius: 50%;"></div>
              </p>
            </template>
          </div>
        </li>
      </ul>
      <div class="isMobile">
        <span v-if="normal_address_show" class="detail-button" @click="getGoodDetail()">任务详情</span>
        <span class="detail-text">任务#{{order.order_no}}</span>
        <span style="margin-left:2px;">{{order.service_type == 1? '下单寄':'转运寄'}}{{order.type == 2 ? '/ 帮我找货':''}}</span>
        <img style="position:relative;top:2px;margin-right: 0;" class="flag" :src="`https://pic.joyorders.com/country/${generateCountryCode(order.address.country).toLowerCase()}.png`" alt="country"/>
        <p class="detail-time">{{order.create_time.replace(/\s.*/, '')}}</p>
        <p class="detail-time">
          <span v-if="order.realRemark" style="position:relative;top:1px;margin-right:10px;">
            <i class="el-icon-chat-square" style="color:#000;"></i>
            <div style="position:absolute;right:-4px;top:1px;background:#ff4650;width:10px;height:10px;border-radius: 50%;"></div>
          </span>
          {{order.realRemark}}
        </p>
      </div>
    </div>
    </template>
    <div class="order-body">
      <ul style="position:relative;">
        <li v-if=" order.type == 2 && order.status < 16 && order.goods_list.length==0" class="order-detail">
          <el-row>
            <el-col class="line-list clearfix" :xs="24" :lg="19" :md="18" :sm="24">
              <div class="order-state notMobile aaa">
                <div>
                  <template v-if="order.fee_adjustment_list && order.fee_adjustment_list.length && order.fee_adjustment_list[0]">
                    <p>{{ packStatus }}<span v-if="orderStatus && order.fee_adjustment_list[0].status!=1">/</span>{{ orderStatus }}</p>
                  </template>
                  <template v-if="!order.fee_adjustment_list.length">
                    <p>{{ orderStatus }}</p>
                  </template>
                </div>
                <div v-if="order.business_order_no" class="order-code notMobile">
                  <p style="margin-bottom: 10px;">商家订单号</p>
                  <template v-if="order.business_order_url">
                    <p>
                      <a style="color:#333;" target="_blank" :href="order.business_order_url">{{ order.business_order_no }}</a>
                    </p>
                  </template>
                  <template v-else>
                    <p style="color:#333;">{{ order.business_order_no }}</p>
                  </template>
                </div>
              </div>
              <div class="order-state isMobile">
                <div>
                  <template v-if="order.fee_adjustment_list && order.fee_adjustment_list.length && order.fee_adjustment_list[0]">
                    <p>{{ packStatus }}<span v-if="orderStatus && order.fee_adjustment_list[0].status!=1">/</span>{{ orderStatus }}</p>
                  </template>
                  <template v-if="!order.fee_adjustment_list.length">
                    <p>{{ orderStatus }}</p>
                  </template>
                </div>
              </div>
              <div class="weeCtCoverBeforeDeal" v-if="order.voucher_list && order.voucher_list.length > 0 ">
                <div class="coverMore" v-if="order.voucher_list.length > 3"></div>
                <GeminiScrollbar forceGemini autoshow class>
                  <div v-if="order.status <= 15"
                          class="ctCover"
                          :style="{width: `${order.displayVoucherList.length * (screenWidthWee > 1024 ? 130 : 90) + 15}px`}"
                          @click="showOrderVoucher"
                  >
                    <div
                            class="cover"
                            :style="{background: `url('${item.url}') center no-repeat`}"
                            v-for="(item, $index) in order.displayVoucherList"
                            :key="$index"
                    >
                    </div>
                  </div>
                  <div v-else
                          class="ctCover"
                          :style="{width: `${order.voucher_list.length * (screenWidthWee > 1024 ? 130 : 90) + 15}px`}"
                          @click="showOrderVoucher"
                  >
                    <div
                            class="cover"
                            :style="{background: `url('${item.url}') center no-repeat`}"
                            v-for="(item, $index) in order.voucher_list"
                            :key="$index"
                    >
                    </div>
                  </div>
                </GeminiScrollbar>
              </div>
              <ul  v-if="false" >
                <li class="order-line clearfix">
                  <div class="order-des">
                    <p class="timeIco">
                      <i class="el-icon-time" style="font-size:35px;color:#888;"></i>
                    </p>
                    <div class="descripe">
                      <div v-if="order.status==11">
                        此任务等待接单中～
                      </div>
                      <div v-if="order.status==13">
                        此任务等待下单中～
                      </div>
                      <div v-if="order.status==14">
                        此任务正在下单中～
                      </div>
                      <div v-if="order.status==15">
                        任务下有未发货商品～
                      </div>
                      <div v-if="order.status == 15 || order.type == 2" style="margin-top:10px;">
                        商品信息详见<span class="voucher" @click="showOrderVoucher()" >下单凭证</span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col class="operation-container notMobile" :span="5">
              <OrderOperation
                :totalAccountList="totalAccountList"
                :normal_address_show="normal_address_show"
                :zhuanyun_role_enable="zhuanyun_role_enable"
                :trackTask="trackTask"
                :order="order"
                :isSingle="isSingle"
                v-on:lineChange="initData"
                v-on:complete="complete"
                v-on:updateGroupLine="updateGroupLine"
                :task_loading="task_loading"
                @begin="begin"
                @takebysingle="take_by_single"
                @showUploadOrder="showUploadOrder"
                @showDaigouOrder="showDaigouOrder"
                @showExpress="showExpress"
                @showOrderDelegate="showOrderDelegate"
                @callBack="callBackHandler"
              ></OrderOperation>
            </el-col>
          </el-row>
        </li>
        <li v-for="(groupOrderLine, packageId) in order.groupOrderLines" :key="packageId" class="order-detail" v-if="order.goods_list&&order.goods_list.length">
          <el-row>
            <el-col class="line-list clearfix" :xs="24" :lg="19" :md="18" :sm="24">
              <div class="order-state notMobile _orderState">
                <OrderState :transportStatusArray="transportStatusArray" :zhuanyun_role_enable="zhuanyun_role_enable" :normal_address_show="normal_address_show" :isSingle="isSingle" :groupOrderLine="groupOrderLine" :order="order" :merchantExpress="merchantExpress" :packageId="packageId" :trackTask="trackTask" :showPackstatus="true"></OrderState>
              </div>
              <div class="order-state isMobile" @click="getPackgeDetail(groupOrderLine,packageId)">
                <OrderState :transportStatusArray="transportStatusArray" :zhuanyun_role_enable="zhuanyun_role_enable" :normal_address_show="normal_address_show" :isSingle="isSingle" :groupOrderLine="groupOrderLine" :order="order" :merchantExpress="merchantExpress" :packageId="packageId" :trackTask="trackTask" :mobiletype="taskInfo.mobiletype"></OrderState>
                <span class="tabBar"><i class="el-icon-arrow-right"></i></span>
              </div>
              <ul style="width: calc(100% - 140px);">
                <li style="position:relative;display:flex;" v-for="(line,index) in groupOrderLine" :key="index" class="order-line clearfix" @mouseover="hover(index,packageId)" @mouseout="hoverIndex = -1;packageIdIndex= -1" v-if="order.type==0">
                  <div class="img-container">
                    <div>
                      <a class="img-wrapper" href="javascript:void(0)" @click="navToProduct(line)">
                        <template v-if="line.enable_alternate_images==1">
                          <img v-if="line.picture" :src="line.picture" mode="aspectFit"/>
                          <div class="plh_img" style="height:100%;" v-else>
                            <div v-if="line[line.unique_param]" class="plh_img_walk" :style="{backgroundImage:'url('+line[line.unique_param].color_image_url+')'}"></div>
                          </div>
                        </template>
                        <template v-else>
                          <img v-if="line.picture" :src="line.picture"/>
                          <img v-else src="https://pic.joyorders.com/blank.png"/>
                        </template>
                        <span class="goodsNum" v-if="line.number>1">{{ line.number }}</span>
                        <span class="top-left star-container" v-if="line.recommendation_index!=0" :style="handleStyle(line.recommendation_index)">
                          <span  class="number">{{line.recommendation_index}}</span>
                        </span>
                      </a>
                    </div>
                    <p class="exception-label" v-if="generateLackGoods(line)" style="font-size:10px;text-align: center;color:#ff4650;letter-spacing: 2px;">
                      {{ generateLackGoods(line) }}
                    </p>
                  </div>
                  <div class="order-des">
                    <p class="name"  style="position: relative;display: flex;align-items: center">
                      <img class="fromWeb" v-if="single_type==1 && line.source==2" src="../../../assets/images/fromWeb.png" />
                      <a :href='line.website.substr(0,7).toLowerCase() == "http://" || line.website.substr(0,8).toLowerCase() == "https://"  ? line.website : "http://"+ line.website' target="_blank">{{showProductName(line)}}</a>
                      <el-popover
                        placement="top-start"
                        class="jo-popover"
                        style="margin-left: 0.5rem"
                        :ref="`popover-${line.good_id}`"
                        trigger="click">
                        <div>
                          <div class="packStatus">
                            <span class="el-dropdown-link to_dos"
                                      style="width: 8rem;display: flex;justify-content: center;align-items: center;padding-bottom: 12px;margin-bottom: 15px;border-bottom: 1px solid #ccc;cursor: pointer;" @click="navToAdmin(line.good_id)">
                                      <i class="el-icon-news" style="position:relative;top:1px;margin-right:3px;"></i>
                                      <span>商品管理</span>
                            </span>
                            <el-dropdown @command="handleRecommendIndex">
                                <span class="el-dropdown-link to_dos"
                                      style="width: 8rem;display: flex;justify-content: space-around;align-items: center;">
                                  <span>推荐指数</span><span style="margin-left: .5rem">{{line.recommendation_index}}</span><i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                              <el-dropdown-menu slot="dropdown" class="dropdownStatus" style="width: 4rem">
                                <el-dropdown-item :command="`0_${line.good_id}`">0</el-dropdown-item>
                                <el-dropdown-item v-for="(i) in 8" :key="i" :command="`${i}_${line.good_id}`">{{i}}
                                </el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </div>
                        </div>
                        <span slot="reference" class="moreIcon"><i class="el-icon-more"></i></span>
                      </el-popover>
                    </p>
                    <!-- <p class="notMobile"><span>规格：</span>{{line.spec}}</p> -->
                    <div class="notMobile spec" v-show="formatSpec(line.spec,line)">
                      <span v-show="!line.isHideSpecLabel">规格：</span>
                      <span v-html="formatSpec(line.spec,line)"></span>
                    </div>
                    <div class="notMobile spec" v-if="checkShangpingEx(line)>-1 || checkChimaEx(line)>-1">
                      <template v-if="checkShangpingEx(line)>-1">
                        <div :title="getTitle(order.exception_list[checkShangpingEx(line)],true)" class="exception-label tips" :class="{'close':order.exception_list[checkShangpingEx(line)].status==2}" @click="showException(checkShangpingEx(line))">
                          {{ getTitle(order.exception_list[checkShangpingEx(line)]) }}
                          <div v-if="isLastFromUser(order.exception_list[checkShangpingEx(line)])" style="position:absolute;right:-4px;top:1px;background:#ff4650;width:10px;height:10px;border-radius: 50%;"></div>
                        </div>
                      </template>
                      <template v-if="checkChimaEx(line)>-1">
                        <label v-if="checkShangpingEx(line)>-1" style="margin:0 0.5rem;">|</label>
                        <span :title="getTitle(order.exception_list[checkChimaEx(line)],true)" class="exception-label tips" :class="{'close':order.exception_list[checkChimaEx(line)].status==2}" @click="showException(checkChimaEx(line))" style="margin-left:2px;">
                          {{ getTitle(order.exception_list[checkChimaEx(line)]) }}
                          <div v-if="isLastFromUser(order.exception_list[checkChimaEx(line)])" style="position:absolute;right:-4px;top:1px;background:#ff4650;width:10px;height:10px;border-radius: 50%;"></div>
                        </span>
                      </template>
                    </div>
                    <div style="height:24px;" v-show="!formatSpec(line.spec,line)">
                    </div>
                    <div class="notMobile spec" v-show="line.sku && isSingle" style="position:relative;">
                      <span>{{line.sku}}</span>
                      <!--<div v-if="supportCompareMerchants.indexOf(+order.business_id)>-1" class="compareExpress_div">
                        <span v-loading="isFetchingMerchantExpress"></span>
                        <span v-if="!isFetchingMerchantExpress && compareExpressObj[line.sku+'_'+JSON.parse(line.spec)[line.vice_param]]" v-for="(c,index) in compareExpressObj[line.sku+'_'+JSON.parse(line.spec)[line.vice_param]]" class="buyAgain compareExpress">
                          <a :href="c.url" target="blank">{{c.text}}</a>
                          <span style="margin-left:5px;" v-if="c.text.indexOf('取消')==-1 && c.copytext" v-clipboard:copy="c.copytext"
                          v-clipboard:success="onCopyCompare"
                          v-clipboard:error="onError">
                          <i class="el-icon-check" v-if="c.copyTxtSuccess" style="font-size:16px;"></i>
                          <i class="iconfont el-icon-joyordercopy-document" v-if="!c.copyTxtSuccess" @click="setCopy(line,index)"></i>
                          </span>
                        </span>

                      </div>-->
                    </div>
                    <div style="height:24px;" v-show="!(line.sku && isSingle)">
                    </div>
                    <div v-if="line.discounted_price !== line.price" class="notMobile" style="display: flex;align-items: center;">
                      <a class="order-price">{{(line.discounted_price)|currency(order.currency_symbol)}}</a>
                      <del class="order-price"> {{(line.price)|currency(order.currency_symbol)}}</del>
                      <div v-if="!isSingle" class="buyAgain" :class="{'isMobile':hoverIndex!=index||packageIdIndex!=packageId}" @click="buyAgain(order,line)">再次购买</div>
                    </div>
                    <div v-if="line.discounted_price == line.price" class="notMobile" style="display: flex;align-items: center;">
                      <p class="order-price"> {{(line.price)|currency(order.currency_symbol)}}</p>
                      <div v-if="!isSingle" class="buyAgain" :class="{'isMobile':hoverIndex!=index||packageIdIndex!=packageId}" @click="buyAgain(order,line)">再次购买</div>
                    </div>
                    <!--<div class="spec" style="align-items:center;color:#07c160">
                      <i class="el-icon-check" style="margin-right:5px;position:relative;top:1px;"></i>
                      满100减20,-{{ order.currency_symbol }}1.00
                    </div>-->
                  </div>
                </li>
                <template v-for="(line,index) in groupOrderLine">
                  <li v-if="line.image_info && JSON.stringify(line.image_info)!='{}'" class="order-line clearfix">
                    <div class="img-container">
                      <img v-if="line.image_info.image" :src="line.image_info.image"/>
                      <img v-else src="https://pic.joyorders.com/blank.png"/>
                    </div>
                    <div class="order-des">
                      <p class="name" v-if="line.image_info.remark">{{line.image_info.remark}}</p>
                      <template v-if="line.status==3">
                        <div v-if="line.discounted_price !== line.price" class="notMobile" style="display: flex;align-items: center;">
                          <a class="order-price">{{(line.discounted_price)|currency(order.currency_symbol)}}</a>
                          <del class="order-price"> {{(line.price)|currency(order.currency_symbol)}}</del>
                          <div v-if="!isSingle" class="buyAgain" :class="{'isMobile':hoverIndex!=index||packageIdIndex!=packageId}" @click="buyAgain(order,line)">再次购买</div>
                        </div>
                        <div v-if="line.discounted_price == line.price" class="notMobile" style="display: flex;align-items: center;">
                          <p class="order-price"> {{(line.price)|currency(order.currency_symbol)}}</p>
                          <div v-if="!isSingle" class="buyAgain" :class="{'isMobile':hoverIndex!=index||packageIdIndex!=packageId}" @click="buyAgain(order,line)">再次购买</div>
                        </div>

                      </template>
                    </div>
                  </li>
                </template>
              </ul>
            </el-col>
            <el-col class="operation-container notMobile" :span="5">
              <OrderOperation
                :totalAccountList="totalAccountList"
                :normal_address_show="normal_address_show"
                :zhuanyun_role_enable="zhuanyun_role_enable"
                :trackTask="trackTask"
                :groupOrderLine="groupOrderLine"
                :order="order"
                :packageId="packageId"
                :isSingle="isSingle"
                v-on:lineChange="initData"
                v-on:complete="complete"
                v-on:updateGroupLine="updateGroupLine"
                :task_loading="task_loading"
                @begin="begin"
                @takebysingle="take_by_single"
                @showUploadOrder="showUploadOrder"
                @showDaigouOrder="showDaigouOrder"
                @showExpress="showExpress"
                @showOrderDelegate="showOrderDelegate"
                @callBack="callBackHandler"
              ></OrderOperation>
            </el-col>
          </el-row>
        </li>
        <li class="order-detail" v-if="order.type == 2 && order.status >= 16 && order.goods_list.length==0 && order.good_image_list && order.good_image_list.length">
          <el-row>
            <el-col class="line-list clearfix" :xs="24" :lg="19" :md="18" :sm="24">
              <div class="order-state notMobile ccc">
                <div>
                  <template v-if="order.fee_adjustment_list && order.fee_adjustment_list.length && order.fee_adjustment_list[0]">
                    <p>{{ packStatus }}<span v-if="orderStatus">/</span>{{ orderStatus }}</p>
                  </template>
                  <template v-if="!order.fee_adjustment_list.length">
                    <p>{{ orderStatus }}</p>
                  </template>
                </div>
                <div v-if="order.business_order_no" class="order-code notMobile">
                  <p style="margin-bottom: 10px;">商家订单号</p>
                  <template v-if="order.business_order_url">
                    <p>
                      <a style="color:#333;" target="_blank" :href="order.business_order_url">{{ order.business_order_no }}</a>
                    </p>
                  </template>
                  <template v-else>
                    <p style="color:#333;">{{ order.business_order_no }}</p>
                  </template>
                </div>
              </div>
              <div class="order-state isMobile">
                <div>
                  <template v-if="order.fee_adjustment_list && order.fee_adjustment_list.length && order.fee_adjustment_list[0]">
                    <p>{{ packStatus }}<span v-if="orderStatus">/</span>{{ orderStatus }}</p>
                  </template>
                  <template v-if="!order.fee_adjustment_list.length">
                    <p>{{ orderStatus }}</p>
                  </template>
                </div>
              </div>
              <div class="weeCtCoverBeforeDeal" v-if="order.voucher_list && order.voucher_list.length > 0 ">
                <div class="coverMore" v-if="order.voucher_list.length > 3"></div>
                <!--没有包裹状态下的图片在任务取消时只显示初始发布时候的图片-->
                <GeminiScrollbar forceGemini autoshow class>
                  <div
                          class="ctCover"
                          :style="{width: `${order.displayVoucherList.length * (screenWidthWee > 1024 ? 130 : 90) + 15}px`}"
                          @click="showOrderVoucher"
                  >
                    <div
                            class="cover"
                            :style="{background: `url('${item.url}') center no-repeat`}"
                            v-for="(item, $index) in order.displayVoucherList"
                            :key="$index"
                    >
                    </div>
                  </div>

                </GeminiScrollbar>
              </div>

            </el-col>
          </el-row>
        </li>
        <li class="order-detail" v-if="order.type==2 && order.status==15 && order.goods_list.length && order.goods_list[0].package_id">
          <el-row>
            <el-col class="line-list clearfix" :xs="24" :lg="19" :md="18" :sm="24">
              <div class="order-state notMobile">
                <OrderState :transportStatusArray="transportStatusArray" :zhuanyun_role_enable="zhuanyun_role_enable" :normal_address_show="normal_address_show" :isSingle="isSingle" :groupOrderLine="constantGroupOrderLine" :order="order" :merchantExpress="merchantExpress" :trackTask="false" :showPackstatus="false"></OrderState>
              </div>
              <div class="constantGroupOrderLine">任务下有未发货商品</div>
            </el-col>
          </el-row>
        </li>
        <div class="mail-top">
          <div v-if="needGetTicket && tickets && tickets.length" style="color: #1aad19;cursor:pointer;" @click="toggleTicket">
            <i style="font-size: 16px;position: relative;top: 1px;" class="el-icon-tickets"></i>
            {{ tickets.length }}
          </div>
          <div v-if="needGetMail && order.mails && order.mails.length" style="color: #1aad19;cursor:pointer;margin-left:20px;" @click="toggleMail">
            <i style="font-size: 16px;position: relative;top: 1px;" class="el-icon-message"></i>
            {{ order.mails.length }}
          </div>
          <div v-if="order.express_bill_list && order.express_bill_list.length" style="color: #1aad19;cursor:pointer;margin-left:20px;" @click="toggleExpresssBill">
            <i style="font-size: 16px;position: relative;top: 1px;" class="el-icon-truck"></i>
            {{ order.express_bill_list.length }}
          </div>
          <div v-if="order.amount_bill_list && order.amount_bill_list.length" style="color: #1aad19;cursor:pointer;margin-left:20px;" @click="toggleAmountBill">
            <i style="font-size: 16px;position: relative;top: 1px;" class="el-icon-wallet"></i>
            {{ order.amount_bill_list.length }}
          </div>
          <!--<div v-if="order.daigou && order.daigou.length" style="color: #1aad19;cursor:pointer;margin-left:20px;" @click="toggleDaigou">
            <i style="font-size: 16px;position: relative;top: 1px;" class="el-icon-s-goods"></i>
            {{ order.daigou.length }}
          </div>-->
        </div>
      </ul>
      <div class="order-foot isMobile">
        <div v-if="isSingle" style="padding-bottom: 20px;">
          <el-button class="block btn-14" type="info" @click="begin()" v-if="order.status == 13 && order.noNeedPaid">开始下单</el-button>
          <el-button class="block btn-14" type="info" @click="take_by_single()" v-if="order.status == 11">确认接单</el-button>
          <el-button class="block btn-14" type="info" @click="showUploadOrder()" v-if="order.status == 14 && order.noNeedPaid && (isSingle || order.buyer_delegate_account_id==account_id)">上传下单信息</el-button>
        </div>
        <div>
          <span style="float:left;">总计</span>
          <span class="foot-price">
            <a  v-if="isSingle && order.fee_adjustment_list.length == 0">{{order.total_amount | currency(order.currency_symbol)}}</a>
            <a  v-if="isSingle && order.fee_adjustment_list.length > 0">{{$decimalFormat((Number(order.total_fee) + Number(order.fee_adjustment_list[0].tax_fee) + Number(order.fee_adjustment_list[0].transport_fee) + Number(order.fee_adjustment_list[0].other_fee)),2) | currency(order.currency_symbol)}}</i></a>
            <a  v-if="!isSingle && order.fee_adjustment_list.length == 0">{{order.rmb_total_amount | currency('¥')}}</a>
            <a  v-if="!isSingle && order.fee_adjustment_list.length > 0">{{$decimalFormat(((Number(order.total_fee) + Number(order.fee_adjustment_list[0].tax_fee) + Number(order.fee_adjustment_list[0].transport_fee) + Number(order.fee_adjustment_list[0].other_fee))*Number(order.conditions.rate) + Number(order.fee_adjustment_list[0].package_forwarding_fee)),2) | currency('¥')}}</a>
          </span>
        </div>
      </div>
    </div>
    <template v-if="order.express_bill_list&&order.express_bill_list.length">
    <div class="mail-body" v-show="expressBillShow">
      <div class="mail-link"></div>
      <div class="mail-content">
        <el-collapse class="customCollapse" v-model="expressActiveName" accordion style="width:100%;">
          <el-collapse-item v-for="(r,index) in order.express_bill_list" :name="index" :key="index">
            <template slot="title">
              <div class="table-row-title" style="line-height:1;width:100%;">
                <div style="width: 40px;position: relative;top: -2px;color: #1aad19;">
                  <i style="font-size: 20px;" class="el-icon-truck"></i>
                </div>
                <div v-for="(c,idx) in expressBillColumns" :key="idx" :style="{width:c.width}">
                  <template v-if="c.field=='time'">
                    <p style="font-size: 16px;padding-bottom: 5px;">{{ r.date_display }}</p>
                    <p style="color:#666;">{{ r.time_display }}</p>
                  </template>
                  <template v-if="c.field=='detail'">
                    <template>
                      <p style="font-size: 16px;padding-bottom: 5px;">{{ `${r.express_company_name}
                        #${r.transport_store_number}` }}</p>
                      <p style="color:#666;">{{ `${r.receive_address} ` }}</p>
                    </template>
                  </template>
                  <template v-if="c.field=='price'">
                    <p style="font-size: 16px;">
                      {{evalPrice(r)}}
                    </p>
                  </template>
                </div>
              </div>
            </template>
            <div class="table-row-content">
              <!--<Mail :good_number="good_number" :r="r" :index="index" @updateMail="updateMail"></Mail>-->
              <BillBody :r="r"></BillBody>
              <div style="clear:both;"></div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

  </template>
  <template v-if="order.amount_bill_list && order.amount_bill_list.length">
    <div class="mail-body" v-show="amountBillShow">
      <div class="mail-link"></div>
      <div class="mail-content">
        <el-collapse class="customCollapse" v-model="amountBillActiveName" accordion style="width:100%;">
          <el-collapse-item v-for="(r,index) in order.amount_bill_list" :name="index" :key="index">
            <template slot="title">
              <div class="table-row-title" style="line-height:1;width:100%;">
                <!--                <div style="width: 40px;position: relative;top: -2px;color: #1aad19;">-->
                <!--                  <i style="font-size: 20px;" class="el-icon-truck"></i>-->
                <!--                </div>-->
                <div v-for="(c,idx) in billColumns" :key="idx" :style="{width:c.width}">
                  <template v-if="c.field=='create_time'">
                    <p style="font-size: 16px;padding-bottom: 5px;">{{ r.date_display }}</p>
                    <p style="color:#666;">{{ r.time_display }}</p>
                  </template>
                  <template v-if="c.field=='detail'">
                    <template>
                      <div v-html="handleBill(r)"></div>
                    </template>
                  </template>
                  <template v-if="c.field=='amount'">
                    <p class="padding-bottom-5" style="font-size: 16px;">{{r.amount}}{{r.currency}}</p>
                    <p class="text-gray">{{r.bill_status_content}}</p>
                  </template>
                </div>
              </div>
            </template>
            <div class="table-row-content">
              <BillCollapseBody :r="r" :index="index" :feeItemTypeList="fee_item_type_list"
                                v-on:updateBill="updateBill"
              >
              </BillCollapseBody>
              <div style="clear:both;"></div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </template>

    <template v-if="needGetMail && order.mails && order.mails.length">
      <div class="mail-body" v-show="mailShow">
        <div class="mail-link"></div>
        <div class="mail-content">
          <el-collapse class="customCollapse" v-model="mailactiveName" accordion style="width:100%;">
              <el-collapse-item v-for="(r,index) in order.mails" :name="index" :key="index">
                <template slot="title">
                  <div class="table-row-title" style="line-height:1;width:100%;">
                    <div style="width: 40px;position: relative;top: -2px;color: #1aad19;">
                      <i style="font-size: 20px;" class="el-icon-message"></i>
                    </div>
                    <div v-for="(c,idx) in columns" :key="idx" :style="{width:c.width}">
                      <template v-if="c.field=='send_time_display'">
                        <p style="font-size: 16px;padding-bottom: 5px;">{{ r.date_display }}</p>
                        <p style="color:#666;">{{ r.time_display }}</p>
                      </template>
                      <template v-if="c.field=='mail_content'">
                        <template v-if="r.mail_theme=='礼品卡'">
                          <p style="font-size: 16px;padding-bottom: 5px;">{{ `${r.merchant_display} #${r.merchant_order_number}` }}</p>
                          <p style="color:#666;">{{ `${r.mail_theme} ` }}<label v-if="r.price">{{ `${r.price_symbol}${r.price}${r.currency}` }}</label></p>
                        </template>
                        <template v-else>
                          <p style="font-size: 16px;padding-bottom: 5px;">{{ `${r.merchant_display} 订单#${r.merchant_order_number}` }}</p>
                          <p style="color:#666;">{{ `${r.mail_theme} ` }}<label v-if="r.tracking_number_display">{{ `#${r.tracking_number_display}` }}</label></p>
                        </template>
                      </template>
                      <template v-if="c.field=='status_display'">
                        <p style="font-size: 16px;">{{ r[c.field] }}</p>
                      </template>
                    </div>
                  </div>
                </template>
                <div class="table-row-content">
                  <Mail :taskDisplay="true" :r="r" :index="index" @updateMail="updateMail"></Mail>
                  <div style="clear:both;"></div>
                </div>
              </el-collapse-item>
            </el-collapse>
        </div>
      </div>
    </template>
    <template v-if="needGetTicket && tickets && tickets.length">
      <div class="mail-body" v-show="ticketShow">
        <div class="mail-link"></div>
        <div class="mail-content">
          <el-collapse class="customCollapse" v-model="ticketactiveName" accordion style="width:100%;" @change="changeTicketCollapse">
            <el-collapse-item v-for="(r,index) in tickets" :name="index" :key="index">
              <template slot="title">
                <div class="table-row-title" style="line-height:1;width:100%;">
                  <div v-for="(c,idx) in ticketcolumns" :key="idx" :style="{width:c.width}">
                    <template v-if="c.field=='send_time_display'">
                      <p style="font-size: 16px;padding-bottom: 5px;">
                        <span class="priority-label" :title="ticketPriorityDisplay(r.priority_id)" :class="{'P1':ticketPriorityDisplay(r.priority_id)=='高','P2':ticketPriorityDisplay(r.priority_id)=='中','P3':ticketPriorityDisplay(r.priority_id)=='低'}"></span>
                        #{{ r.ticket_number }}
                      </p>
                    </template>
                    <template v-if="c.field=='mail_content'">
                      <p style="font-size: 16px;padding-bottom: 5px;">
                        <label style="font-size: 16px;">{{ r.subject }}</label>
                      </p>
                      <p style="color:#666;">
                        <label>
                          <i class="el-icon-collection-tag" style="font-size: 16px;position:relative;top:2px;"></i>
                          {{ ticketTypeDisplay(r.type_id) }}
                        </label>
                        <label style="margin-left:5px;">
                          <i title="指派给" class="el-icon-thumb" style="font-size: 16px;transform: rotate(90deg);position:relative;top:1px;"></i>
                          {{ r.created_by_username }}
                        </label>
                        <label style="margin-left:5px;">
                          <i title="更新时间" class="el-icon-time" style="font-size: 16px;position:relative;top:1px;"></i>
                          {{ r.created_date }}
                        </label>
                      </p>
                    </template>
                    <template v-if="c.field=='status_display'">
                      <p style="font-size: 16px;;padding-bottom: 5px;">{{ ticketStatusDisplayForTitle(r.status_id).title }}</p>
                      <p style="color:#666;">{{ ticketStatusDisplayForTitle(r.status_id).subtitle }}</p>
                    </template>
                  </div>
                </div>
              </template>
              <div class="table-row-content">
                <Ticket :r="r" :relationReset="relationReset" :index="index" :ticketStatus="ticketStatus" :ticketVisible="ticketVisible"
                :ticketPriorities="ticketPriorities" :singleList="ticketAccounts" :ticketTypes="ticketTypes" :replyTemplate="replyTemplate"
                :exceptionTypes="exceptionTypes" :expressList="expressList" :merchants="merchants" :order="order" @reset="handleReset"></Ticket>
                <div style="clear:both;"></div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </template>
    <template v-if="order.daigou && order.daigou.length">
      <div class="mail-body" v-show="daigouShow">
        <div class="mail-link"></div>
        <div class="mail-content">
          <el-collapse class="customCollapse" v-model="daigouactiveName" accordion style="width:100%;">
              <el-collapse-item v-for="(r,index) in order.daigou" :name="index" :key="index">
                <template slot="title">
                  <div class="table-row-title" style="line-height:1;width:100%;">
                    <div style="width: 40px;position: relative;top: -2px;color: #1aad19;">
                      <!--<i style="font-size: 20px;" class="el-icon-message"></i>-->
                    </div>
                    <div v-for="(c,idx) in columns" :key="idx" :style="{width:c.width}">
                      <template v-if="c.field=='send_time_display'">
                        <p style="font-size: 16px;padding-bottom: 5px;">{{ r.createDateDisplay }}</p>
                        <p style="color:#666;">{{ r.createTimeDisplay }}</p>
                      </template>
                      <template v-if="c.field=='mail_content'">
                          <p style="font-size: 16px;padding-bottom: 5px;">{{ `订单#${r.fifteenhaoku_order_no}` }}</p>
                      </template>
                      <template v-if="c.field=='status_display'">
                        <p style="font-size: 16px;">{{ r[c.field] }}</p>
                      </template>
                    </div>
                  </div>
                </template>
                <div class="table-row-content">
                  <Daigou :r="r" :index="index"></Daigou>
                  <div style="clear:both;"></div>
                </div>
              </el-collapse-item>
            </el-collapse>
        </div>
      </div>
    </template>
    <el-dialog v-if="showPackge" class="el-dialog-sm el-dialog-sm-h3 mobile-order-detail" :close-on-click-modal="false"  :visible.sync="showPackge" width="90%"  @close="toggleBody(0)">
      <h1 class="detail-title">包裹详情</h1>
      <div class="detail-body">
        <h2>包裹状态</h2>
        <div class="mobile-order-state">
          <OrderState :transportStatusArray="transportStatusArray" :zhuanyun_role_enable="zhuanyun_role_enable" :normal_address_show="normal_address_show" :isSingle="isSingle" :groupOrderLine="groupOrderLine_temporary" :trackTask="trackTask" :order="order" :merchantExpress="merchantExpress" :packageId="packageId_temporary" :mobiletype="taskInfo.mobiletype" :showPackstatus="true"></OrderState>
        </div>
        <p v-if="order.business_order_no && !trackTask">商家订单号{{order.business_order_no}}</p>
      </div>
      <div class="detail-body">
        <ul class="buyContent">
          <li class="clearfix" v-for="(goods,index) in groupOrderLine_temporary" :key="index">
            <div class="content-container">
              <div class="clearfix">
                <div class="img-container">
                  <a href="javascript:void(0)" @click="navToProduct(goods)">
                    <img v-if="goods.picture" :src="goods.picture"/>
                    <img  v-else src="https://pic.joyorders.com/blank.png"/>
                  </a>
                </div>
                <div class="line-des">
                  <p class="name"><a :href='goods.website.substr(0,7).toLowerCase() == "http://" || goods.website.substr(0,8).toLowerCase() == "https://" ? goods.website : "http://"+ goods.website' target="_blank">{{goods.name}}</a></p>
                  <!-- <p><span>规格：</span>{{goods.spec}}</p> -->
                  <div class="spec">
                    <span>规格：</span>
                    <span v-html="formatSpec(goods.spec,good)"></span>
                  </div>
                  <div v-if="goods.discounted_price !== goods.price">
                    <a class="order-price">{{(goods.discounted_price)|currency(order.currency_symbol)}}</a>
                    <del class="order-price"> {{(goods.price)|currency(order.currency_symbol)}}</del>
                  </div>
                  <div v-if="goods.discounted_price == goods.price">
                    <p class="order-price"> {{(goods.price)|currency(order.currency_symbol)}}</p>
                  </div>

                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="detail-body">
        <h2>寄至</h2>
        <SingleAddress :address="order.address"></SingleAddress>
      </div>
      <div class="detail-body" v-if="groupOrderLine_temporary[0].status != 3 && order.status != 30">
        <OrderOperation
          :totalAccountList="totalAccountList"
          :normal_address_show="normal_address_show"
          :zhuanyun_role_enable="zhuanyun_role_enable"
          :trackTask="trackTask"
          :groupOrderLine="groupOrderLine_temporary"
          :order="order"
          :packageId="packageId_temporary"
          :isSingle="isSingle"
          :mobiletype="taskInfo.mobiletype"
          v-on:lineChange="initData"
          v-on:complete="complete"
          v-on:updateGroupLine="updateGroupLine"
          :task_loading="task_loading"
          @begin="begin"
          @takebysingle="take_by_single"
          @showUploadOrder="showUploadOrder"
          @showDaigouOrder="showDaigouOrder"
          @showExpress="showExpress"
          @showOrderDelegate="showOrderDelegate"
        ></OrderOperation>
      </div>
    </el-dialog>
    <el-dialog v-if="showDetail" class="el-dialog-sm el-dialog-sm-h3 mobile-order-detail orderDetail" :close-on-click-modal="false"  :visible.sync="showDetail" width="90%"  @close="toggleBody(0)">
      <h1 style="" class="detail-title">任务详情</h1>
      <div class="isMobile">
        <div class="suspension">

          <div class="flexBtn" style="margin-top:10px;" v-if="order.status == 11&&isSingle">
            <div @click="take_by_single()">
              <i class="el-icon-copy-document operationIco"></i>
              <div class="operationBtn" >确认接单</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if="order.status == 13&&isSingle">
            <div @click="begin()">
              <i class="el-icon-copy-document operationIco"></i>
              <div class="operationBtn" >开始下单</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if=" order.status == 14 && ( (order.fee_adjustment_list[0] && order.fee_adjustment_list[0].status == 1) || !(order.fee_adjustment_list[0] && order.fee_adjustment_list[0].unpaid_fee_rmb)) &&isSingle">
            <div @click="showUploadOrder()">
              <i class="el-icon-copy-document operationIco"></i>
              <div class="operationBtn" >上传下单信息</div>
            </div>
          </div>
          <AddressDialog v-if="['11'].indexOf(order.status) > -1 && !isSingle"  :address-id="order.address_id" v-on:success="updateAddress" v-on:complete="complete" style="display:block;margin-top: 10px;">
              <i class="el-icon-circle-close operationIco"></i>
              <div class="operationBtn" >更改地址</div>
          </AddressDialog>
          <OrderCancelDialog v-if="['11', '13'].indexOf(order.status) > -1&&!isSingle" style="margin-top:10px;" class="flexBtn" :mobiletype="taskInfo.mobiletype" :isSingle="isSingle" :order="order" v-on:complete="complete" @refresh="updatePriceInfo">
            <!-- <div   v-if="!trackTask"> -->
              <i class="el-icon-circle-close operationIco"></i>
              <div class="operationBtn" >取消任务</div>
            <!-- </div> -->
          </OrderCancelDialog>
          <OrderCancelDialog v-if="['11','12', '13','14'].indexOf(order.status) > -1&&isSingle" style="margin-top:10px;" class="flexBtn" :mobiletype="taskInfo.mobiletype" :isSingle="isSingle" :order="order" v-on:complete="complete" @refresh="updatePriceInfo">
            <!-- <div   v-if="!trackTask"> -->
              <i class="el-icon-circle-close operationIco"></i>
              <div class="operationBtn" >取消任务</div>
            <!-- </div> -->
          </OrderCancelDialog>
          <div class="flexBtn" style="margin-top:10px;" v-if="['11'].indexOf(order.status) > -1 && !isSingle">
            <div @click="copyOrder()">
              <i class="el-icon-copy-document operationIco"></i>
              <div class="operationBtn" >修改地址</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if="!trackTask && order.type!=2">
            <div @click="copyOrder()">
              <i class="el-icon-copy-document operationIco"></i>
              <div class="operationBtn" >复制任务</div>
            </div>
          </div>
          <OrderShare :order="order" style="margin-top:10px;" class="flexBtn"  :mobiletype="taskInfo.mobiletype" v-if="order.status == 12">
            <i class="el-icon-share operationIco"></i>
            <div class="operationBtn" >分享任务</div>
          </OrderShare>
          <div class="flexBtn" style="margin-top:10px;" v-if="order.status ==12">
            <div @click="editOrder()">
              <i class="el-icon-edit-outline operationIco"></i>
              <div class="operationBtn" >修改任务</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if="order.status==15||order.status==16||order.status==20 || order.type == 2">
            <div @click="showOrderVoucher()">
              <i class="el-icon-edit-outline operationIco"></i>
              <div class="operationBtn" >下单凭证</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if="order.status ==15&&isSingle">
            <div @click="showExpress()">
              <i class="el-icon-edit-outline operationIco"></i>
              <div class="operationBtn" >上传商家物流</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if="order.status != 13 && order.status != 12 && order.status != 11&&order.status!=30&&isSingle&&order.type==0">
            <div @click="showProductCancel()">
              <i class="el-icon-circle-close operationIco"></i>
              <div class="operationBtn" >取消商品</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if="order.status != 13 && order.status != 12 && order.status != 11&&order.status!=30&&isSingle&&order.type==2&&order.status!=16">
            <div @click="showProductCancel()">
              <i class="el-icon-circle-close operationIco"></i>
              <div class="operationBtn" >取消商品</div>
            </div>
          </div>
          <div v-if="isSingle && order.status != '30' && order.status != '20'" style="margin-top:9px;" class="flexBtn">
            <div @click="openModify()">
              <span class="moneyIco operationIco"></span>
              <div class="operationBtn" >修改费用</div>
            </div>
          </div>
          <div v-if="isSingle && order.status == '30' && showRefundTip" style="margin-top:9px;" class="flexBtn">
            <div @click="openModify()">
              <span class="moneyIco operationIco"></span>
              <div class="operationBtn" >退款</div>
            </div>
          </div>

        </div>
      </div>

      <div class="detail-body">
        <p>任务#{{order.order_no}}</p>
        <p>商家{{order.business_name}}</p>
        <p>创建日期{{order.create_time.replace(/\s.*/, '')}}</p>
      </div>
      <div class="detail-body">
        <h2>任务总计</h2>
        <ul class="popover-price">
          <li><span>商品</span> {{order.total_fee | currency(order.currency_symbol)}}</li>
          <li v-if="order.fee_adjustment_list.length > 0"><span>消费税</span><del v-if="order.fee_adjustment_list[0].original_tax_fee != order.fee_adjustment_list[0].tax_fee">{{order.fee_adjustment_list[0].original_tax_fee | currency(order.currency_symbol)}}</del> {{order.fee_adjustment_list[0].tax_fee | currency(order.currency_symbol)}}</li>
          <li v-if="order.fee_adjustment_list.length == 0"><span>消费税</span> {{order.tax_amount | currency(order.currency_symbol)}}</li>
          <li v-if="order.fee_adjustment_list.length > 0"><span>商家运费</span><del v-if="order.fee_adjustment_list[0].original_transport_fee != order.fee_adjustment_list[0].transport_fee">{{order.fee_adjustment_list[0].original_transport_fee | currency(order.currency_symbol)}}</del> {{order.fee_adjustment_list[0].transport_fee | currency(order.currency_symbol)}}</li>
          <li v-if="order.fee_adjustment_list.length == 0"><span>商家运费</span> {{order.transport_amount | currency(order.currency_symbol)}}</li>
          <li v-if="order.fee_adjustment_list.length > 0"><span>其他费用</span><del v-if="order.fee_adjustment_list[0].original_other_fee != order.fee_adjustment_list[0].other_fee">{{order.fee_adjustment_list[0].original_other_fee | currency(order.currency_symbol)}}</del> {{order.fee_adjustment_list[0].other_fee | currency(order.currency_symbol)}}</li>
          <li v-if="order.fee_adjustment_list.length == 0"><span>其他费用</span> {{order.other_amount | currency(order.currency_symbol)}}</li>
          <li><span>汇率</span> {{$decimalFormat(Number(order.conditions.rate),4)}}</li>
          <li v-if="order.fee_adjustment_list.length > 0"><span>商家小计</span> {{$decimalFormat((Number(order.total_fee) + Number(order.fee_adjustment_list[0].tax_fee) + Number(order.fee_adjustment_list[0].transport_fee) + Number(order.fee_adjustment_list[0].other_fee)),2) | currency(order.currency_symbol)}}/{{$deciamlFormat(((Number(order.total_fee) + Number(order.fee_adjustment_list[0].tax_fee) + Number(order.fee_adjustment_list[0].transport_fee) + Number(order.fee_adjustment_list[0].other_fee))*Number(order.conditions.rate)),2) | currency('¥')}}</li>
          <li v-if="order.fee_adjustment_list.length == 0"><span>商家小计</span> {{order.total_amount | currency(order.currency_symbol)}}/{{order.rmb_total_amount | currency('¥')}}</li>
          <li><span>优惠码</span> {{order.coupon_text}}</li>
          <hr class="line">
          <li v-if="order.fee_adjustment_list.length > 0"><span>国际运费</span><del v-if="order.fee_adjustment_list[0].original_package_forwarding_fee != order.fee_adjustment_list[0].package_forwarding_fee">{{order.fee_adjustment_list[0].original_package_forwarding_fee | currency('¥')}}</del> {{order.fee_adjustment_list[0].package_forwarding_fee  | currency('¥')}}</li>
          <li v-if="order.fee_adjustment_list.length == 0"><span>国际运费</span> {{order.transport_amount_rmb | currency('¥')}}</li>
          <li v-if="order.fee_adjustment_list.length > 0"><span>总计</span> {{$decimalFormat(((Number(order.total_fee) + Number(order.fee_adjustment_list[0].tax_fee) + Number(order.fee_adjustment_list[0].transport_fee) + Number(order.fee_adjustment_list[0].other_fee))*Number(order.conditions.rate) + Number(order.fee_adjustment_list[0].package_forwarding_fee)),2) | currency('¥')}}</li>
          <li v-if="order.fee_adjustment_list.length == 0"><span>总计</span> {{order.rmb_total_amount | currency('¥')}}</li>
          <li v-if="order.fee_adjustment_list.length > 0"><div v-if="order.fee_adjustment_list[0].status=='0'"><span>待支付</span> {{order.fee_adjustment_list[0].unpaid_fee_rmb  | currency('¥')}}</div></li>
          <li v-if="order.fee_adjustment_list.length > 0"><div v-if="order.fee_adjustment_list[0].status=='3'"><span>待退款</span> {{order.fee_adjustment_list[0].unpaid_fee_rmb.replace('-','')  | currency('¥')}}</div></li>
          <li v-if="order.fee_adjustment_list.length > 0"><div v-if="order.fee_adjustment_list[0].status!='0' && order.fee_adjustment_list[0].status!='3'"><span>待支付</span> {{0.00  | currency('¥')}}</div></li>
          <li v-if="order.fee_adjustment_list.length == 0 && order.status == '12'"><span>待支付</span> {{order.rmb_total_amount | currency('¥')}}</li>
          <li v-if="order.fee_adjustment_list.length == 0 && order.status != '12'"><span>待支付</span> {{0.00 | currency('¥')}}</li>
        </ul>
      </div>
      <div class="detail-body">
        <h2>寄至</h2>
        <SingleAddress :address="order.address"></SingleAddress>
      </div>
      <div class="detail-body">
        <h2>响应时间</h2>
        <p v-if="order.status < 13">{{order.conditions.response_hours}}</p>
        <p v-if="(order.status == 13 || order.status == 14) && this.order.conditions.response_hours.indexOf('小时内响应') > -1 && this.order.take_time">下单还剩 {{order.take_time}}</p>
        <p v-if="(order.status == 13 || order.status == 14) && this.order.conditions.response_hours == '尽快响应' && this.order.take_time">尽快响应</p>
      </div>
      <div class="detail-body">
        <h2>下单说明</h2>
        <p v-if="order.buyer_account_id > 0 && isSingle && order.buyer.email" class="clearfix" style="margin-top: 5px;">
          <span style="display:inline-block;float:left;margin-right:5px;">
            联系邮箱:
          </span>
          <span style="display:inline-block;width:160px;float:left;word-break:break-all;">
            {{order.buyer.email}}
          </span>
        </p>
        <p style="margin-top: 5px;">
          <span style="display:inline-block;float:left;margin-right:5px;">
            缺货处理：
          </span>
          <span style="display:inline-block;width:160px;float:left;word-break:break-all;">
            {{lackDisplay[order.conditions.check_full_goods?order.conditions.check_full_goods:0]}}
          </span>
        </p>

        <p v-if="order.realRemark" class="clearfix" style="margin-top: 5px;">
          <span style="display:inline-block;float:left;">备注：</span>
          <span style="display:inline-block;width:140px;float:left;">{{order.realRemark}}</span>
        </p>
        <p  class="clearfix" style="margin-top: 5px;">
          <span v-if="order.support_transport_service == '1'">无需下单人提供转运服务</span>
          <span v-if="order.support_transport_service == '2'">需下单人提供转运服务</span>
        </p>
      </div>
    </el-dialog>
    <el-dialog v-if="completion" class="el-dialog-sm el-dialog-sm-h3"  :lock-scroll="true" :visible.sync="completion" width="90%" @close="closeCompletion()">
      <div class="text-center redirct">
        <p><i class="ico ico-paysucces completion"></i></p>
        <h1 style="padding: 60px 0 25px;">{{operationType}}</h1>
        <p v-if="status && status != 12&&refund!=null">若非私下付款,{{refund}}元退款将于24小时内原路返回至{{name}}的支付账户。<span v-if="showRefundTip">任务中还有(转费/其他费用/转运费)未退款,可前往'任务总计'退款</span></p>
        <p v-if="status && status != 12&&refund==null">请通过修改费用退还商品金额。<span v-if="showRefundTip">任务中还有(转费/其他费用/转运费)未退款,可前往'任务总计'退款</span></p>
        <p v-if="!status && !operation && !confirm && !isBuyAgain">您的收货地址已经更换</a></p>
        <p v-if="!status && !operation && confirm">若非私下付款,任务金额已进入下单人账户</a></p>
        <!--<p class="tip" style="margin-top: 10px;" v-if="!status && operation && operation!='转运'">
          请将商家邮件转发至 <a href="mailto:OrderTrack@joyorders.com">OrderTrack@joyorders.com</a>
        </p>-->
      </div>
    </el-dialog>
    <el-dialog v-if="isBuy" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :visible.sync="isBuy" width="90%" @close="showForm = false">
      <h1 class="buyTitle">再次购买</h1>
      <div>
        <p class="website-name">{{order.business.name}}</p>
        <p class="website-url" v-for="(b,index) in order.business.website.split(',')" :key="index">{{b}}</p>
      </div>
      <ul class="buyContent">
        <li class="clearfix">
          <div class="content-container">
            <div class="clearfix">
              <div class="img-container">
                <a href="javascript:void(0)" @click="navToProduct(goods)">
                  <img v-if="goods.picture" :src="goods.picture"/>
                  <img  v-else src="https://pic.joyorders.com/blank.png"/>
                </a>
              </div>
              <div class="line-des">
                <p class="name"><a :href='goods.website.substr(0,7).toLowerCase() == "http://" || goods.website.substr(0,8).toLowerCase() == "https://" ? goods.website : "http://"+ goods.website' target="_blank">{{goods.name}}</a></p>
                <!-- <p><span>规格：</span>{{goods.spec}}</p> -->
                <div class="spec">
                  <span>规格：</span>
                  <span v-html="formatSpec(goods.spec)"></span>
                </div>
                <div v-if="goods.discounted_price !== goods.price">
                  <a class="order-price">{{(goods.discounted_price)|currency(order.currency_symbol)}}</a>
                  <del class="order-price"> {{(goods.price)|currency(order.currency_symbol)}}</del>
                </div>
                <div v-if="goods.discounted_price == goods.price">
                  <p class="order-price"> {{(goods.price)|currency(order.currency_symbol)}}</p>
                </div>
                <el-select v-model="form.number" class="inline-block">
                  <el-option
                    v-for="item in 100"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="!isSingle" class="block" type="primary" @click="submit(order,goods)"><div class="addCart"></div>加入购物车</el-button>
        <el-button v-if="isSingle" class="block" type="primary" @click="taskInfoSubmit(order,goods)"><div class="addCart"></div>加入购物车</el-button>
      </div>
      <el-dialog
        width="30%"
        :visible.sync="warning"
        append-to-body>
        <h1 style="text-align:center; padding: 0 0 30px;">提示</h1>
        <p>该商品与购物车内已存在商品的商家网址不一样,继续操作将覆盖购物车内商品</p>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="isSingle" class="block" type="primary" @click="coverSubmit(order,goods)">确认</el-button>
        </div>
      </el-dialog>
    </el-dialog>
    <el-dialog v-if="showModify" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="showModify" :lock-scroll="true" width="90%" @close="step = 1">
      <h3 class="text-center"><i v-if="step>1" class="el-icon-arrow-left back" @click="step--"></i>{{modifyTitle}}</h3>
      <div v-if="step == 1">
        <el-form ref="modifyPrice" :model="modifyPrice" :rules="rules" class="dialog-form">
          <ul class="error-messages" v-if="!isEmptyErrors">
            <li v-for="error in errors">{{error[0].message}}</li>
          </ul>
          <el-form-item label="" class="modify-price">
            <div>
              <span>商品</span>{{modify_price_info.goods_price.value | currency(order.currency_symbol)}}
            </div>
          </el-form-item>
          <el-form-item label="" prop="tax_fee" v-if="order.type!=2">
            <div>
              <div class="modify">
                <div class="edit_modify_div" @click="show_modify_tax_fee=true">
                  <span>消费税</span><i v-show="(!showRefundTip && order.status<=14) || (showRefundTip && Number(defaultModify.tax_fee) != 0) && !show_modify_tax_fee"
                  class="el-icon-edit-outline edit_modify"></i>{{modifyPrice.tax_fee | currency(order.currency_symbol)}}
                </div>
              </div>
            </div>
            <div v-if="(!showRefundTip && order.status<=14) || (showRefundTip && Number(defaultModify.tax_fee) != 0)" v-show="show_modify_tax_fee">
              <YueDanIpt :reg="/^\d+\.?\d{0,2}$/" model="tax_fee" :object="modifyPrice" placeholder="消费税" :append="order.currency"></YueDanIpt>
              <div style="display:flex;margin-top:10px;justify-content: space-between;">
                <el-button style="width:48%;height:50px;" @click.stop="cancelModify('tax_fee')">取 消</el-button>
                <el-button style="width:48%;height:50px;" type="info" @click.stop="confirmModify('tax_fee')">确 定</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="" prop="transport_fee" v-if="order.type!=2">
            <div>
              <div class="modify">
                <div class="edit_modify_div" @click="show_modify_transport_fee=true">
                  <span>商家运费</span><i v-show="(!showRefundTip && order.status<=14) || (showRefundTip &&  Number(defaultModify.transport_fee) != 0) && !show_modify_transport_fee"
                  class="el-icon-edit-outline edit_modify"></i>{{modifyPrice.transport_fee | currency(order.currency_symbol)}}
                </div>
              </div>
            </div>
            <div v-if="(!showRefundTip && order.status<=14) || (showRefundTip &&  Number(defaultModify.transport_fee) != 0)" v-show="show_modify_transport_fee">
              <YueDanIpt :reg="/^\d+\.?\d{0,2}$/" model="transport_fee" :object="modifyPrice" placeholder="商家运费" :append="order.currency"></YueDanIpt>
              <div style="display:flex;margin-top:10px;justify-content: space-between;">
                <el-button style="width:48%;height:50px;" @click.stop="cancelModify('transport_fee')">取 消</el-button>
                <el-button style="width:48%;height:50px;" type="info" @click.stop="confirmModify('transport_fee')">确 定</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="" prop="other_fee" v-if="order.type!=2">
            <div>
              <div class="modify">
                <div class="edit_modify_div" @click="show_modify_other_fee=true">
                  <span>其他费用</span><i v-show="(!showRefundTip && order.status<=14) || (showRefundTip && Number(defaultModify.other_fee) != 0) && !show_modify_other_fee"
                  class="el-icon-edit-outline edit_modify"></i>{{modifyPrice.other_fee | currency(order.currency_symbol)}}
                </div>
              </div>
            </div>
            <div v-if="(!showRefundTip && order.status<=14) || (showRefundTip && Number(defaultModify.other_fee) != 0)" v-show="show_modify_other_fee">
              <YueDanIpt :reg="/^\d*\.?\d{0,2}$/" model="other_fee" :object="modifyPrice" placeholder="其他费用" :append="order.currency"></YueDanIpt>
              <div style="display:flex;margin-top:10px;justify-content: space-between;">
                <el-button style="width:48%;height:50px;" @click.stop="cancelModify('other_fee')">取 消</el-button>
                <el-button style="width:48%;height:50px;" type="info" @click.stop="confirmModify('other_fee')">确 定</el-button>
              </div>
            </div>
          </el-form-item>
          <div class="modify-price">
            <div>
              <span>汇率</span>{{order.conditions.rate}}
            </div>
            <div>
              <span>商家小计</span>{{totalBusinessPrice}}
            </div>
          </div>
          <div class="modify-price">
            <div>
              <span>服务费</span>{{modify_price_info.service_price.value | currency(order.currency_symbol)}}
            </div>
          </div>
          <div class="modify-price" v-if="modify_price_info.discount_price && modify_price_info.original_discount_price && (modify_price_info.discount_price.value!='0.00' || modify_price_info.original_discount_price.value!='0.00')">
            <div>
              <span>下单优惠</span>-{{modify_price_info.discount_price.value | currency(modify_price_info.discount_price.currency_symbol)}}
            </div>
          </div>
          <div v-if="discount_rule.discount_price" style="float: right;text-align: right;margin: -10px 0 10px;">
            <div v-if="order.joyorders_promo_code" class="promo_code">
              {{order.joyorders_promo_code}}
            </div>
            <div>{{discount_rule.discount_price}}</div>
          </div>
          <div v-if="order.service_type != 1" class="modify-price">
            <div>
              <div v-if=" order.type == 2 " >
                <div v-if="modify_price_info.international_transport_price.charge_type == 2" >
                 <span>国际运费</span>包邮
                </div>
                <div class="edit_modify_div" v-else @click="show_modify_package_forwarding_fee=true">
                  <span>国际运费</span><i v-show="modify_price_info.international_transport_price.charge_type == 1 && !show_modify_package_forwarding_fee"
                  class="el-icon-edit-outline edit_modify" ></i>{{modify_price_info.international_transport_price.value | currency('¥')}}
                </div>
              </div>

              <div v-else>
                <div v-if="modify_price_info.international_transport_price.charge_type == 2" >
                 <span>国际运费</span>包邮
                </div>
                <div class="edit_modify_div" v-else @click="show_modify_package_forwarding_fee=true">
                  <span>国际运费</span><i v-show="modify_price_info.international_transport_price.charge_type == 1 && !show_modify_package_forwarding_fee"
                  class="el-icon-edit-outline edit_modify" ></i>{{modify_price_info.international_transport_price.value | currency('¥')}}
                </div>
              </div>

              <div v-if="modify_price_info.international_transport_price.charge_type == 1" v-show="show_modify_package_forwarding_fee">
                <YueDanIpt :reg="/^\d*\.?\d{0,2}$/"  model="package_forwarding_fee" :object="modifyPrice" placeholder="国际运费" :append="'CNY'"/>
                <div style="display:flex;margin-top:10px;justify-content: space-between;">
                  <el-button style="width:48%;height:50px;" @click.stop="cancelModify('package_forwarding_fee')">取 消</el-button>
                  <el-button style="width:48%;height:50px;" type="info" @click.stop="confirmModify('package_forwarding_fee')">确 定</el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="modify-price" >
            <div>
              <span>总计</span>{{totalPrice | currency('¥')}}
            </div>
            <div><span>{{modify_price_info.payment_status}}</span> {{needPaid | currency('¥')}}</div>

          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="block" type="primary" style="margin-bottom:30px;" @click="nextStep()">确 定</el-button>
        </div>
      </div>
      <div v-if="step == 2">
        <!-- <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)>0">费用修改后,买单人需支付{{needPaid.replace('-','')}}元。</h3> -->
        <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)>0 && this.modify_price_info.payment_status=='待支付'">费用修改后,买单人需支付{{Number(needPaid)}}元。</h3>
        <!-- <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)<0">费用修改后,{{needPaid.replace('-','')}}元将退还买单人。</h3> -->
        <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)>0 && this.modify_price_info.payment_status=='待退款'">费用修改后,{{$decimalFormat(Number(needPaid),2).replace('-','')}}元将退还买单人。</h3>
        <!-- <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)==0 && showRefundTip">费用修改后,{{needPaid.replace('-','')}}元将退还买单人。</h3> -->
        <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)==0 && showRefundTip">费用修改后,{{needPaid.replace('-','')}}元将退还买单人。</h3>
        <!-- <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)==0 && !showRefundTip">费用修改后,买单人需支付{{needPaid.replace('-','')}}元。</h3> -->
        <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)==0 && !showRefundTip">费用修改后,买单人需支付{{needPaid.replace('-','')}}元。</h3>
        <el-button :loading="loading" class="block" style="margin-bottom:30px;" type="primary" @click="submitModify()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="modifySuccess" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :visible.sync="modifySuccess" width="90%" @close="showForm = false">
      <div class="text-center redirct">
        <p><i class="ico ico-paysucces completion"></i></p>
        <h1 style="padding: 60px 0 25px;">{{modifyTitle}}成功</h1>
        <p v-if="Number(needPaid)>0 && this.real_price_info.payment_status=='待退款'">已邮件通知买单人,{{needPaid.replace('-','')}}元退款将于10分钟内退款至买单人的支付账户。</p>
        <p v-if="Number(needPaid)>0 && this.real_price_info.payment_status=='待支付'">已邮件通知买单人,{{needPaid.replace('-','')}}元待支付。</p>
        <p v-if="Number(needPaid)==0 && showRefundTip">已邮件通知买单人,{{needPaid.replace('-','')}}元退款将于10分钟内退款至买单人的支付账户。</p>
        <p v-if="Number(needPaid)==0 && !showRefundTip">已邮件通知买单人,{{needPaid.replace('-','')}}元待支付。</p>
      </div>
    </el-dialog>
    <el-dialog v-if="showCopy" class="el-dialog-sm el-dialog-sm-h3" center :close-on-click-modal="false" :visible.sync="showCopy" width="90%" @close="showCopy = false">
      <div class="text-center">
        <h1 style="padding: 10px 0 30px;">确定复制该任务?</h1>
        <el-button @click="showCopy = false">取 消</el-button>
        <el-button type="primary" @click="copyOrderSuccess()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog width="30%" :close-on-click-modal="false" :visible.sync="offline" @close="offLine = false">
      <h1 style="text-align:center; padding: 0 0 30px;">提示</h1>
      <p>此下单任务为私下支付, 请确认收到付款再下单</p>
      <div slot="footer" class="dialog-footer" style="margin-top:10px;">
        <el-button @click="offline = false">取消</el-button>
        <el-button type="primary" @click="Submit()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog class="customDialog" width="300px" style="text-align:center;" :close-on-click-modal="false" :visible.sync="trackVisible" @close="trackVisible = false">
      <img :src="src" />
    </el-dialog>

    <el-dialog class="el-dialog-sm el-dialog-sm-h3" center :close-on-click-modal="false" :visible.sync="assignBuyerVisible" width="90%" @close="assignBuyerVisible = false">
      <div class="text-center">
        <div style="margin-bottom:10px;">
          <el-select clearable
          class="customheight_auto" style="width:100%;"
          v-model="order_buyer_id" placeholder="指定下单买手">
                    <el-option
                      v-for="item in buyers"
                      :key="item.single_username"
                      :label="item.single_username"
                      :value="item.single_account_id">
                    </el-option>
          </el-select>
        </div>
        <div style="margin-bottom:10px;">
          <el-select clearable
          class="customheight_auto" style="width:100%;"
          v-model="transport_buyer_id" placeholder="指定转运买手">
                    <el-option
                      v-for="item in buyers"
                      :key="item.single_account_id"
                      :label="item.single_username"
                      :value="item.single_account_id">
                    </el-option>
          </el-select>
        </div>
        <el-button @click="assignBuyerVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAssignBuyer()">确 定</el-button>
      </div>
    </el-dialog>

    <OrderDelegateDialog ref="OrderDelegateDialog" style="display:inline-block;margin-top: 10px;" :order="order" :buyers="singleList" :expressList="expressList" :addressList="addressList" :delegates="delegates"></OrderDelegateDialog>
    <UploadExpressDialog ref="UploadExpressDialog" @showChooseImage="showChooseImage" style="display:inline-block;margin-top: 10px;" :order="order"  v-on:complete="complete"></UploadExpressDialog>
    <ProductCancelDialog ref="ProductCancelDialog" :isSingle="isSingle" @refresh="updatePriceInfo" v-on:lineChange="initData" v-on:complete="complete" :order="order" style="display:inline-block;margin-top: 10px;" @showChooseImage="showChooseImage"></ProductCancelDialog>
    <CallBackDialog ref="CallBackDialog" :isSingle="isSingle" :order="order" style="display:inline-block;margin-top: 10px;" @showChooseImage="showChooseImage"></CallBackDialog>
    <PackageCancelDialog ref="PackageCancelDialog" :isSingle="isSingle" @refresh="updatePriceInfo" v-on:lineChange="initData" v-on:complete="complete" :order="order" style="display:inline-block;margin-top: 10px;" @showChooseImage="showChooseImage"></PackageCancelDialog>
    <OrderVoucher @selectProductImage="selectProductImage" :isSingle="isSingle" :needChoose="needChooseImage" :order="order" style="display:block;" :role="role"></OrderVoucher>

    <AddressDialog v-if="['11'].indexOf(order.status) > -1 && !isSingle"  :address-id="order.address_id" v-on:success="updateAddress" v-on:complete="complete" style="display:block;margin-top: 10px;" :order="order"></AddressDialog>

    <OrderCancelDialog v-if="['11', '13'].indexOf(order.status) > -1&&!isSingle" style="margin-top:10px;" class="flexBtn" :mobiletype="taskInfo.mobiletype" :isSingle="isSingle" :order="order" v-on:complete="complete" @refresh="updatePriceInfo"></OrderCancelDialog>
    <OrderCancelDialog v-if="['11','12', '13','14'].indexOf(order.status) > -1&&isSingle" style="margin-top:10px;" class="flexBtn" :mobiletype="taskInfo.mobiletype" :isSingle="isSingle" :order="order" v-on:complete="complete" @refresh="updatePriceInfo"></OrderCancelDialog>
    <UploadOrderDialog :totalAccountList="allAccountList" :normal_address_show="normal_address_show" style="display:block;" :order="order" :mobiletype="taskInfo.mobiletype" v-on:complete="complete" :expressList="expressList" :delegates="delegates" :singleList="singleList" :bindedAccountList="bindedAccountList"></UploadOrderDialog>
    <DaigouOrderDialog style="display:block;" :order="order" v-on:complete="complete"></DaigouOrderDialog>
    <ModifyOrderDialog :totalAccountList="allAccountList" :normal_address_show="normal_address_show" style="display:block;" :order="order" :mobiletype="taskInfo.mobiletype" v-on:complete="complete" :expressList="expressList" :delegates="delegates" :singleList="singleList"></ModifyOrderDialog>
    <AddAddressToTransportDialog :role="role" :order="order" :mobiletype="taskInfo.mobiletype" v-on:complete="getAddrFromStore" :expressList="expressList" :supportEditAccountList="supportEditAccountList" :supportAccountList="supportAccountList"></AddAddressToTransportDialog>
    <FeePromotionDialog :order="order" :mobiletype="taskInfo.mobiletype" @refresh="updatePriceInfo"></FeePromotionDialog>
    <AfterSaleDialog :order="order" :order_discount_rule="discount_rule" :total_price="real_price_info?real_price_info.total_price.value:''" :mobiletype="taskInfo.mobiletype" @refresh="updatePriceInfo"></AfterSaleDialog>
    <ExceptionManageDialog :exceptionTypes="exceptionTypes" :replyTemplateList="replyTemplateList" @updateOrder="updateOrderHandler" :order="order" :maishouenable="maishouenable" :mobiletype="taskInfo.mobiletype"
    :currentEx="currentEx" :ticketStatus="ticketStatus" :ticketVisible="ticketVisible" :ticketPriorities="ticketPriorities" :singleList="ticketAccounts" :ticketTypes="ticketTypes" @refreshEXList="refreshEXList"></ExceptionManageDialog>
    <AddExceptionDialog :order="order" :exceptionTemplateList="exceptionTemplateList" :exceptionTypes="exceptionTypes" @refreshEXList="refreshEXList"
    :exceptionCategories="exceptionCategories" :mobiletype="taskInfo.mobiletype" @createTicket="showAddTicket"></AddExceptionDialog>
    <ModifyDelegateDialog :order="order" :delegates="delegates" :mobiletype="taskInfo.mobiletype" :buyers="singleList" v-on:complete="complete"></ModifyDelegateDialog>
    <OrderLogDialog :order="order" ></OrderLogDialog>
    <AddTicketDialog :order="order" :ticketStatus="ticketStatus" :ticketVisible="ticketVisible" :expressList="expressList" :merchants="merchants" :exceptionTypes="exceptionTypes"
    :ticketPriorities="ticketPriorities" :singleList="ticketAccounts" :ticketTypes="ticketTypes" @fetchTicket="fetchTickets"></AddTicketDialog>
    <AddAmountBillDialog :order="order"
                         :businessOption="merchants"
                         :subTotal="real_price_info"
                         :feeItemTypeList="fee_item_type_list"
                         :calculatingMethodList="calculating_method_list"
                         :calculatingMethodDetail="calculating_method_detail"
                         :billStatusList="bill_status_list"
                         :formData="amountBillForm"
                         @addBillBack="addBillBack"
    ></AddAmountBillDialog>
    <vue-canvas-poster v-show="trackVisible" :widthPixels="0" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
  <Created
    :businessOption="merchants"
    :feeItemTypeList="fee_item_type_list"
    :calculatingMethodList="calculating_method_list"
    :calculatingMethodDetail="calculating_method_detail"
    :billStatusList="bill_status_list"
    :formData="formData1"
    >

    <el-button class="dis-none"  :id="`amountBillButton${order.id}`" type="primary">新增账单</el-button>
  </Created>

  <el-dialog v-if="productDetailVisible" top="0" class="el-dialog-sm custom-width-dialog-900 no-padding" :show-close="false" :visible.sync="productDetailVisible" width="auto">
      <PRODUCT isPopUp="1" :productId="product_id"></PRODUCT>
  </el-dialog>
  </div>
</template>

<script>
import OrderDelegateDialog from './single/OrderDelegateDialog'
import UploadExpressDialog from './single/UploadExpressDialog'
import ModifyDelegateDialog from './single/ModifyDelegateDialog'
import ProductCancelDialog from './single/ProductCancelDialog'
import CallBackDialog from './single/CallBackProductDialog'
import PackageCancelDialog from './single/PackageCancelDialog'
import UploadOrderDialog from './single/UploadOrderDialog'
import DaigouOrderDialog from './single/DaigouOrderDialog'
import ModifyOrderDialog from './single/ModifyOrderDialog'
import AddAddressToTransportDialog from './single/AddAddressToTransport'
import FeePromotionDialog from './single/FeePromotionDialog'
import AfterSaleDialog from './single/AfterSaleDialog'
import ExceptionManageDialog from './single/ExceptionManage'
import AddExceptionDialog from './single/AddException'
import AddTicketDialog from '../ticket/AddTicket'
import OrderLogDialog from './single/OrderLogs'
import AddAmountBillDialog from '../amount_bill/Create'
import Ticket from '../ticket/TicketBody.vue'
import OrderVoucher from './OrderVoucher'
import OrderShare from './OrderShare'
import Mail from '../mail/MailBody'
import Daigou from '../daigou/DaigouBody'
import AddressDialog from '../../publish_task/address/AddressDialog'
import OrderCancelDialog from './OrderCancelDialog'
import SingleAddress from '../../publish_task/address/SingleAddress'
import OrderOperation from './OrderOperation'
import OrderState from './OrderState'
import api from '../../../services/api.js'
import ChatContainer from '../../../components/chat/ChatContainer'
import YueDanIpt from '../../../components/YueDanIpt'
import Clipboard from 'clipboard'
import { ADMIN_HOST,lackDisplay,SPEC_MAPPER } from '../../../services/constant.js'
import {showProductName,formatSpec} from '../../../services/tools.js'
import BillBody from '../express_bill/BillBody'
import BillCollapseBody from '../amount_bill/BillCollapseBody'
import {handleStyle} from "../../../services/tools";
import PRODUCT from "../../../components/ProductDetail"
import Created from '../amount_bill/Create'
let _ = require('lodash')
let $ = require('jQuery')
export default {
  name: 'Order',
  props: ['needGetTicket','needGetMail','order', 'bussinessList', 'singleList', 'isSingle', 'trackTask','exceptionTypes','exceptionCategories','exceptionTemplateList','replyTemplateList'
  ,'expressList','delegates','buyers','supportAccountList','supportEditAccountList','transportStatusArray','addressList','showHead'
  ,'ticketAccounts','ticketStatus','ticketPriorities','ticketTypes','ticketVisible','merchants','bindedAccountList','replyTemplate'],
  components: {
    PRODUCT:PRODUCT,
      Created:Created,
      BillCollapseBody:BillCollapseBody,
    SingleAddress: SingleAddress,
    OrderOperation: OrderOperation,
    OrderState: OrderState,
    ChatContainer,
    OrderShare: OrderShare,
    AddressDialog: AddressDialog,
    Mail:Mail,
    Daigou:Daigou,
    OrderCancelDialog: OrderCancelDialog,
    ExceptionManageDialog:ExceptionManageDialog,
    AddExceptionDialog:AddExceptionDialog,
    AddTicketDialog:AddTicketDialog,
    OrderLogDialog:OrderLogDialog,
    Ticket:Ticket,
    YueDanIpt: YueDanIpt,
    UploadExpressDialog: UploadExpressDialog,
    ProductCancelDialog: ProductCancelDialog,
    CallBackDialog:CallBackDialog,
    PackageCancelDialog:PackageCancelDialog,
    UploadOrderDialog: UploadOrderDialog,
    DaigouOrderDialog:DaigouOrderDialog,
    ModifyOrderDialog:ModifyOrderDialog,
    ModifyDelegateDialog:ModifyDelegateDialog,
    OrderVoucher: OrderVoucher,
    OrderDelegateDialog,
    AddAddressToTransportDialog,
    FeePromotionDialog,
    AfterSaleDialog,
    BillBody,
      AddAmountBillDialog
  },
  computed: {
    isLastFromUser(){
      return function(ex){
        let remarkArr=ex.description.split('&remark&');
        let last_remarkArr = remarkArr[remarkArr.length-1];
        let r = last_remarkArr.split('^&*');
        if(r.length==4){
          let role = r[r.length-1];
          if(role!='1')
            return true
          else
            return false
        }
        else{
            return false
        }
      }
    },
    ticketStatusDisplayForTitle(){
      return (status_id)=>{
        if(status_id){
          let name = { title:'',subtitle:'' }
          for(var i=0,length=this.ticketStatus.length;i<length;i++){
            let o = this.ticketStatus.find(i=>i.id==status_id)
            if(o){
              name.title = o.name
              break;
            }
          }
          if(!name.title){
            for(var i=0,length=this.ticketStatus.length;i<length;i++){
              if(this.ticketStatus[i].next_level_list.length){
                let o_o = this.ticketStatus[i].next_level_list.find(i=>i.id==status_id)
                if(o_o){
                  let t = o_o.name.split('-')
                  name.title=t[0]
                  name.subtitle=t[1]
                  break;
                }
              }
            }
          }
          return name
        }
        else
          return { title:'',subtitle:'' }
        }
    },
    ticketTypeDisplay(){
      return (type_id)=>{
        if(type_id){
          let name=''
          for(var i=0,length=this.ticketTypes.length;i<length;i++){
            let o = this.ticketTypes[i].next_level_list.find(j=>j.id==type_id)
            if(o){
              name = o.name;
              break;
            }
          }
          return name
        }
        else
          return ''
      }
    },
    ticketPriorityDisplay(){
      return (priority_id)=>{
        if(priority_id)
          return this.ticketPriorities.find(i=>i.id==priority_id).name
        else
          return ''
      }
    },
    createtimedisplay(){
      let today=new Date()
      let yesterday=new Date(today.getTime() -24*60*60*1000)
      let today_string=this.$moment(today).format('YYYY-MM-DD')
      let yest_string=this.$moment(yesterday).format('YYYY-MM-DD')
      if(this.order.create_time.replace(/\s.*/, '')==today_string)
        return '今天';
      if(this.order.create_time.replace(/\s.*/, '')==yest_string)
        return '昨天';
      return this.order.create_time.replace(/\s.*/, '')
    },
    maishouenable(){
      //包含系统买手管理员role=1，商家买手管理员，普通任务买手
      return this.role==1 || this.order.single_account_id==this.account_id || (this.order.merchant_administrator_account_id_list && this.order.merchant_administrator_account_id_list.indexOf(this.account_id)>-1)
    },
    showDelegateText(){
      let t = false
      if(this.order.groupOrderLines){
        for(let key in this.order.groupOrderLines){
            if(this.order.groupOrderLines[key][0].status<4){
              t = true
            }
        }
      }
      return [13,14,15].indexOf(+this.order.status)>-1 && ((this.order.type!=2 && t) || this.order.type==2)  && this.order.noNeedPaid && this.maishouenable
    },
    packStatus(){
      if(this.order.fee_adjustment_list && this.order.fee_adjustment_list.length){
        switch(+this.order.fee_adjustment_list[0].status){
          case 0:
            return "待支付";
          case 2:
            return "已取消";
          case 3:
            return "未退款";
          case 4:
            return "已退款";
          case 5:
            return "无需操作";
        }
      }
      else
        return ""
    },
    orderStatus(){
      switch(+this.order.status){
        case 11:
          return "待接单";
        case 12:
          return "待支付";
        case 13:
          return "待下单";
        case 14:
          return "下单中";
        case 15:
          return "待发货";
        case 20:
          return "已完成";
        case 30:
          return "已取消"
        default:
          return "";
      }
    },
    zhuanyun_role_enable(){
      if([1,2].indexOf(+this.role)>-1 || this.order.single_account_id==this.account_id || this.order.transport_shipping_account_id==this.account_id || (this.order.merchant_administrator_account_id_list && this.order.merchant_administrator_account_id_list.indexOf(this.account_id)>-1 ))
        return true
      else
        return false
    },
    normal_address_show(){
      //anniee是外部买手，但是希望看到用户地址，所以目前单独写死。
      if(this.account_id=='17852' || [1,2,3].indexOf(+this.role)>-1 || this.order.single_account_id==this.account_id || this.order.transport_shipping_account_id==this.account_id || (this.order.merchant_administrator_account_id_list && this.order.merchant_administrator_account_id_list.indexOf(this.account_id)>-1))
        return true
      else
        return false
    },
    original_international_transport_price_text(){
      switch(+this.real_price_info.original_international_transport_price.charge_type){
        case 1:
          return '实收 '+((+this.real_price_info.original_international_transport_price.value)?this.real_price_info.original_international_transport_price.currency_symbol+this.real_price_info.original_international_transport_price.value:'待计算');
        case 2:
          return '包邮';
        case 3:
          return this.real_price_info.original_international_transport_price.currency_symbol+this.real_price_info.original_international_transport_price.value;
      }
    },
    international_transport_price_text(){
      switch(+this.real_price_info.international_transport_price.charge_type){
        case 1:
          return '实收 '+((+this.real_price_info.international_transport_price.value)?this.real_price_info.international_transport_price.currency_symbol+this.real_price_info.international_transport_price.value:'待计算');
        case 2:
          return '包邮';
        case 3:
          return this.real_price_info.international_transport_price.currency_symbol+this.real_price_info.international_transport_price.value;
      }
    },
    taskInfo () {
	    return this.$store.state.taskInfo
    },
    nim () {
      return this.$store.state.nim
    }
  },
  data () {
    var checkIsPrice = (rule, value, callback) => {
      if (value && (isNaN(value) || value < 0)) {
        callback(new Error('请输入正确的金额'))
      } else {
        callback()
      }
    }
    return {
      productDetailVisible:false,
      product_id:'',
        bill_settlement_status_list: [],//结算状态
        bill_status_list: [],//账单状态
        calculating_method_list: [],//结算方式
        fee_item_type_list: [],//结算类型
        payment_method_list: [],//支付方式,
        calculating_method_detail: [{}],
        amountBillForm:{},
        formData1: {},

      relationReset:false,
      showProductName:showProductName,
      formatSpec:formatSpec,
      daigouShow:false,
      mailShow:false,
      expressBillShow:false,
      amountBillShow:false,
      ticketShow:false,
      daigouactiveName:'0',
      mailactiveName: '0',
      expressActiveName:'0',
      amountBillActiveName:'0',
      ticketactiveName: '0',
      columns: [
        { name: '发送时间', field: 'send_time_display',width:'160px' },
        { name: '邮件内容', field: 'mail_content',width:'calc(100% - 360px)' },
        { name: '状态', field: 'status_display',width:'100px' },
      ],
        billColumns: [
            {name: '创建时间', field: 'create_time', width: '20%'},
            {name: '账单详情', field: 'detail', width: 'calc(100% - 30%)'},
            {name: '金额', field: 'amount', width: '10%'},
        ],
      expressBillColumns: [
        {name: '创建时间', field: 'time', width: '160px'},
        {name: '账单详情', field: 'detail', width: 'calc(100% - 360px)'},
        {name: '金额', field: 'price', width: '100px'},
      ],
      ticketcolumns: [
        { name: '工单', field: 'send_time_display',width:'26%' },
        { name: '工单内容', field: 'mail_content',width:'calc(100% - 410px)' },
        { name: '状态', field: 'status_display',width:'150px' },
      ],
      daigoucolumns: [
        { name: '发送时间', field: 'send_time_display',width:'160px' },
        { name: '代购内容', field: 'mail_content',width:'calc(100% - 360px)' },
        { name: '状态', field: 'status_display',width:'100px' },
      ],
      mailStatus:{'2':'待处理','1':'已处理','-1':'处理中...'},
      gettingMails:true,
      task_loading:false,
      //shipping_Arr:'',
      addExcetion:false,
      showXiadan:false,
      single_type:this.$localStorage.get('single_type'),
      //allBuyers:[],
      assignBuyerVisible:false,
      order_buyer_id:'',
      transport_buyer_id:'',
      discount_rule:{},
      lackDisplay:lackDisplay,
      //bindedAccountList:[],
      totalAccountList:[],
      allAccountList:[],
      addressStatusClass:'',
      isAlreadyInStore:false,
      supportCompareMerchants:[4563,4474,4309,4329,4479],
      currentCopy:{},
      showChooseImageType:'uploadexpress',
      merchantExpress:null,
      isFetchingMerchantExpress:false,
      compareExpressObj:{},
      isrefetching:false,
      real_price_info:null,
      constantGroupOrderLine:[{
        status:1
      }],
      modify_price_info:{},
      show_modify_package_forwarding_fee:false,
      show_modify_tax_fee:false,
      show_modify_transport_fee:false,
      show_modify_other_fee:false,
      trackVisible:false,
      painting:{
        width:`250px`,
        height:`400px`,
        background: '#fff',
        views: [
          {
            type: 'image',
            url: '',
            css: {
              width:`250px`,
              height:`250px`,
              mode:'aspectFill',
              left:'0',
              top: '0'
            }
          },
          {
            type: 'rect',
            css:
              {
                //paintingWidth:250,
                top:'250px',
                color:'#444',
                width:'250px',
                height:'25px'
              }

          },
          {
            type: 'text',
            text: '长按识别，跟踪包裹 >',
            css:
              {
                //paintingWidth:250,
                top:'255px',
                color:'#fff',
                fontSize: '13px',
                textAlign:'left',
                padding:'10px'
              }

          },
          {
            type: 'rect',
            css: {
              width:`100px`,
              height:`100px`,
              color:'#fff',
              borderRadius:'50px',
              right:'2px',
              top: '210px'
            }
          },
          {
            type: 'image',
            url: '',
            css: {
              width:`90px`,
              height:`90px`,
              right:'7px',
              top: '215px'
            }
          },
          {
            type: 'text',
            text: '',
            css:
              {
                top:'280px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
              }
          },
          {
            type: 'text',
            text: '',
            css:
              {
                top:'310px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
              }
          },
          {
            type: 'text',
            text: '',
            css:
              {
                top:'330px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
              }
          },
          /*{
            type: 'text',
            text: '',
            css:
              {
                top:'360px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
              }
          },*/
        ],
      },
      src:'',
      tickets:[],
      needChooseImage: false, // 显示选中图片
      editTotalFee: false, // 商品金额可编辑
      offline: false, // 线下支付弹框
      isOffLine: false, // 是否线下支付
      copyTxtSuccess: false,
      copyIdCardSuccess:false,
      transportList: [],
      packageIdIndex: -1,
      hoverIndex: -1,
      modifyTitle: '',
      showRefundTip: false,
      showCopy: false,
      groupOrderLine_temporary: null,
      packageId_temporary: null,
      showPackge: false,
      showDetail: false,
      screenWidth: document.body.clientWidth,
      screenWidthWee: document.body.clientWidth,
      mobiletype: false,
      step: 1,
      modifySuccess: false,
      innerVisible: false,
      fee_adjustment_list: [],
      loading: false,
      dialogFormVisible: false,
      errors: null,
      isEmptyErrors: true,
      showModify: false,
      currentOrder: {},
      totalProductPrice: null,
      totalBusinessPrice: null,
      totalPrice: null,
      needPaid: null,
      returnAmount: '0.00',
      timer: null,
      completion: false,
      status: null,
      operationType: '', // 操作类别
      type: '', // 商品or任务
      refund: '', // 退款
      name: '',
      operation: null, // 操作
      confirm: null, // 订单确认完成
      isBuy: false, // 再次购买
      isBuyAgain: false, // 再次购买是否成功
      warning: false, // 警告弹框
      goods: '', // 再次购买的商品
      businessList: [],
      env: window.env,
      form: {
        good_id: '',
        name: '',
        website: '',
        spec: '',
        price: '',
        picture: '',
        discounted_price: '',
        number: 1,
        currency: null,
        currency_symbol: null
      }, // 再次购买信息
      modifyPrice: {
        order_id: '',
        offline_payment: '0',
        tax_fee: '0',
        transport_fee: '0',
        other_fee: '0',
        package_forwarding_fee: '0'
      },
      defaultModify: {
        tax_fee: '0',
        transport_fee: '0',
        other_fee: '0',
        package_forwarding_fee: '0'
      },
      modifyAmount: {
        total_amount: ''
      },
      rules: {
        tax_fee: [
          { required: true, message: '消费税是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ],
        transport_fee: [
          { required: true, message: '商家运费是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ],
        other_fee: [
          { required: true, message: '商家运费是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ],
        package_forwarding_fee: [
          { required: true, message: '商家运费是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ]
      },
      role:this.$localStorage.get('role'),
      account_id:this.$localStorage.get('account_id'),
      validate_price_message_title:'',
      dizhiex_index:-1,
      chima_ex:[],
      shangping_ex:[],
      currentEx:0
    }
  },
  created () {
    let that = this
    this.isrefetching=true;
    this.initData()
    //this.getAllBuyers()
    window.onresize = () => {
      that.screenWidthWee = document.body.clientWidth
    }
  },
 async mounted(){
    this.refetchPriceData();
    if(this.needGetTicket)
      this.fetchTickets()
    this.fetchExpressBill();
    if(this.needGetMail && this.order.business_order_no)
      this.fetchMails();
    if(this.order.business.country!='JP')
      this.fetchDaigou()
    //1.  没有转运公司+加拿大商家的调用.      2. 转运公司有转运中国的时候调用.
    if((this.order.business_id=='4474' && this.order.transport_express_id=='0')||
    (this.order.transport_express_id!='0'))
      this.getAddrFromStore();
    if(this.order.exception_list){
      if(!this.isSingle){
        this.order.exception_list=this.order.exception_list.filter((i)=>{
          if(i.target_role_list && i.target_role_list.filter(t=>t.value==1).length==0)
            return false
          else
            return true
        })
      }
      this.refreshEXList();
    }
     let res2 = await api.getConfig(this);
     Object.keys(res2.body.result).map((item) => {
         this[item] = res2.body.result[item]
     });
    this.fetchAmountBill();

  },
  methods: {
    navToAdmin(id){
      let url = ADMIN_HOST+'/#/goods/create?good_id='+id
      window.open(url,'_blank')
    },
    getPayMethod(type){
      switch(type){
        case '2':
          return '微信支付';
        case '90':
          return 'AlphaPay(微信支付)';
        case '91':
          return 'AlphaPay(支付宝)';
        case '92':
          return 'AplphaPay(云闪付)';
      }
    },
    navToProduct(line){
      if(line.good_id && line.good_id!='0'){
        this.product_id = line.good_id;
        this.productDetailVisible=true;
      }
      else{
        if(line.website){
          let url = line.website.substr(0,7).toLowerCase() == "https://" || line.website.substr(0,8).toLowerCase() == "https://" ? line.website : "https://"+ line.website
          window.open(url)
        }
      }
    },
      addBillBack(){
          debugger

      },
      async updateBill(r) {
          let btn = document.getElementById('amountBillButton'+this.order.id);
          this.formData1 = JSON.parse(JSON.stringify(r));
          btn.click();
      },
      handleBill(r) {
          let noHtml;
          if (r.order_no_list && r.order_no_list.length === 1) {
              noHtml = `任务#${r.order_no_list[0]}`
          } else {
              noHtml = `${r.order_no_list.length}个任务`
          }
          let orderHtml;
          let merchant = this.merchants.find(i => i.merchant_id == r.merchant_order_info_list[0].merchant_id).merchant_name
          if (r.merchant_order_info_list && r.merchant_order_info_list.length === 1) {
              orderHtml = `${merchant}#${r.merchant_order_info_list[0].merchant_order_no}`
          } else {
              orderHtml = `${merchant}&nbsp;&nbsp;${r.merchant_order_info_list.length}个商家订单`
          }
          let html = `
                      <p style="font-size: 16px;padding-bottom: 5px;">${r.payee_user}#&nbsp;&nbsp;${r.bill_no}</p>

<p class="text-gray">
                        ${orderHtml}
                        ${noHtml}
                    </p>
`;
          return html;
      },
     async fetchAmountBill(){
      let res=  await api.getBillList(this,{order_no:this.order.order_no});
          this.order.amount_bill_list=res.body.result.map(item=>{
              if (item.create_time) {
                  item.date_display = this.generateDateDisplay(item.create_time.split(' ')[0])
                  item.time_display = item.create_time.split(' ')[1]
              }
              if (item.update_time) {
                  item.date_display2 = this.generateDateDisplay(item.update_time.split(' ')[0])
                  item.time_display2 = item.update_time.split(' ')[1]
              }
              return item;
          });
      },
    displaySource(s){
      switch(s){
        case "0":
          return 'PC端';
        case "1":
          return '小程序';
        case "2":
          return '苹果app';
        case "3":
          return '安卓app'
      }
    },
   checkShangpingEx(line){
    if(this.shangping_ex.length==0)
      return -1
    else{
      let r = -1;
      for(let i = 0;i<this.shangping_ex.length;i++){
        let ex = this.order.exception_list[this.shangping_ex[i]];
        let result = ex.product_list.findIndex((good)=>{
          return good.id==line.id && this.formatSpec(good.specification,line)==this.formatSpec(line.spec,line)
        })
        if(result!=-1){
          r = this.shangping_ex[i]
          break;
        }
      }
      return r;
    }
   },
   checkChimaEx(line){
    if(this.chima_ex.length==0)
      return -1
    else{
      let r = -1;
      for(let i = 0;i<this.chima_ex.length;i++){
        let ex = this.order.exception_list[this.chima_ex[i]];
        let result = ex.product_list.findIndex((good)=>{
          return good.id==line.id && this.formatSpec(good.specification,line)==this.formatSpec(line.spec,line)
        })
        if(result!=-1){
          r = this.chima_ex[i]
          break;
        }
      }
      return r;
    }
   },
   refreshEXList(){
    this.shangping_ex=[];
    this.chima_ex=[];
    if(this.order.exception_list.length>1){
        this.order.exception_list.sort((a,b)=>{
          return (+a.status)-(+b.status)
        })
      }
      if(this.order.exception_list.length){
        this.dizhiex_index=this.order.exception_list.findIndex(i=>i.type_name=='地址变更');
        this.order.exception_list.forEach((e,index)=>{
          if(e.type_name=='商品变更'){
            this.shangping_ex.push(index)
          }
          if(e.type_name=='尺码变更'){
            this.chima_ex.push(index)
          }
        })
      }
   },
   getTitle(ex,need_desc){
    if(ex.type_name=='标题提示'){
      let arr = ex.description.split('&remark&');
      let contents = arr[0].split('^&*');
      if(contents.length==1){
        return contents[0]
      }
      else
        return contents[2]
    }
    else{
      if(need_desc){
        let arr = ex.description.split('&remark&');
        let contents = arr[0].split('^&*');
        if(contents.length==1){
          return contents[0]
        }
        else
          return contents[2]
      }
      else
        return ex.type_name
    }
   },
   async handleRecommendIndex(val){
      let param={};
      param.good_id=val.split("_")[1];
      param.recommendation_index=val.split("_")[0];
      let res= await  api.updateRecommendationIndex(this,param);
      if (res.body.status == 'ok') {
        let find= this.order.goods_list.find(item=>item.good_id== param.good_id);
        find.recommendation_index=param.recommendation_index;
        let pop1 = `popover-${ param.good_id}`;
        this.$refs[pop1][0].doClose();
     }
    },
    // talon 2024/12/3 8:18 fix-计算方法
    evalPrice(r) {
      if (r.transport_amount_currency == r.tax_amount_currency) {
        if (isNaN(r.transport_amount) && isNaN(r.tax_amount)) {
          return '--';
        }
        let a = isNaN(Number(r.transport_amount)) ? 0.00 : Number(r.transport_amount);
        let b = isNaN(Number(r.tax_amount)) ? 0.00 : Number(r.tax_amount);
        let num = this.$decimalFormat((a + b), 2)
        let symbol = '';
        if (r.transport_amount_currency === 'CAD') {
          symbol = 'C$';
        }
        return symbol + num + r.transport_amount_currency;
      }
      return '--';
    },

    handleStyle(val){
      return handleStyle(val)
    },
    handleAlternate(val){
      if(val&&typeof val==='string'){
        return JSON.parse(val)
      }else {
        return val
      }
    },
    async changeTicketCollapse(data){
      this.relationReset=false;
      if(data==='')
        return
      let mail=this.tickets[data]
      if(mail.comments)
        return
      let params={}
      params.ticket_id=mail.id
      let res = await api.getTicketComments(this, params)
      mail.comments = res.body.result
      mail.comments.forEach((i)=>{
        i.replyDateDisplay=this.generateDateDisplay(i.replied_date.split(' ')[0])
        i.replyTimeDisplay=i.replied_date.split(' ')[1]
        i.editMode=false
      })
      this.$set(this.tickets[data],0,mail);
      this.$forceUpdate()
    },
    handleReset(){
      this.relationReset=true
    },
    callBackHandler(data){
      switch(data.type){
        case "1":
          if(data.params.type==1){
            let productCancelDialog = document.getElementById('callbackdialog' + this.order.id)
            productCancelDialog.click()
          }
          else
            this.callbackOrder(data.params);
          break;
        case "2":
          this.showProductCancel();
          break;
      }
    },
    createTicket(){

    },
    toggleDaigou(){
      this.daigouShow=!this.daigouShow
    },
    toggleMail(){
      this.mailShow=!this.mailShow
    },
    toggleExpresssBill(){
      this.expressBillShow=!this.expressBillShow
    },
      toggleAmountBill(){
          this.amountBillShow=!this.amountBillShow
      },
    toggleTicket(){
      this.ticketShow=!this.ticketShow
    },
    async updateMail(index){
      let mail = this.order.mails[index]
      mail.updating=true
      let res=await api.updateMailInfo(this,{id_list:[mail.id],status:mail.status})
      if(res.body.status!='ok'){
        mail.status=mail.status=='1'?'2':'1'
      }
      mail.updating=false
      mail.status_display=this.mailStatus[mail.status]
      this.order.mailList[index]=Object.assign({},mail)
      this.$forceUpdate()
    },
    generateDateDisplay(datestring){
      let today=new Date()
      let yesterday=new Date(today.getTime() -24*60*60*1000)
      let today_string=this.$moment(today).format('YYYY-MM-DD')
      let yest_string=this.$moment(yesterday).format('YYYY-MM-DD')
      if(datestring==today_string)
        return '今天';
      if(datestring==yest_string)
        return '昨天';
      return datestring
    },
    async fetchDaigou(){
      this.order.daigou=[]
      const generateParams=()=>{
        let params={}
        params.joyorders_order_no = this.order.order_no
        return params
      }
      let params=generateParams()
      let res=await api.daigouList(this, params);
      res=res.body;
      this.order.daigou = res.result;
      if(this.order.daigou){
        this.order.daigou.forEach((i)=>{
            if(i.create_time){
              i.createDateDisplay=this.generateDateDisplay(i.create_time.split(' ')[0])
              i.createTimeDisplay=i.create_time.split(' ')[1]
            }
        })
      }
      this.$forceUpdate()
    },
    async fetchTickets(){
      this.tickets=[]
      const generateParams=()=>{
        let params={}
        params.limit=99;
        params.page=1;
        params.order_no = this.order.order_no
        return params
      }
      let params=generateParams()
      let res=await api.getTicketList(this, params);
      res=res.body;
      this.tickets = res.result;
      if(this.tickets){
        this.tickets.forEach((i)=>{
            if(i.created_date){
              i.createDateDisplay=this.generateDateDisplay(i.created_date.split(' ')[0])
              i.createTimeDisplay=i.created_date.split(' ')[1]
            }
        })
      }
      this.$forceUpdate()
    },
    async fetchExpressBill(){
      this.order.expressBillList=[];
      let params=this.generateParams();
      if(!this.order.shipping_info){
        return
      }
      let temp=[]
       this.order.shipping_info.map(item=>{
          if(item.transport_store_number) {
            let a=item.transport_store_number.split("|");
              a.map(item=>{
              temp.push( item.split("*")[0])
             })
          }
      })
      if(!temp.length){
        return
      }
      params.transport_store_number=temp.join('|');
      let res=await api.getOutboundDetailList(this, params);
      this.order.express_bill_list=res.body.result;
      this.order.express_bill_list.map(item=>{
        if (item.create_time) {
          item.date_display = this.generateDateDisplay(item.create_time.split(' ')[0])
          item.time_display = item.create_time.split(' ')[1];
          item.weight_label = evalWeight(item);
          item.money_label = evalMoney(item);
          try {
            item.html = JSON.parse(item.html);
          } catch (e) {
            //不是json字符串不处理
          }

        }
        return item;
      });
      function evalWeight(r) {
        let weight, real;
        weight = isNaN(r.weight_value) ? '--' : r.weight_value + r.weight_unit;
        real = isNaN(r.weight_value_real) ? '--' : r.weight_value_real + r.weight_unit_real;
        let arr = [{name: '包裹重量', value: weight}, {name: '收费重量', value: real}]
        return arr.filter(x => x.value != '--');
      }

      function evalMoney(r) {
        // {{ r.transport_amount }}{{r.transport_amount_currency}}| {{ r.tax_amount }}{{r.tax_amount_currency}}
        let tr, tx;
        tr = !r.transport_amount || isNaN(r.transport_amount) ? '--' : r.transport_amount + r.transport_amount_currency
        tx = !r.tax_amount || isNaN(r.tax_amount) ? '--' : r.tax_amount + r.tax_amount_currency
        let arr = [{name: '运费', value: tr}, {name: '税费', value: tx}]
        return arr.filter(x => x.value != '--');
      }
    },
    generateParams(){
      let params={}
      params.limit=99;
      params.page=1;
      let end = new Date()
      let start = new Date(end.getTime() - 180*24*60*60*1000)
      params.start_time=this.$moment(start).format('YYYY-MM-DD HH:mm')
      params.end_time=this.$moment(end).format('YYYY-MM-DD HH:mm');
      return params;
    },
    async fetchMails(){
      this.order.mails=[]
      const generateParams=()=>{
        let params={}
        params.limit=99;
        params.page=1;
        let ar = this.order.business_order_no.split('|')
        let n_arr=ar.map((a)=>{
          if(a.indexOf('*')>-1)
            return a.substring(0,a.indexOf('*'))
          else
            return a
        })
        params.merchant_order_number=n_arr.join('|')
        let end = new Date()
        let start = new Date(end.getTime() - 180*24*60*60*1000)
        params.start_time=this.$moment(start).format('YYYY-MM-DD HH:mm')
        params.end_time=this.$moment(end).format('YYYY-MM-DD HH:mm')
        return params
      }
      let params=generateParams()
      let res=await api.getMailList(this, params);
      res=res.body;
      //if(res.status == 'ok')
      this.order.mails=res.rows;
      this.order.mails.forEach((i)=>{
          i.status_display=this.mailStatus[i.status]
          if(i.merchant_id!='0')
            i.merchant_display=this.order.business_name
          else
            i.merchant_display=i.sender
          if(i.send_time){
            i.date_display=this.generateDateDisplay(i.send_time.split(' ')[0])
            i.time_display=i.send_time.split(' ')[1]
          }
          if(i.tracking_list && i.tracking_list.length){
            i.tracking_number_display=i.tracking_list.map(j=>j?j.tracking_number:'').join(',')
          }
          if(i.package_content){
            if(i.package_content.confirm){
              i.package_content.confirm.forEach((g)=>{
                if(g.spec)
                  g.good_detail_arr=JSON.parse(g.spec)
              })
            }
            if(i.package_content.shipping_now && i.package_content.shipping_now.length){
              i.package_content.shipping_now.forEach((s)=>{
                s.good_list.forEach((g)=>{
                  if(g.spec)
                    g.good_detail_arr=JSON.parse(g.spec)
                })
              })
            }
            if(i.package_content.already_shipped && i.package_content.already_shipped.length){
              i.package_content.already_shipped.forEach((s)=>{
                s.good_list.forEach((g)=>{
                  if(g.spec)
                    g.good_detail_arr=JSON.parse(g.spec)
                })
              })
            }
            if(i.package_content.finished && i.package_content.finished.length){
              i.package_content.finished.forEach((s)=>{
                s.good_list.forEach((g)=>{
                  if(g.spec)
                    g.good_detail_arr=JSON.parse(g.spec)
                })
              })
            }
            if(i.package_content.arrive_soon && i.package_content.arrive_soon.length){
              i.package_content.arrive_soon.forEach((s)=>{
                s.good_list.forEach((g)=>{
                  if(g.spec)
                    g.good_detail_arr=JSON.parse(g.spec)
                })
              })
            }
            if(i.package_content.shipping_soon && i.package_content.shipping_soon.length){
              i.package_content.shipping_soon.forEach((g)=>{
                if(g.spec)
                  g.good_detail_arr=JSON.parse(g.spec)
              })
            }
            if(i.package_content.cancel){
              i.package_content.cancel.forEach((g)=>{
                if(g.spec)
                  g.good_detail_arr=JSON.parse(g.spec)
              })
            }
          }
      })
      this.gettingMails=false;

    },
    generateLackGoods(line){
      let ex=this.order.exception_list.filter((i)=>{
        return (i.type==1 || i.type==2) && i.status==1
      })
      if(ex.length){
        let ex_g=ex[0].product_list.filter(g=>g.id==line.id)
        if(ex_g.length){
          if(ex_g[0].number==line.number)
            return '缺 货'
          else
            return `缺${ex_g[0].number}件`
        }
        else
          return ''
      }
      else
        return ''
    },
    updateOrderHandler(){
      this.$forceUpdate()
    },
    searchBuyer(type){
      let obj={}
      if(type==5){
        obj.type=5+'';
        obj.name=this.order.buyer.username
      }
      else if(type==2){
        if(this.order.buyer_delegate_username){
          obj.type=2+'';
          obj.name=this.order.buyer_delegate_username
        }
        else{
          obj.type=1+'';
          obj.name=this.order.single_username
        }
      }
      this.$emit('searchBuyer',obj)
    },
    generateCountryCode(c){
      const pattern = new RegExp(/\((.+)\)/g)
			return c.match(pattern)[0].replace('(', '').replace(')', '')
    },
    async getAllBuyers(){
      let res = await api.getBuyers(this, {})
      res = res.body
      this.allBuyers = res.result.filter(i=>(+i.single_account_id)>0)
    },
    cancelModify(type){
      switch(type){
        case 'package_forwarding_fee':
          this.modifyPrice.package_forwarding_fee=this.modify_price_info.international_transport_price.value
          this.show_modify_package_forwarding_fee=false
          break;
        case 'other_fee':
          this.modifyPrice.other_fee=this.modify_price_info.other_price.value
          this.show_modify_other_fee=false
          break;
        case 'transport_fee':
          this.modifyPrice.transport_fee=this.modify_price_info.transport_price.value
          this.show_modify_transport_fee=false
          break;
        case 'tax_fee':
          this.modifyPrice.tax_fee=this.modify_price_info.tax_price.value
          this.show_modify_tax_fee=false
          break;
      }
    },
    confirmModify(type){
      let data={order_id:this.order.id};
      switch(type){
        case 'package_forwarding_fee':
          data.international_transport_price=this.modifyPrice.package_forwarding_fee
          break;
        case 'other_fee':
          data.other_price=this.modifyPrice.other_fee
          break;
        case 'transport_fee':
          data.transport_price=this.modifyPrice.transport_fee
          break;
        case 'tax_fee':
          data.tax_price=this.modifyPrice.tax_fee
          break;
      }
      api.post(this, {
            path: 'order.php?api=get_price_info&type=4',
            data: data,
            loading: 'loading'})
      .then((res)=>{
        res = res.body
        if (res.status == 'ok') {
          switch(type){
            case 'package_forwarding_fee':
              this.show_modify_package_forwarding_fee=false
              break;
            case 'other_fee':
              this.show_modify_other_fee=false
              break;
            case 'transport_fee':
              this.show_modify_transport_fee=false
              break;
            case 'tax_fee':
              this.show_modify_tax_fee=false
              break;
          }
          this.modify_price_info=res.result;
          this.initModify(this.modify_price_info)
        }
      })
    },
    async confirmAssignBuyer(){
      let data={
        order_id:this.order.id,
        b:this.order_buyer_id,
        c:this.transport_buyer_id
      }
      let res = await api.post(this, {
            path: 'order.php',
            api: 'upload_info',
            data: data,
            loading: 'loading'
          })
          res = res.body
          if (res.status == 'ok') {
            this.assignBuyerVisible=false;
          }
    },
    updateGroupLine(data){
      if(data && data.goods_list)
        this.order.groupOrderLines = _.groupBy(data.goods_list, 'package_id')
      this.$forceUpdate()
    },
    async getAddrFromStore(data){
      if(data){
        this.completion = true
        this.status = data.status
        this.operationType = data.operationType
        this.operation = data.operation
      }
      let res = await api.getAddressAccountList(this, {
          order_id: this.order.id,
      })
      res = res.body
      this.totalAccountList=res.result
      this.allAccountList=JSON.parse(JSON.stringify(res.result))
      let tid=0;
      if(this.order.transport_express_id && this.order.transport_express_id!='0'){
        tid=this.order.transport_express_id
        //特殊处理Buyandship香港，2024/01/29看作必得转运，之前看作番茄转运
        if(this.order.transport_express_id==1542)
          tid=1557
      }
      else if(this.order.business_id=='4474'){
        tid=899
      }
      if(tid)
        this.totalAccountList=this.totalAccountList.filter(i=>i.express_company_id==tid)

      let s1=this.totalAccountList.filter(i=>i.status==1)
      let s2=this.totalAccountList.filter(i=>i.status==2)
      let s3=this.totalAccountList.filter(i=>i.status==3)
      //console.log('addr',this.totalAccountList,s1,s2,s3)
      if(s1.length>0){
        this.addressStatusClass='success'
        if((+s1[0].match_index)<4)
          this.addressStatusClass+=' not_match'
      }
      else{
        if(s2.length>0){
          this.addressStatusClass='progress'
          if((+s2[0].match_index)<4)
            this.addressStatusClass+=' not_match'
        }
        else if(s3.length>0){
          this.addressStatusClass='danger'
          if((+s3[0].match_index)<4)
            this.addressStatusClass+=' not_match'
        }
      }

      /*if (res.status == 'ok' && this.order.shipping_info.length) {
        this.bindedAccountList=res.result.filter(i=>i.express_company_id==this.order.shipping_info[0].transport_express_id);
        let a=[];
        if(localStorage.getItem('bindedaccountlist'))
          a=JSON.parse(localStorage.getItem('bindedaccountlist'))
        this.totalAccountList=a.filter(i=>i.express_company_id==this.order.shipping_info[0].transport_express_id);
        this.totalAccountList.forEach((a)=>{
          if(this.bindedAccountList.filter(i=>i.zhuanyun_account_id==a.zhuanyun_account_id).length)
            a.binded=true;
        })
      }*/
    },
    isShowCallbackPackage1(){
      if(!this.isSingle)
        return false
      let has4Status=false;
      let has5Status=false;
      if(this.order.groupOrderLines){
        for(let key in this.order.groupOrderLines){
            if(this.order.groupOrderLines[key][0].status==4){
              has4Status=true
            }
            if(this.order.groupOrderLines[key][0].status==5 || this.order.groupOrderLines[key][0].status==6){
              has5Status=true
            }
        }
        if(has4Status){
          if(this.role==1){
            return true;
          }
          else if(this.order.single_account_id==this.account_id || this.order.business_shipping_account_id==this.account_id || (this.order.merchant_administrator_account_id_list && this.order.merchant_administrator_account_id_list.indexOf(this.account_id)>-1)){
            return true;
          }
          else{
            return false;
          }
        }
        if(has5Status){
          if(this.role==1){
            return true;
          }
          else if(this.order.single_account_id==this.account_id || this.order.transport_shipping_account_id==this.account_id || (this.order.merchant_administrator_account_id_list && this.order.merchant_administrator_account_id_list.indexOf(this.account_id)>-1)){
            return true;
          }
          else{
            return false;
          }
        }
        return false;
      }
      else{
        return false;
      }
    },
    getMerchantExpress(){
      if(this.order.status==30 || !this.order.business_order_no || this.order.business_order_no.toLowerCase().indexOf('*none')>-1)
        return
      this.isFetchingMerchantExpress=true;
      if(!this.merchantExpress){
        let params={order_id: this.order.business_order_no}
        api.get(this, {
                path: 'merchant_order.php?api=get_by_id',
                params: params
                })
          .then((res)=>{
            this.isFetchingMerchantExpress=false;
            this.merchantExpress=res.body.result;
            if (res.body.status == 'ok' && this.merchantExpress.goods_list && this.merchantExpress.goods_list.length) {
              this.order.goods_list.forEach((g)=>{
                this.compareMerchantExpress(g);
              })
            }
          })
      }
      else{
        this.isFetchingMerchantExpress=false;
        this.order.goods_list.forEach((g)=>{
          this.compareMerchantExpress(g);
        });
      }
    },
    checkAllSpec(orderG,merchantG){
      let orderGSpec=JSON.parse(orderG.spec);
      let merchantGSpec=JSON.parse(merchantG.spec);
      let compareResult=[]
      if(orderG.sku!=merchantG.good_id)
        compareResult.push(merchantG.good_id)
      for(let p in orderGSpec){
        if(orderGSpec[p].toLowerCase()!=merchantGSpec[p].toLowerCase()){
          compareResult.push(SPEC_MAPPER[p]+':'+orderGSpec[p])
          break;
        }
      }
      if(compareResult.length)
        merchantG.compareDetail = compareResult.join('，')
      else
        merchantG.compareDetail = ''
    },
    compareMerchantExpress(g){
      let g_vice_param=JSON.parse(g.spec)[g.vice_param]
      let totalGoodsNumber=g.number;
      let differentGoods=[];
      let exceptionGoods=[];
      let cancelGoods=[];
      let merchantGoods=[];
      let merchantGoods2=[];
        //如果只有唯一的一个商品，则对比所有规格属性和sku
        if(this.order.goods_list.length==1 && this.merchantExpress.goods_list.length==1){
          let mGoods=this.merchantExpress.goods_list[0];
          this.checkAllSpec(g,mGoods)
          //任务物流单号与商家物流单号不一样
          if(g.shipping_id && g.shipping_id!='0'){
            merchantGoods2=this.merchantExpress.goods_list.filter((item)=>{
              let AWB=''
              if(item.AWB_list.length){
                AWB=item.AWB_list.map((l)=>{
                  return l.AWB
                }).join('')
              }
              let shipping_number=''
              shipping_number=this.order.shipping_info.filter((f)=>{
                return f.id==g.shipping_id
              }).map((f)=>{
                return f.AWB
              }).join('')
              return AWB && shipping_number!=AWB
            })
          }
          else{
            //任务为待发货，商家这边已经发货(可能会有已发货但还没有物流的情况)
              merchantGoods=this.merchantExpress.goods_list.filter((item)=>{
                return g.status!=item.status && item.status==4
              })
          }
          //商家这边取消了
          let merchantGoods3=this.merchantExpress.goods_list.filter((item)=>{
            return g.status!=item.status && (item.status==7 || item.status==3)
          })
          if(merchantGoods.length){
            differentGoods.push(merchantGoods[0]);
          }
          if(merchantGoods2.length){
            exceptionGoods.push(merchantGoods2[0]);
          }
          if(merchantGoods3.length){
            cancelGoods.push(merchantGoods3[0]);
          }
          this.compareExpressObj[g.sku+'_'+g_vice_param]=[];
          if(differentGoods.length){
            let leng=0;
            let biaodian=differentGoods[0].compareDetail?'，':''
            differentGoods.forEach((i)=>{
              leng=leng+(+i.number);
            })
            if(totalGoodsNumber==leng){
              //如果所有商品状态都不一样。则不用显示括号
              if(differentGoods[0].AWB_list.length){
                differentGoods[0].AWB_list.forEach((express)=>{
                  this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:express.ship_url,text:differentGoods[0].compareDetail+biaodian+express.express+' '+express.AWB,copytext:express.AWB});
                })
              }
              else{
                this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:'',text:differentGoods[0].compareDetail+biaodian+'已发货，暂无物流',copytext:''});
              }
            }
            else{
            //如果部分商品不一样，则需要显示括号
              if(differentGoods[0].AWB_list.length){
                differentGoods[0].AWB_list.forEach((a)=>{
                  this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:express.ship_url,text:"（"+leng+"/"+totalGoodsNumber+"）:"+differentGoods[0].compareDetail+biaodian+express.express+' '+express.AWB,copytext:express.AWB});
                })
              }
              else{
                this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:'',text:"（"+leng+"/"+totalGoodsNumber+"）:"+differentGoods[0].compareDetail+biaodian+"已发货，暂无物流",copytext:''});
              }
            }
          }
          if(exceptionGoods.length){
            let leng=0;
            let biaodian=exceptionGoods[0].compareDetail?'，':''
            exceptionGoods.forEach((i)=>{
              leng=leng+(+i.number);
            })
            if(totalGoodsNumber==leng){
              //如果所有商品状态都不一样。则不用显示括号
              exceptionGoods[0].AWB_list.forEach((express)=>{
                this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:express.ship_url,text:differentGoods[0].compareDetail+biaodian+express.express+' '+express.AWB,copytext:express.AWB});
              })
            }
            else{
              //如果部分商品不一样，则需要显示括号
              exceptionGoods[0].AWB_list.forEach((a)=>{
                this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:express.ship_url,text:"（"+leng+"/"+totalGoodsNumber+"）:"+differentGoods[0].compareDetail+biaodian+express.express+' '+express.AWB,copytext:express.AWB});
              })
            }
          }
          if(cancelGoods.length){
            let leng=0;
            let biaodian=cancelGoods[0].compareDetail?'，':''
            cancelGoods.forEach((i)=>{
              leng=leng+(+i.number);
            })
            if(totalGoodsNumber==leng){
              //如果所有商品状态都不一样。则不用显示括号
              this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:'',text:cancelGoods[0].compareDetail+biaodian+'已取消',copytext:''});
            }
            else{
              //如果部分商品不一样，则需要显示括号
              this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:'',text:cancelGoods[0].compareDetail+biaodian+"已取消（"+leng+"/"+totalGoodsNumber+"）:",copytext:''})
            }
          }
        }
        else{
          //任务物流单号与商家物流单号不一样
          if(g.shipping_id && g.shipping_id!='0'){
            merchantGoods2=this.merchantExpress.goods_list.filter((item)=>{
              let AWB=''
              if(item.AWB_list.length){
                AWB=item.AWB_list.map((l)=>{
                  return l.AWB
                }).join('')
              }
              let shipping_number=''
              shipping_number=this.order.shipping_info.filter((f)=>{
                return f.id==g.shipping_id
              }).map((f)=>{
                return f.AWB
              }).join('')
              return g.sku==item.good_id && g_vice_param==JSON.parse(item.spec)[g.vice_param] && AWB && shipping_number!=AWB
            })
          }
          else{
            //任务为待发货，商家这边已经发货(可能会有已发货但还没有物流的情况)
              merchantGoods=this.merchantExpress.goods_list.filter((item)=>{
              return g.sku==item.good_id && g_vice_param==JSON.parse(item.spec)[g.vice_param] && g.status!=item.status && item.status==4
            })
          }
          //商家这边取消了
          let merchantGoods3=this.merchantExpress.goods_list.filter((item)=>{
            return g.sku==item.good_id && g_vice_param==JSON.parse(item.spec)[g.vice_param] && g.status!=item.status && (item.status==7 || item.status==3)
          })
          if(merchantGoods.length){
            differentGoods.push(merchantGoods[0]);
          }
          if(merchantGoods2.length){
            exceptionGoods.push(merchantGoods2[0]);
          }
          if(merchantGoods3.length){
            cancelGoods.push(merchantGoods3[0]);
          }
          this.compareExpressObj[g.sku+'_'+g_vice_param]=[];
          if(differentGoods.length){
            let leng=0;
            differentGoods.forEach((i)=>{
              leng=leng+(+i.number);
            })
            if(totalGoodsNumber==leng){
              //如果所有商品状态都不一样。则不用显示括号
              if(differentGoods[0].AWB_list.length){
                differentGoods[0].AWB_list.forEach((express)=>{
                  this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:express.ship_url,text:express.express+' '+express.AWB,copytext:express.AWB});
                })
              }
              else{
                this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:'',text:'已发货，暂无物流',copytext:''});
              }
            }
            else{
            //如果部分商品不一样，则需要显示括号
              if(differentGoods[0].AWB_list.length){
                differentGoods[0].AWB_list.forEach((a)=>{
                  this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:express.ship_url,text:"（"+leng+"/"+totalGoodsNumber+"）:"+express.express+' '+express.AWB,copytext:express.AWB});
                })
              }
              else{
                this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:'',text:"（"+leng+"/"+totalGoodsNumber+"）:已发货，暂无物流",copytext:''});
              }
            }
          }
          if(exceptionGoods.length){
            let leng=0;
            exceptionGoods.forEach((i)=>{
              leng=leng+(+i.number);
            })
            if(totalGoodsNumber==leng){
              //如果所有商品状态都不一样。则不用显示括号
              exceptionGoods[0].AWB_list.forEach((express)=>{
                this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:express.ship_url,text:express.express+' '+express.AWB,copytext:express.AWB});
              })
            }
            else{
              //如果部分商品不一样，则需要显示括号
              exceptionGoods[0].AWB_list.forEach((a)=>{
                this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:express.ship_url,text:"（"+leng+"/"+totalGoodsNumber+"）:"+express.express+' '+express.AWB,copytext:express.AWB});
              })
            }
          }
          if(cancelGoods.length){
            let leng=0;
            cancelGoods.forEach((i)=>{
              leng=leng+(+i.number);
            })
            if(totalGoodsNumber==leng){
              //如果所有商品状态都不一样。则不用显示括号
              this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:'',text:'已取消',copytext:''});
            }
            else{
              //如果部分商品不一样，则需要显示括号
              this.compareExpressObj[g.sku+'_'+g_vice_param].push({url:'',text:"已取消（"+leng+"/"+totalGoodsNumber+"）:",copytext:''})
            }
          }
        }

    },
    callbackOrder(params){
      this.$confirm('确认撤回吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        //let params={order_id: +this.order.id,type:1}
        //params.good_id_list=this.order.goods_list.filter(i=>i.status==0 || i.status==1).map(i=>i.id)
        let cur_pack = {}
        for(var g in this.order.groupOrderLines){
          if(this.order.groupOrderLines[g][0].package_id == this.$store.state.curPackageId){
            this.order.groupOrderLines[g].loading = true
            cur_pack = this.order.groupOrderLines[g]
          }
        }
        api.post(this, {
              path: 'order.php?api=change_status',
              data: params,
              loading: 'loading'})
        .then((res)=>{
          cur_pack.loading = false
          if (res.body.status == 'ok') {
            Object.assign(this.order, res.body.result)
            _.each(this.order.goods_list, good => {
              if (good.status == 3 || good.status == 7) {
                good.package_id = good.cancel_time
              }
            })
            if(this.order.goods_list && this.order.goods_list.length)
                this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
          }
          else{
            if(res.body.result == 'already_updated'){
              this.$msgbox.alert('订单数据已更新，点击确定会自动更新数据', '数据更新', {
                confirmButtonText: '确定',
                callback: action => {
                  this.order.status = res.description.status;
                }
              })
            }
            else{
              this.$msgbox.alert(res.body.result, '错误')
            }
          }
        })
      }).catch(() => {
      });
    },
    callbackOrderEx(){
      this.callbackOrder({order_id: +this.order.id,type:3});
    },
    callbackPackage(){
      this.$confirm('确认撤回发货吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        let params={order_id: +this.order.id}
        let packids = []
        for(var g in this.order.groupOrderLines){
          if(this.order.groupOrderLines[g][0].package_id && this.order.groupOrderLines[g][0].status == 4){
            packids.push(this.order.groupOrderLines[g][0].package_id)
          }
        }
        params.package_id_list=packids
        api.post(this, {
              path: 'order.php?api=cancel_delivery_goods',
              data: params,
              loading: 'loading'})
        .then((res)=>{
          if (res.body.status == 'ok') {
            Object.assign(this.order, res.body.result)
            if(this.order.goods_list && this.order.goods_list.length)
                this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
          }
          else{
            if(res.body.result == 'already_updated'){
              this.$msgbox.alert('订单数据已更新，点击确定会自动更新数据', '数据更新', {
                confirmButtonText: '确定',
                callback: action => {
                  Object.assign(this.order, res.description)
                  if(this.order.goods_list && this.order.goods_list.length)
                    this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
                }
              })
            }
            else{
              this.$msgbox.alert(res.body.result, '错误')
            }
          }
        })
      }).catch(() => {

      });
    },
    validate_price_info(){
      let map={'original_goods_price':'初始商品价格','goods_price':'商品价格'
      ,'original_tax_price':'初始税费','tax_price':'税费'
      ,'original_transport_price':'初始商家运费','transport_price':'商家运费'
      ,'original_other_price':'初始其他费用','other_price':'其他费用'
      ,'original_service_price':'初始服务费','service_price':'服务费'
      ,'original_international_transport_price':'初始国际运费','international_transport_price':'国际运费'
      ,'original_subtotal_price':'初始商家小计','subtotal_price':'商家小计'
      ,'original_total_price':'初始总计','total_price':'总计'
      ,'paid_amount':'净支付','paying_amount':'支付中','refunding_amount':'退款中'
      ,'after_sales_service_fee':'售后服务费','original_after_sales_service_fee':'初始售后服务费'
      ,'discount_price':'打折价格','original_discount_price':'初始打折价格'}
      for(let p in map){
        if(this.real_price_info[p] && this.order.price_info[p] && this.real_price_info[p].value!=this.order.price_info[p].value){
          this.validate_price_message_title=map[p]
          break;
        }
      }
    },
    refetchPriceData(){
      this.isrefetching=false;
      this.discount_rule={}
      if(!this.real_price_info)
        this.real_price_info=JSON.parse(JSON.stringify(this.order.price_info));
      let params={order_id: +this.order.id}
      api.post(this, {
            path: 'order.php?api=get_price_info&type=5',
            data: params,
            loading: 'loading'})
      .then((res)=>{
        if (res.body.status == 'ok') {
          this.real_price_info=res.body.result;
          if(this.real_price_info.discount_rule_info){
            for(let p in this.real_price_info.discount_rule_info){
              if(!this.real_price_info.discount_rule_info[p].error){
                if(this.real_price_info.discount_rule_info[p].discount_rule)
                  this.discount_rule[p]=this.real_price_info.discount_rule_info[p].discount_rule.display_name
              }
            }
          }
          this.validate_price_info()
        }
        this.isrefetching=false;
      })
    },
    isShowModifyOrdeInfo(){
      if(this.order.groupOrderLines){
        let r=false;
        for(let key in this.order.groupOrderLines){
            if(['1','4','5'].indexOf(this.order.groupOrderLines[key][0].status)>-1)
              r=true;
        }
        return r;
      }
      else{
        return false;
      }
    },
    isShowCallbackPackage(){
      if(this.order.groupOrderLines){
        let r=false;
        for(let key in this.order.groupOrderLines){
            if(this.order.groupOrderLines[key][0].status==4)
              r=true;
        }
        return r;
      }
      else{
        return false;
      }
    },
    updatePriceInfo(data){
      this.real_price_info=JSON.parse(JSON.stringify(data))
      this.$emit('refresh',{order:this.order,price_info:data})
    },
    saveIdCard(prop,name){
      let url=this.order.id_card_info[prop]
      var x=new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = 'blob';
      x.onload=function(e){
          var url = window.URL.createObjectURL(x.response)
          var a = document.createElement('a');
          a.href = url
          let p=prop.split('_')[0]=='front'?'Front':'Back'
          a.download = name+p+".jpg"
          a.click()
      }
      x.send();
    },
    openTrack(){
      this.trackVisible=true;
      this.generateQrCode();
    },
    generateQrCode(){
      let params={page: 'pages/order/orderDetail/orderDetail',
						is_hyaline: true,
						scene: this.order.id}
        api.post(this, {
            path: 'good.php',
            data: params,
            loading: 'loading',
            api: 'create_qr_code'
        }).then((res)=>{
          if(this.order.goods_list&&this.order.goods_list.length){
            if(this.order.type==0)
              this.$set(this.painting.views[0], 'url', this.order.goods_list[0].picture);
            else
              this.$set(this.painting.views[0], 'url', this.order.goods_list[0].image_info.image);
            //if(this.order.goods_list.length>1)
            //this.$set(this.painting.views[8], 'text', '这单一共'+this.order.goods_list.length+'件商品');
          }
          this.$set(this.painting.views[4], 'url', res.body);
          this.$set(this.painting.views[5], 'text', '#'+this.order.order_no);
          this.$set(this.painting.views[6], 'text', this.order.address.full_name1+' '+this.order.address.mobile);
          let address=`${this.order.address.province}${this.order.address.city}${this.order.address.county}${this.order.address.address1}`
          if(address.length>15)
            address=address.substr(0,15)+'...'
          this.$set(this.painting.views[7], 'text', address);
        })
    },
    success(src) {
     this.src=src;
    },
    fail(err) {
      console.log('fail', err)
    },
    getTotalFeeWithAllFee(order){
      let cancelGoodsFee=0;
      if(order.goods_list){
        order.goods_list.forEach((g)=>{
          if(g.status == 3)
            cancelGoodsFee+=(+g.discounted_price)*(+g.number);
        })
      }
      return (+order.total_amount)-cancelGoodsFee;
    },
    async take_by_single () {
      if (!this.isOffLine) {
        if (this.order.offline_payment == '1') {
          this.offline = true
          this.$forceUpdate()
          return
        }
      }
      let res = await api.post(this, {
        path: 'order.php',
        api: 'take_by_single',
        data: {
          order_id: this.order.id,
          update_time: this.order.update_time
        },
        loading: 'task_loading'
      })
      res = res.body
      if (res.status == 'ok') {
        Object.assign(this.order, res.result)
        if(this.order.goods_list && this.order.goods_list.length)
            this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
      }
      else{
        if(res.result=='already_updated'){
          this.$msgbox.alert('订单数据已更新，点击确定会自动更新数据', '数据更新', {
            confirmButtonText: '确定',
            callback: action => {
              Object.assign(this.order, res.description)
              if(this.order.goods_list && this.order.goods_list.length)
                  this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
              this.order.take_time = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            }
          })
        }
      }
      this.initData()
    },
    async begin () {
      let res = await api.post(this, {
        path: 'order.php',
        api: 'begin',
        data: {
          order_id: this.order.id,
          update_time: this.order.update_time
        },
        loading: 'task_loading'
      })
      res = res.body
      if (res.status == 'ok') {
        Object.assign(this.order, res.result)
        if(this.order.goods_list && this.order.goods_list.length)
            this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
      }
      else{
        if(res.result=='already_updated'){
          this.$msgbox.alert('订单数据已更新，点击确定会自动更新数据', '数据更新', {
            confirmButtonText: '确定',
            callback: action => {
              Object.assign(this.order, res.description)
              if(this.order.goods_list && this.order.goods_list.length)
                this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
            }
          })
        }
      }
      this.initData()
    },
    Submit () {
      this.offline = false
      this.isOffLine = true
      this.take_by_single()
    },
    showExpress () {
      this.$nextTick(()=>{
        let express = document.getElementById('epress' + this.order.id)
        express.click()
      })
    },
    showProductCancel () {
      let productCancelDialog = document.getElementById('product' + this.order.id)
      productCancelDialog.click()
    },
    showPackageCancel () {
      let productCancelDialog = document.getElementById('package' + this.order.id)
      productCancelDialog.click()
    },
    showOrderLog(){
      let productCancelDialog = document.getElementById('orderlog' + this.order.id)
      productCancelDialog.click()
    },
    showAfterSale(){
      let productCancelDialog = document.getElementById('aftersale' + this.order.id)
      productCancelDialog.click()
    },
    showFeePromotion(){
      let productCancelDialog = document.getElementById('feepromotion' + this.order.id)
      productCancelDialog.click()
    },
    showException(index){
      console.log('currentex',index);
      this.currentEx=index
      this.$nextTick(()=>{
        let productCancelDialog = document.getElementById('exception' + this.order.id)
        productCancelDialog.click()
      })

    },
    showModifyDelegate(){
      let productCancelDialog = document.getElementById('modifyDelegate' + this.order.id)
      productCancelDialog.click()
    },
    showAddException(){
      let productCancelDialog = document.getElementById('addexception' + this.order.id)
      productCancelDialog.click()
    },
    showAddTicket(){
      let productCancelDialog = document.getElementById('addticket' + this.order.id)
      productCancelDialog.click()
    },
     async showAddAmountBill(){
          let res = await api.getConfig(this);
          Object.keys(res.body.result).map((item) => {
              this[item] = res.body.result[item]
          });
          let productCancelDialog = document.getElementById('addBill' + this.order.id)
          productCancelDialog.click()
      },
    showChooseImage (data) {
      if(data)
        this.showChooseImageType=data;
      this.needChooseImage = true
    },
    showOrderVoucher () {
      let orderVoucher = document.getElementById('voucher' + this.order.id)
      this.needChooseImage = false
      orderVoucher.click()
    },
    showOrderCancel () {
      let orderCancel = document.getElementById('orderCancel' + this.order.id)
      orderCancel.click()
    },
    showChangeAddress () {
      let showChangeAddress = document.getElementById('orderAddress' + this.order.id)
      showChangeAddress.click()
    },
    showOrderDelegate(){
      let showOrderDelegate = document.getElementById('orderDelegate' + this.order.id)
      showOrderDelegate.click()
    },
    showModifyOrder () {
      let uploadOrder = document.getElementById('modifyOrder' + this.order.id)
      uploadOrder.click()
    },
    showUploadOrder (isModify) {
      sessionStorage.setItem('isModifyUpload',isModify)
      let uploadOrder = document.getElementById('uploadOrder' + this.order.id)
      uploadOrder.click()
    },
    showDaigouOrder () {
      let uploadOrder = document.getElementById('daigouOrder' + this.order.id)
      uploadOrder.click()
    },
    showAddressToTransport() {
      let uploadOrder = document.getElementById('addAddressToTransport' + this.order.id)
      uploadOrder.click()
    },
    editOrder () {
      this.$store.commit('clearTaskInfo')
      this.$localStorage.set('goBackOrderUrl', this.$route.fullPath)
      this.$router.push({ path: '/buyer/publish_task/confirm', query: {order_id: this.order.id} })
    },
    setCopy(line,index){
      this.currentCopy.sku=line.sku
      this.currentCopy.spec=line.spec
      this.currentCopy.viceParam=line.vice_param
      this.currentCopy.index=index;
    },
    onCopyCompare(){
      this.compareExpressObj[this.currentCopy.sku+'_'+JSON.parse(this.currentCopy.spec)[this.currentCopy.viceParam]][this.currentCopy.index].copyTxtSuccess=true
      this.$forceUpdate()
      setTimeout(() => {
        this.compareExpressObj[this.currentCopy.sku+'_'+JSON.parse(this.currentCopy.spec)[this.currentCopy.viceParam]][this.currentCopy.index].copyTxtSuccess=false
        this.$forceUpdate();
      }, 2000)
    },
    onCopy (e) {
      this.copyTxtSuccess = true
      setTimeout(() => {
        this.copyTxtSuccess = false
      }, 2000)
    },
    onCopy (e) {
      this.copyTxtSuccess = true
      setTimeout(() => {
        this.copyTxtSuccess = false
      }, 2000)
    },
    onCopyIdCard (e) {
      this.copyIdCardSuccess = true
      setTimeout(() => {
        this.copyIdCardSuccess = false
      }, 2000)
    },
    onError () {

    },
    // 传递产品图片
    selectProductImage (item) {
      if(this.showChooseImageType=='uploadexpress'){
        let res = {
          item: {
            id: item.id
          },
          response: {
            result: item.url
          }
        }
        this.$refs.UploadExpressDialog.$refs.ProductList.onUploadSuccess(res)
      }
      else
        this.$refs.ProductCancelDialog.$refs.CancelProductList.updateGoodInfoImg(item.url)
    },
    editOrder () {
      this.$store.commit('clearTaskInfo')
      this.$localStorage.set('goBackOrderUrl', this.$route.fullPath)
      this.$router.push({ path: '/buyer/publish_task/confirm', query: {order_id: this.order.id} })
    },
    hover (index, packageId) {
      this.hoverIndex = index
      this.packageIdIndex = packageId
    },
    copyOrder () {
      this.showCopy = true
    },
    async copyOrderSuccess () {
      let res = await api.getOrderById(this, {
        order_id: this.order.id
      })
      if (res.body.status == 'ok') {
        res = res.body.result
        res.address_info = res.address
        res.coupon = JSON.parse(res.coupon)
        _.each(res.goods_list, goods => {
          goods.business_name = res.business.name
          goods.business_id = res.business.id
          goods.business_website = res.business.website
          goods.currency_symbol = res.currency_symbol
          goods.currency = res.currency
        })
        res.business.business_website = res.business.website
        res.business.business_name = res.business.name
        res.business.business_id = res.business.id
        res.id = ''
        res.fee_adjustment_list = []
        let payment_type_info = {
          card_number: null,
          name: null,
          safety_code: null,
          type: '2',
          valid_date: null
        }
        res.payment_type_id = '47'
        if (this.isSingle) {
          if (this.taskInfo && this.taskInfo.business && this.taskInfo.business.business_name == res.business.name && this.taskInfo.currency == res.currency) {
            _.each(res.goods_list, goods => {
              let flag = false
              let form = {
                good_id: goods.good_id,
                name: goods.name,
                website: goods.website,
                spec: goods.spec,
                price: goods.price,
                picture: goods.picture,
                discounted_price: goods.discounted_price,
                number: goods.number,
                currency: goods.currency,
                currency_symbol: goods.currency_symbol,
                business_name: goods.business_name,
                business_id: goods.business_id,
                business_website: goods.business_website,
                id: +new Date()
              }
              _.each(this.taskInfo.goods_list, list => {
                if (list.name == goods.name) {
                  flag = true
                  return false
                }
              })
              if (!flag) {
                this.taskInfo.goods_list.push(form)
              }
            })
          } else {
            this.taskInfo.business_website = res.business.website
            this.taskInfo.business_name = res.business.name
            this.taskInfo.business_id = res.business.id
            Object.assign(this.taskInfo, res)
          }
        }
        if (!this.isSingle) {
          this.taskInfo.business_website = res.business.website
          this.taskInfo.business_name = res.business.name
          this.taskInfo.business_id = res.business.id
          this.taskInfo.payment_type_info = payment_type_info
          Object.assign(this.taskInfo, res)
        }
        this.$store.commit('updateTaskInfo', this.taskInfo)
        if (!this.isSingle) {
          let flag = false
          let cartList = await api.getCartList(this)
          if (cartList.body.result.length > 0) {
            let list = cartList.body.result
            _.each(res.goods_list, async goods => {
              let form = {
                good_id: goods.good_id,
                name: goods.name,
                website: goods.website,
                spec: goods.spec,
                price: goods.price,
                picture: goods.picture,
                discounted_price: goods.discounted_price,
                number: goods.number,
                currency: goods.currency,
                currency_symbol: goods.currency_symbol,
                business_name: goods.business_name,
                business_id: goods.business_id,
                business_website: goods.business_website
              }
              _.each(list, async item => {
                if (item.status == '0' && item.business_name == form.business_name && item.business_website == form.business_website && item.name == form.name && item.spec == form.spec && item.price == form.price && item.discounted_price == form.discounted_price && item.picture == form.picture && item.website == form.website) {
                  item.currency = form.currency
                  item.currency_symbol = form.currency_symbol
                  item.number = Number(item.number) + Number(form.number)
                  flag = true
                  let res = await api.post(this, {
                    path: 'cart.php',
                    api: 'update',
                    data: [item],
                    loading: 'loading'
                  })
                  if (res.body.status == 'ok') {
                    this.$router.push({ path: '/publish_task/cart', query: {business_name: this.form.business_name}})
                  }
                }
              })
              if (flag) {
                return
              }
              if (!flag) {
                let res = await api.post(this, {
                  path: 'cart.php',
                  api: 'add',
                  data: [form],
                  loading: 'loading'
                })
                if (res.body.status == 'ok') {
                  this.$router.push({ path: '/publish_task/cart', query: {business_name: this.form.business_name}})
                }
              }
            })
          } else {
            _.each(res.goods_list, async goods => {
              let form = {
                good_id: goods.good_id,
                name: goods.name,
                website: goods.website,
                spec: goods.spec,
                price: goods.price,
                picture: goods.picture,
                discounted_price: goods.discounted_price,
                number: goods.number,
                currency: goods.currency,
                currency_symbol: goods.currency_symbol,
                business_name: goods.business_name,
                business_id: goods.business_id,
                business_website: goods.business_website
              }
              let res = await api.post(this, {
                path: 'cart.php',
                api: 'add',
                data: [form],
                loading: 'loading'
              })
              if (res.body.status == 'ok') {
                this.$router.push({ path: '/publish_task/cart', query: {business_name: this.form.business_name}})
              }
            })
          }
        } else {
          this.$router.push({ path: '/buyer/publish_task/cart' })
        }
        this.showCopy = false
      }
    },
    getPackgeDetail (groupOrderLine, packageId) {
      this.groupOrderLine_temporary = groupOrderLine
      this.packageId_temporary = packageId
      this.showPackge = true
      this.toggleBody(1)
    },
    getGoodDetail () {
      this.showDetail = true
      this.toggleBody(1)
    },
    toggleBody (isPin) {
      if (isPin) {
        $('body').addClass('mobile-body-hidden')
      } else {
        $('body').removeClass('mobile-body-hidden')
      }
    },
    initData () {

      if (this.order.status == '30') {
        if (this.order.shipping_info.length > 0) {
          if (Number(this.order.transport_amount) > 0 || Number(this.order.other_amount) > 0) {
              this.showRefundTip = true
            } else {
              this.showRefundTip = false
            }
        }
      } else {
        this.showRefundTip = false
      }
      if (this.order.coupon) {
        try {
          this.order.coupon = JSON.parse(this.order.coupon)
          this.order.coupon_text = this.order.coupon.join(' ')
          if (this.order.business && this.order.business.website) {
            this.order.website = this.order.business.website.split(',')[0]
          }
        } catch (e) {

        }
      }
      this.order.conditions = this.order.conditions || {}
      _.each(this.order.goods_list, good => {
        if (good.status == 3 || good.status == 7) {
          good.package_id = good.cancel_time
        }
      })
      this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
      /*let last_transport_store_number=''
      let arr=[];
      //let hasDuplicate=false;
      for(let p in this.order.groupOrderLines){
        let id=this.order.groupOrderLines[p][0].shipping_id;
        let o=this.order.shipping_info.filter(s=>s.id==id)
        if(o && o.length){
          arr.push(o[0].id);
          if(last_transport_store_number==o[0].transport_store_number){
            this.order.groupOrderLines[p][0].isDuplicate=true;
            hasDuplicate=true;
          }
          else
            last_transport_store_number=o[0].transport_store_number;
        }
      }
      if(hasDuplicate)
        this.shipping_Arr=arr.join('|')*/
      //console.log("groupOrderLines222",this.shipping_Arr)
      //this.getMerchantExpress()
      this.calTotalProductPrice()
      this.timeCal()
    },
    calServiceAmount () {
      let serviceRate, serviceFixedAmount
      if (this.taskInfo.support_transport_service === '1') {
        // 下单
        serviceRate = parseFloat(this.taskInfo.business.single_service_rate === '0' ? this.taskInfo.service_rate.replace('%', '') : this.taskInfo.business.single_service_rate.replace('%', ''))
        serviceFixedAmount = parseFloat(this.taskInfo.business.single_fixed_amount)
      } else if (this.taskInfo.support_transport_service === '2') {
        // 下单 + 转运
        serviceRate = parseFloat(this.taskInfo.business.buyer_service_rate === '0' ? this.taskInfo.service_rate.replace('%', '') : this.taskInfo.business.buyer_service_rate.replace('%', ''))
        serviceFixedAmount = parseFloat(this.taskInfo.business.buyer_fixed_amount)
      }
      this.service_amount = this.$decimalFormat((serviceRate * this.taskInfo.amount / 100 + serviceFixedAmount),2)
      // this.total_amount = (parseFloat(this.amount) + parseFloat(this.tax_amount) + parseFloat(this.transport_amount) + parseFloat(this.service_amount)).toFixed(2)
    },
    calTotalProductPrice () {
      this.totalProductPrice = 0
      _.each(this.order.goods_list, goods => {
        let price = goods.discounted_price || goods.price
        price = price * goods.number
        if (goods.status != '3') {
          this.totalProductPrice += Number(price)
        }
      })
    },
    timeCal () {
      if (this.order.status != 13 && this.order.status != 14) {
        return
      }
      let response_hours = this.order.conditions.response_hours
      if (response_hours) {
        response_hours = response_hours.replace('小时内响应', '')
      }
      if (isNaN(Number(response_hours))) {
        return
      }
      let latestTime = +new Date(this.order.take_time) + response_hours * 3600 * 1000 - +new Date()
      if (latestTime >= 0) {
        this.order.take_time = msToTime(latestTime)
        this.timer = setInterval(() => {
          latestTime -= 1000
          this.order.take_time = msToTime(latestTime)
        }, 1000)
      }
    },
    complete (data) {
      if(data.needRefreshPackStatus){
        for(let key in this.order.groupOrderLines){
              this.order.groupOrderLines[key].forEach((g)=>{
                g.status='1'
              })
        }
      }
      this.completion = true
      this.status = data.status
      this.operationType = data.operationType
      this.type = data.type
      this.refund = data.refund
      this.name = data.name
      this.operation = data.operation
      this.confirm = data.confirm
      this.isBuyAgain = data.isBuyAgain
      this.showRefundTip = data.showRefundTip
      this.$forceUpdate()
      if(data.needUpload){
        this.$store.commit('setNeedUpload',true)
        setTimeout(()=>{
          this.completion = false
          this.showOrderVoucher()
        },500)
      }
      if(data.operation=='代购')
        this.fetchDaigou()
    },
    updateAddress () {

    },
    closeCompletion () {
      if (this.operationType == '上传发货信息成功' || this.operationType == '取消商品成功') {
        this.showPackge = false
        this.toggleBody(0)
      }
    },
    buyAgain (order, line) {
      this.isBuy = true
      this.goods = line
    },
    async submit (order, line) {
      let flag = false
      this.form.business_id = order.business.id
      this.form.business_name = order.business.name
      this.form.business_website = order.business.website
      this.form.good_id = line.good_id
      this.form.name = line.name
      this.form.website = line.website
      this.form.spec = line.spec
      this.form.price = line.price
      if (line.picture) {
        this.form.picture = line.picture
      }
      this.form.discounted_price = line.discounted_price
      this.form.currency = order.currency
      this.form.currency_symbol = order.currency_symbol
      let cartList = await api.getCartList(this)
      if (cartList.body.result.length > 0) {
        let list = cartList.body.result
        _.each(list, async item => {
          if (item.status == '0' && item.business_name == this.form.business_name && item.business_website == this.form.business_website && item.name == this.form.name && item.spec == this.form.spec && item.price == this.form.price && item.discounted_price == this.form.discounted_price && item.picture == this.form.picture && item.website == this.form.website) {
            item.currency = this.form.currency
            item.currency_symbol = this.form.currency_symbol
            item.number = Number(item.number) + 1
            flag = true
            let res = await api.post(this, {
              path: 'cart.php',
              api: 'update',
              data: [item],
              loading: 'loading'
            })
            if (res.body.status == 'ok') {
              this.status = null
              this.confirm = false
              this.operation = false
              this.isBuy = false
              this.completion = true
              this.isBuyAgain = true
              this.operationType = '加入购物车成功'
            }
          }
        })
        if (flag) {
          return
        }
        let res = await api.post(this, {
          path: 'cart.php',
          api: 'add',
          data: [this.form],
          loading: 'loading'
        })
        if (res.body.status == 'ok') {
          this.status = null
          this.confirm = false
          this.operation = false
          this.isBuy = false
          this.completion = true
          this.isBuyAgain = true
          this.operationType = '加入购物车成功'
        }
      } else {
        let res = await api.post(this, {
          path: 'cart.php',
          api: 'add',
          data: [this.form],
          loading: 'loading'
        })
        if (res.body.status == 'ok') {
          this.status = null
          this.confirm = false
          this.operation = false
          this.isBuy = false
          this.completion = true
          this.isBuyAgain = true
          this.operationType = '加入购物车成功'
        }
      }
    },
    taskInfoSubmit (order, line) {
      let flag = false
      this.form.business = order.business
      this.form.business_id = order.business.id
      this.form.business_name = order.business.name
      this.form.business_website = order.business.website
      this.form.good_id = line.good_id
      this.form.name = line.name
      this.form.website = line.website
      this.form.spec = line.spec
      this.form.price = line.price
      if (line.picture) {
        this.form.picture = line.picture
      }
      this.form.discounted_price = line.discounted_price
      this.form.currency = order.currency
      this.form.currency_symbol = order.currency_symbol
      this.form.id = +new Date()
      if (this.taskInfo.business_name) {
        if (this.taskInfo.business_name == this.form.business_name) {
          this.taskInfo.currency = order.currency
          this.taskInfo.currency_symbol = order.currency_symbol
          this.taskInfo.goods_list = this.taskInfo.goods_list || []
          if (this.taskInfo.goods_list) {
            _.each(this.taskInfo.goods_list, item => {
              if (item.business_website == this.form.business_website && item.name == this.form.name && item.spec == this.form.spec && item.price == this.form.price && item.discounted_price == this.form.discounted_price && item.picture == this.form.picture && item.website == this.form.website) {
                item.number = Number(item.number) + 1
                flag = true
                this.status = null
                this.confirm = false
                this.operation = false
                this.isBuy = false
                this.completion = true
                this.isBuyAgain = true
                this.operationType = '加入购物车成功'
                this.$store.commit('updateTaskInfo', this.taskInfo)
              }
            })
          }
          if (flag) {
            return
          }
          this.taskInfo.goods_list.push(this.form)
          this.status = null
          this.confirm = false
          this.operation = false
          this.isBuy = false
          this.completion = true
          this.isBuyAgain = true
          this.operationType = '加入购物车成功'
          this.$store.commit('updateTaskInfo', this.taskInfo)
        } else {
          this.warning = true
        }
      } else {
        this.taskInfo.business = order.business
        this.taskInfo.business.business_id = order.business.id
        this.taskInfo.business_id = order.business.id
        this.taskInfo.business.business_name = order.business.name
        this.taskInfo.business_name = order.business.name
        this.taskInfo.business.business_website = order.business.website
        this.taskInfo.business_website = order.business.website
        this.taskInfo.currency = order.currency
        this.taskInfo.currency_symbol = order.currency_symbol
        this.taskInfo.goods_list = this.taskInfo.goods_list || []
        this.taskInfo.goods_list.push(this.form)
        this.status = null
        this.confirm = false
        this.operation = false
        this.isBuy = false
        this.completion = true
        this.isBuyAgain = true
        this.operationType = '加入购物车成功'
        this.$store.commit('updateTaskInfo', this.taskInfo)
      }
    },
    coverSubmit (order, line) {
      this.$store.commit('clearTaskInfo')
      this.taskInfo.business = order.business
      this.taskInfo.business_id = order.business.id
      this.taskInfo.business_name = order.business.name
      this.taskInfo.business_website = order.business.website
      this.taskInfo.currency = order.currency
      this.taskInfo.currency_symbol = order.currency_symbol
      this.taskInfo.goods_list = []
      this.taskInfo.goods_list.push(this.form)
      this.status = null
      this.confirm = false
      this.operation = false
      this.isBuy = false
      this.warning = false
      this.completion = true
      this.isBuyAgain = true
      this.operationType = '加入购物车成功'
      this.$store.commit('updateTaskInfo', this.taskInfo)
    },
    selectChat (toAccountId) {
      // this.$store.commit('updateNim', {
      //   showChat: false
      // })
      this.$store.commit('updateNim', {
        pageType: 'detail',
        toAccountId: toAccountId,
        showChat: true
      })
    },
    editAmount () {
      this.isEmptyErrors = true
      this.errors = {}
      if (Number(this.modifyAmount.total_amount) > Number(this.defaultAmount)) {
        this.isEmptyErrors = false
        this.errors = {
          business_name: [
            {message: '商品金额不能增加'}
          ]
        }
      }
      if (Number(this.modifyAmount.total_amount) < 0) {
        this.isEmptyErrors = false
        this.errors = {
          business_name: [
            {message: '商品金额必须大于零'}
          ]
        }
      }
      this.returnAmount = Number(this.modifyAmount.total_amount) - Number(this.defaultAmount)
    },
    initModify (price_info) {
      if (this.order.type == 2) {
        this.returnAmount = '0.00'
        if (this.order.goods_list && this.order.goods_list.length) {
          _.each(this.order.goods_list, item => {
            if (item.status == 3) {
              this.editTotalFee = true
              this.defaultAmount = price_info.goods_price.value
              this.modifyAmount.total_amount = price_info.goods_price.value
              // return false
            }
          })
        }
      }
      this.modifyPrice.order_id = this.order.id

      this.modifyPrice.tax_fee = price_info.tax_price.value
      this.defaultModify.tax_fee = price_info.tax_price.value
      this.modifyPrice.transport_fee = price_info.transport_price.value
      this.defaultModify.transport_fee = price_info.transport_price.value
      this.modifyPrice.other_fee = price_info.other_price.value
      this.defaultModify.other_fee = price_info.other_price.value
      this.modifyPrice.package_forwarding_fee = price_info.international_transport_price.value
      this.defaultModify.package_forwarding_fee = price_info.international_transport_price.value

      this.totalBusinessPrice = price_info.subtotal_price.value
      this.totalPrice = price_info.total_price.value
      this.needPaid = price_info.payment_price.value

    },
    async getUnpaid () {
      let res = await api.post(this, {
        path: 'order.php',
        api: 'fee_when_adjust_by_single',
        data: this.modifyPrice,
        loading: 'loading'
      })
      if (res.body.status == 'ok') {
        this.needPaid = (res.body.result.unpaid_fee_rmb).toString()
      }
    },
    modifyBlur (data) {
      if (this.showRefundTip) {
        if (Number(this.modifyPrice.tax_fee) > Number(this.defaultModify.tax_fee)) {
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '当前订单只能退款,不能输入超过现有金额的数值'}
            ]
          }
          return
        } else {
          this.isEmptyErrors = true
          this.errors = {}
        }
        if (Number(this.modifyPrice.transport_fee) > Number(this.defaultModify.transport_fee)) {
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '当前订单只能退款,不能输入超过现有金额的数值'}
            ]
          }
          return
        } else {
          this.isEmptyErrors = true
          this.errors = {}
        }
        if (Number(this.modifyPrice.other_fee) > Number(this.defaultModify.other_fee)) {
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '当前订单只能退款,不能输入超过现有金额的数值'}
            ]
          }
          return
        } else {
          this.isEmptyErrors = true
          this.errors = {}
        }
        if (Number(this.modifyPrice.package_forwarding_fee) > Number(this.defaultModify.package_forwarding_fee)) {
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '当前订单只能退款,不能输入超过现有金额的数值'}
            ]
          }
          return
        } else {
          this.isEmptyErrors = true
          this.errors = {}
        }
      }
      this.getUnpaid()
    },
    openModify (title) {
      this.modifyTitle = title
      this.showModify = true
      this.isEmptyErrors = true
      this.errors = {}
      this.modify_price_info=this.real_price_info
      this.initModify(this.real_price_info)
    },
    nextStep () {
      if (this.modifyPrice.package_forwarding_fee == this.package_forwarding_fee) {
        this.modifyPrice.package_forwarding_fee = 0
      }
      if (this.isEmptyErrors) {
        this.step = 2
      } else {

      }
    },
    async submitModify () {
      if (Number(this.returnAmount) < 0) {
        let res = await api.post(this, {
          path: 'order.php',
          api: 'adjust_amount_by_single',
          data: {order_id: this.order.id, amount: this.modifyAmount.total_amount},
          loading: 'loading'
        })
        if (res.body.status == 'ok') {
          this.returnAmount = '0.00'
        }
      }
      let res = await api.post(this, {
        path: 'order.php',
        api: 'adjust_fee_by_single',
        data: this.modifyPrice,
        loading: 'loading'
      })
      if (res.body.status == 'ok') {

        //this.$set(this.order, 'fee_adjustment_list', this.fee_adjustment_list)
        this.innerVisible = false
        this.showModify = false
        this.modifySuccess = true
        this.step = 1
        this.$emit('Modify')
      }
    }
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
    $('body').removeClass('mobile-body-hidden')
  },
  watch: {
    order: {
      handler (newName, oldName) {
        if (newName.shipping_info && newName.shipping_info.length) {
          if (newName.support_transport_service == '2' && this.isSingle) {
            let transportList = []
            _.each(newName.shipping_info, item => {
              if (item.transport_express) {
                transportList.push(item.transport_express)
              }
            })
            if (transportList.length > 0) {
              this.transportList = Array.from(new Set(transportList))
            }
          }
        }
      },
      deep: true

    }
  }
}

function msToTime (duration) {
  var seconds = parseInt((duration / 1000) % 60),
    minutes = parseInt((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)))

  hours = (hours < 10) ? '0' + hours : hours
  minutes = (minutes < 10) ? '0' + minutes : minutes
  seconds = (seconds < 10) ? '0' + seconds : seconds

  return hours + ':' + minutes + ':' + seconds
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .img-wrapper{
    .top-left{
      display: none;
    }
    &:hover{
      .top-left{
        display: block;
      }
    }
  }
.constantGroupOrderLine{
  width:130px;
  height:120px;
  display: flex;
  align-items: center;
}
.id_card_div{
  min-width: 257px;
  max-width: 310px;
}
.id_card_div p{
  color: #666666;
  line-height: 22px;
  white-space: normal;
}
.bold {
  color: #333;
  font-size:16px;
  margin-bottom: 3px;
}
.id_card_img{
  width:45%;
  position:relative;
  cursor: pointer;
}
.id_card_img img{
  width:100%;
  object-fit: contain;
}
.id_card_img i{
  display: none;
}
.id_card_img:hover i{
  display: block;
  font-size: 30px;
  position:absolute;
  top:25%;
  left:40%;
}
.suspension{
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  border-top: 1px #ccc solid;
  background-color: #fff;
  z-index: 4444;
  .flexBtn {
    flex-grow: 1;
    text-align: center;
    padding: 15px 0;
    .operationIco{
      font-size: 28px;
      color: #0F66CF;
      &.moneyIco{
        display: inline-block;
        height: 26px;
        width: 25px;
        background-image: url('../../../assets/images/money@2x.png');
        background-repeat: no-repeat;
        background-size: contain;

      }
    }
    .operationBtn{
      font-size: 12px;
      color: #0F66CF;
      margin-top: 15px;
    }
  }
}
.isMobile {
  display: none;
}
.copy{
  width: 14px;
  vertical-align: middle;
}
.copyTxt{
    float: right;
    cursor: pointer;

    &.copyTxtSuccess,&.copyIdCardSuccess{
      background-color: #f4f4f5;
      color: #909399;
      padding-left: 10px;
    }
}
  .order-header {
    background:rgba(243,243,249,1);
    padding: 30px;
    margin-top: 33px;
    border: 1px solid #D7D7D7;
    border-bottom: none;
    overflow: hidden;
    .detail-button {
      float: right;
      color: #0F66CF;
      cursor: pointer;
    }
    .detail-text {
      color: #333333;
      font-size: 14px;
      float: left;
    }
    .detail-time {
      color: #999999;
      font-size: 12px;
      float: left;
      clear: both;
    }
    li {
      float: left;
      margin-right: 50px;
    }

    .business-name {
      min-width: 100px;
      word-break: break-all;
    }

    span {
      color:rgba(136,136,136,1);
      line-height:20px;
    }
    .order_no{
      cursor: pointer;
      color: inherit;
    }

    .search_tag{
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }

    p {
      color:rgba(51,51,51,1);
      line-height:20px;
      padding-top: 5px;

      a {
        cursor: pointer;
        color: #333333;
        .el-icon-caret-bottom {
          padding-left: 3px;
          color: #333333;
        }
      }
    }

    .order-no {
      float: right;
      text-align: right;

      .moreIcon {
        line-height: 14px !important;
        cursor: pointer;
        text-align: center;
        display: inline-block;
        height: 15px;
        width: 15px;
        border: 1px solid transparent;
        border-radius: 50%;
        transform: rotate(90deg);
        &:hover{
          border-color:rgb(215,240,253);
          background:rgb(215,240,253);
        }
      }
    }
  }
  .order-detail {
    border: 1px solid #D7D7D7;
    border-top: none;
    padding: 25px 50px 30px;
    .fromWeb{
      margin-right: 0.8rem;
      display: inline-block;
      height: 14px;
      width: 14px;
      text-align: center;
    }
    .line-list {
      border-right: 1px solid #D7D7D7;
      padding-right: 30px;

      .img-container {
        float: left;
        width: 120px;
        height: 120px;
        a {
          position: relative;
          overflow: visible;
          display: block;
          width: 120px;
          height: 120px;

          .goodsNum{
            position: absolute;
            top: -10px;
            right:0;
            display: inline-block;
            height: 20px;
            width: 20px;
            border: 1px solid #D7D7D7;
            border-radius: 50%;
            text-align: center;
            font-size: 10px;
            line-height: 18px;
            color: white;
            background: black;
          }
        }

        img {
          // width: 100%;
          // position: absolute;
          // left: 0;
          // top: 50%;
          // -webkit-transform: translateY(-50%);
          // transform: translateY(-50%);
          height: 120px;
          width: 120px;
          object-fit: contain;
        }
      }

      .order-des {
        float: left;
        //margin-top: -5px;
        margin-left: 20px;
        .compareExpress_div{
          position: absolute;
          left: 180px;
          min-width: 250px;
          min-height:20px;
          top: -25px;
        }
        .buyAgain{
          height: 32px;
          width: 80px;
          text-align: center;
          line-height: 32px;
          border: 1px solid #DEE1EB;
          border-radius: 3px;
          background: #F3F3F9;
          font-size: 12px;
          color: #686B73;
          margin-left: 5px;
          cursor:pointer;
          float:right;
        }
        .buyAgain.compareExpress{
          background: #0f66cf;
          border: 1px solid #0f66cf;
          color: white;
          border-radius: 3px;
          width: max-content;
          padding: 0 20px;
          margin-bottom:5px;
          display: flex;
        }
        .buyAgain.compareExpress a{
          color:white;
        }
      }

      .order-state {
        float: right;
        text-align: right;
        p {
          color: #888888;
          margin-bottom: 20px;
        }
      }
    }

    .order-line {
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }

      .name {
        font-size:14px;
        color:rgba(51,51,51,1);
        line-height:20px;
        &:hover {
          .moreIcon {
            display: inline-block;
          }
        }
        .moreIcon {
          cursor: pointer;
          text-align: center;
          height: 15px;
          width: 15px;
          line-height: 15px !important;
          border: 1px solid transparent;
          border-radius: 50%;
          transform: rotate(90deg);
          display: inline-block;
          &:hover{
            border-color:rgb(215,240,253);
            background:rgb(215,240,253);
          }
        }
      }

      .order-des {
        position: relative;
        min-height: 120px;
        flex:1;
        .timeIco{
          text-align: center;
          margin-bottom: 10px;
          margin-top: 20px;
        }
        .descripe{
          color: #888;
          font-size: 18px;
          .voucher{
            cursor: pointer;
            text-decoration:underline;
          }
        }
        .order-price{
          font-size: 18px;
          line-height: 32px;
          color: black;
          margin: 0;
        }

        a.order-price {
          color: #FF4650;
          font-size: 18px;
        }

        del.order-price {
          color: #B0B4BF;
          font-size: 16px;
        }
      }

      p {
        font-size:12px;
        color:#333333;
        line-height:17px;
        margin-bottom: 6px;

        span {
          color: #999;
          font-size:12px;
        }
        a {
          color: #333333;
        }
      }

      .price {
        font-size:18px;
        color:rgba(51,51,51,1);
        line-height:25px;
        position: absolute;
        min-width: 200px;
        bottom: 0;
        margin: 0;
      }
    }

    .operation-container {
      padding-left: 50px;
    }
  }

  .popover-price {
    li {
      clear: both;
      text-align: right;
      color: #333333;
      line-height: 24px;

      span {
        float: left;
        color: #999999;
      }

      del {
        color: #B0B4BF;
      }
    }

    .line {
      float: left;
      width: 100%;
      height: 1px;
      border: 1px dashed #ccc;
    }
  }
  .modify-price {
    padding: 10px 5px;
    div {
      clear: both;
      text-align: right;
      color: #333333;
      line-height: 24px;

      span {
        float: left;
        color: #999999;
      }
    }

  }
  .modify {
    padding: 0 5px;
    div {
      clear: both;
      text-align: right;
      color: #333333;
      line-height: 24px;

      span {
        float: left;
        color: #999999;
      }
    }

  }

  .offlineLabel {
    position: absolute;
    left: -4px;
    font-size: 12px;
    height: 22px;
    width: 60px;
    text-align: center;
    padding: 5px 5px;
    border-radius: 20px;
    color: #fff;
    background: rgb(254,160,0);
  }
  .unpaidline{
    position: absolute;
    font-size: 12px;
    height: 22px;
    width:500px;
  }
  .unpaidlineLabel {
    display:inline-block;
    width: auto;
    line-height: 22px;
    padding: 0 8px;
    text-align: center;
    border-radius: 4px;
    color: #fff;
    background: black;
    &.miniprogram{
      background: #0f66cf;
    }
    &.alreadypaid{
      background:white;
      color:black;
    }
    &.waitingcacu{
      background:black;
      color:white;
    }
    &.exception{
      background-color: #fff1f1;
      color: #ff4650;
    }
  }
  .redirct {
    font-size:24px;
    line-height:33px;
    margin-top: 54px;
    padding-bottom: 70px;
    .completion {
      background-image: url('../../../assets/images/Group@2x.png');
      background-position: 0 0;
      background-size: contain;
    }
    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
  }
  .buyTitle {
    text-align: center;
    color: #333333;
    font-size: 18px;
    padding-bottom: 40px;
  }
  .addCart {
    display: inline-block;
    height: 25px;
    width: 25px;
    background: url('../../../ico/cart_icon.svg') no-repeat;
    background-size:contain;
    vertical-align: middle;
    position: relative;
    margin-right: 10px;
  }
  .website-name {
    font-size:18px;
    color:rgba(51,51,51,1);
    line-height:25px;
    text-align: left;
    word-break: break-all;
  }
  .website-url {
    font-size:13px;
    color:rgba(102,102,102,1);
    line-height:18px;
    text-align: left;
    margin-bottom: 10px;
    word-break: break-all;
  }
  .buyContent {
    border-top: 1px solid #CDCDCD;
    // max-height: 286px;
    // overflow-y: auto;
    // overflow-x: hidden;

    .content-container {
      padding-right: 60px;
      width: 100%;
      position: relative;

      & > div {
        border-bottom: 1px solid #CDCDCD;
        padding: 20px 0;
      }

      .inline-block {
        margin-left: 0;
        margin-top: 10px;
        // position: absolute;
        // bottom: 20px;
      }
    }

    .img-container {
      float: left;
      width: 120px;
      height: 120px;
      overflow: hidden;

      img {
        width: 100%;
        position: absolute;
        left: 0;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
      }
    }

    li {
      &:last-child {
        .content-container {
          & > div {
            border-bottom: none;
          }
        }
      }
    }
    .line-des {
      margin-left: 130px;
      position: relative;

      p {
        line-height: 24px;
        word-break: break-all;
        span {
          color: #888888;
        }
        a {
            color: #333333;
          }
      }
      .inline-block {
        margin-left: 0;
        // position: absolute;
        // bottom: -39px;
      }
      .order-price{
        font-size: 18px;
        line-height: 24px;
        color: black;
        margin: 0;
      }

      a.order-price {
        color: #FF4650;
        font-size: 18px;
      }

      del.order-price {
        color: #B0B4BF;
        font-size: 16px;
      }
    }

  }

  .chat-component {
    position: absolute;
    z-index: 999;
    right: 30px;
  }

  .gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);

    filter: grayscale(100%);

    filter: gray;
  }
  .back {
    float: left;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
  }
  @media screen and (max-width: 1024px) {
    .notMobile{
      display: none !important;
    }
    .isMobile {
      z-index: 2;
      display: block !important;
    }
    .order-header {

      li {
        margin-right: 23px !important;
      }
    }
    .order-foot {
      overflow: hidden;
      padding: 20px;
      border-left: 1px solid #D7D7D7;
      border-right: 1px solid #D7D7D7;
      border-bottom: 1px solid #D7D7D7;

      .foot-price {
        float: right;

        a {
          color: #333333;
        }
      }
    }
    .order-detail{
      padding: 20px 15px !important;
      .line-list {
        border-right: none;
        position: relative;
        padding-right: 0 !important;
        .img-container {
          width: 80px;
          height: 80px;
          a {
            width: 80px;
            height: 80px;
            img {
              width: 80px;
              height: 80px;
            }
          }
        }
        .order-state {
          float: none;
          position: absolute;
          right: 0;
          top: 50%;

          div {
            display: inline-block;
          }

          .tabBar {
            .el-icon-arrow-right {
              cursor: pointer;
              vertical-align: middle;
            }
          }
        }
      }
      .order-line {
        .order-des{
            height: auto;
            margin-left: 10px !important;
        }
      }
    }
  }
  @media screen and (max-width: 769px) {
    .order-header {
      padding: 10px !important;
    }
    .order-detail {
      padding:20px 15px !important;

      .line-list {
        border-right: none;
        position: relative;
        padding-right: 0 !important;
        .img-container {
          width: 80px;
          height: 80px;
          a {
            width: 80px;
            height: 80px;
            img {
              width: 80px;
              height: 80px;
            }
          }
          img {
              width: 80px;
              height: 80px;
            }
        }

        .order-state {
          float: none;
          position: absolute;
          right: 0;
          top: 50%;

          div {
            display: inline-block;
          }

          .tabBar {
            .el-icon-arrow-right {
              vertical-align: middle;
            }
          }
        }
      }

      .order-line {

        .order-des {
          height: auto;
          margin-left: 10px !important;

          .name {
            word-break: break-all;
            max-width: 170px;
          }
        }
      }
    }

    .detail-title {
      padding: 10px 0 10px;
      text-align:center;
      font-size:18px;
      color: #333333;
      border-bottom: 1px solid #D7D7D7;
    }

    .detail-body {
      position: relative;
      padding: 15px;
      border-bottom: 1px solid #D7D7D7;
      h2 {
        font-size: 14px;
        color: #333333;
        padding: 10px 0;
      }

      p {
        margin-bottom: 10px;
        color: #888888;
      }

      .popover-price {
        padding: 0 0 10px!important;
      }

      .mobile-order-state {
        display: inline-block;
        position: absolute;
        right: 20px;
        top: 25px;
      }

      .buyContent {
        border-top: none !important;
        .img-container {
          width: 80px;
          height: 80px;
        }
        .line-des {
          margin-left: 98px !important;
          .order-price{
            font-size: 14px !important;

            &.a{
              font-size: 14px !important;
            }

            &.del {
              font-size: 14px !important;
            }
          }
          p {
            margin-bottom: 5px !important;
          }

        }
        .content-container {

          &>div {
            border-bottom: none !important;
          }
        }
      }
    }
  }
  .weeCtCoverBeforeDeal {
        position: relative;
        /*width: 380px;*/
        /*width: 310px;*/
        width: 430px;
        height: 135px;
        .coverMore{
            position: absolute;
            right: 0;
            top: 0;
            width: 50px;
            height: 120px;
            background-image: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,.25), rgba(255,255,255,.75), rgba(255,255,255,.90), white);
            z-index: 1;
        }
        .ctCover{
            height: 120px;
            /*width: 3700px;*/
            display: flex;
            /*flex-wrap: nowrap;*/
            .cover {
                /*display: inline-block;*/
                width: 120px;
                height: 120px;
                margin-right: 10px;
                background-size: contain !important;
                &:last-of-type{
                    margin-right: 25px;
                }
                cursor: pointer;
            }
            /*.gm-scroll-view{*/
            /*    display: flex;*/
            /*}*/
        }
    }
@media screen and (max-width: 1024px) {
  .weeCtCoverBeforeDeal {
    position: relative;
    /*width: 380px;*/
    width: 310px;
    /*width: 430px;*/
    height: 95px;
    .coverMore{
      position: absolute;
      right: 0;
      top: 0;
      width: 50px;
      height: 80px;
      background-image: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,.25), rgba(255,255,255,.75), rgba(255,255,255,.90), white);
      z-index: 1;
    }
    .ctCover{
      height: 80px;
      /*width: 3700px;*/
      display: flex;
      /*flex-wrap: nowrap;*/
      .cover {
        /*display: inline-block;*/
        width: 80px;
        height: 80px;
        margin-right: 10px;
        background-size: contain !important;
        &:last-of-type{
          margin-right: 25px;
        }
        cursor: pointer;
      }
      /*.gm-scroll-view{*/
      /*    display: flex;*/
      /*}*/
    }
  }
}
.spec{
  display: flex;
  word-break: break-all;
  color: #888888;
  line-height: 24px;
  span {
    display: block;
  }
}
.joyorderIcon{
    position: relative;
    top: 2px;
}
.joyorderIcon.taobao{
    font-size:20px;
    top:3px;
}
@font-face {
  font-family: "iconfont"; /* Project id 2668685 */
  /* Color fonts */
  src:
       url('../../../assets/iconfont/iconfont.woff2?t=1626081681400') format('woff2'),
       url('../../../assets/iconfont/iconfont.woff?t=1626081681400') format('woff'),
       url('../../../assets/iconfont/iconfont.ttf?t=1626081681400') format('truetype');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-icon-joyordercopy-document:before {
  content: "\e64a";
}
.el-icon-joyorderxiazai:before {
  content: "\e617";
}

.el-icon-joyordershenfenzhengrenzheng:before {
  content: "\e609";
}

.el-icon-joyorderkefu:before {
  content: "\e606";
}

.el-icon-joyorderweixin:before {
  content: "\e6ea";
}

.el-icon-joyorder26:before {
  content: "\e615";
}
.promo_code{
    border: 1px solid #D9D9D9;
    display: inline-block;
    padding: 0 10px;
    font-size: 13px;
}
.edit_modify_div{
  cursor: pointer;
}
.el-icon-edit-outline.edit_modify{
  margin-right:10px;
}
.flag{
  width:20px;
  height:14px;
  object-fit:contain;
  margin-right: 5px;
}
.el-popover{
  .clearfix:nth-of-type(1){
    margin-top:0 !important;
  }
}

.exception-label{
  color:#ff4650;
  background-color: #fff1f1;
  cursor:pointer;
  position: relative;
  &.tips{
    color:#0f66cf;
    background-color: transparent;
  }
  &.noti{
    color:#1aad19;
    background-color: transparent;
  }
  &.close{
    color:#888888;
    background-color:#f3f3f9;
  }
}
.mail-top{
  position:absolute;
  bottom: 30px;
  right: 50px;
  display: flex;
  align-items: center;
}
.mail-body{
  .mail-link{
    height:30px;
    border-left:1px dashed #D7D7D7;
    border-right:1px dashed #D7D7D7;
  }
  .mail-content{
    border: 1px solid #D7D7D7;
    border-top: none;
  }
  .table-row-title{
    display: flex;
  }
  .table-row-content{
      padding:25px 50px 0 30px;
  }
}
.spec_div{
  align-items:flex-start;
}
.spec_div.end{
  align-items:flex-end;
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/Order.vue